import AuthGate from './firebase/AuthGate';
import { DARK_MODE_CSS } from "./theme/darkModeCss";
import { withoutOccurrenceColors } from "./utils/occurrenceColor";
import { useAuth } from './firebase/auth';
import { registerPush, unregisterPush, isPushConfigured } from './firebase/messaging';
import { registerNativePush, unregisterNativePush, isNativePush } from './capacitor/nativePush';
import { restorePlayBillingPurchases, isPlayBillingAvailable } from './firebase/playBilling';
import { usePremium } from './firebase/billing';
import { bindAndroidBackButton } from './capacitor/backButton';
import { useWidgetSync, useWidgetPendingToggles, useWidgetPendingTaskToggles, useWidgetLaunchActions, parseWidgetAction, PLANNER_OPEN_DATE_FLAG, PLANNER_OPEN_DATE_EVENT } from './capacitor/widgetSync';
import { useWidgetPremium } from './capacitor/useWidgetPremium';
import PremiumGateModal, { warmPremiumPage } from './components/PremiumGateModal';
import { useAlarmSync } from './capacitor/alarmSync';
import { useNotificationSync } from './capacitor/notificationSync';
import { useNextAlarmHint } from './capacitor/nextAlarmHint';
import { syncClarityBars } from './capacitor/clarityBars';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
// ── Phosphor icons loaded via safe wrapper (crash-proof) ─────────────────────
import {
  Sparkle, PaintBrush, Wind as PhWind, BookOpenText, Barbell, Headphones as PhHeadphones,
  Users as PhUsers, Coins as PhCoins, AppleLogo as PhApple, Laptop as PhLaptop,
  House, Tree, Brain as PhBrain, Heart as PhHeart,
  Leaf as PhLeaf, NotePencil, Lightning,
  MusicNote, Basketball, Coffee as PhCoffee, Pill as PhPill,
  Moon as PhMoon, SunHorizon, GraduationCap as PhGrad, Microscope as PhMicroscope,
  Flower, ShootingStar, Drop,
  BowlFood, Bed, Shower, Bicycle, PersonSimpleRun,
  BookBookmark, PencilLine, Guitar, Palette as PhPalette2,
  Dog as PhDog, Cat as PhCat, Baby as PhBaby,
  Smiley, SmileyMeh, SmileySad,
  Sun, CloudSun, Snowflake as PhSnowflake,
  Confetti, Gift as PhGift, Trophy as PhTrophy,
  FirstAidKit, HeartStraight,
  PersonSimpleBike, PersonSimpleSwim, PersonSimpleHike, PersonSimpleSki,
  PersonSimpleWalk, PersonSimpleTaiChi,
  SoccerBall, Football, TennisBall as TennisBall2, Volleyball,
  SwimmingPool, SneakerMove,
  ForkKnife, CookingPot, Orange, Carrot, Bread,
  Stethoscope, Eye, Tooth,
  Backpack, Tent, Mountains, Island,
  Airplane, Car as PhCar, Bus as PhBus,
  Alarm, HourglassHigh, CalendarCheck as PhCalCheck,
  Flag as PhFlag,
  FireSimple, Fire as PhFire, ArrowsClockwise as PhArrowsClockwise,
  Wallet, PiggyBank, ChartLine as PhChartLine, Briefcase as PhBriefcase,
  HandsPraying, Peace, YinYang, Anchor,
  Camera as PhCamera, VideoCamera, FilmStrip, GameController,
  Code as PhCode, Terminal as PhTerminal, Robot as PhRobot,
  ChatTeardrop, Phone as PhPhone, Envelope as PhEnvelope,
  Scissors as PhScissors,
  Plant, TreeEvergreen,
  IceCream, Cookie, BeerStein, Wine as PhWine,
  Bathtub, ToiletPaper, Broom, Hammer as PhHammer,
  SmileyNervous, SmileyWink, SmileyAngry,
  Timer as PhTimer,
  Acorn, AirplaneLanding, AirplaneTakeoff, Aperture, Armchair,
  Atom, Avocado, Balloon, Bandaids, Bank,
  Baseball, Boat, Bone, BowlSteam, BoxingGlove,
  Broadcast, Bug, BugBeetle, Butterfly,
  Cactus, Cake, Calculator, Cards, CassetteTape,
  CastleTurret, Certificate, ChalkboardTeacher, Champagne, ChartBar,
  ChartPie, ChatCircle, ChatDots, Chats, CirclesThree,
  ClipboardText, Cloud as PhCloud, CloudLightning, CloudMoon, CloudRain,
  CloudSnow, Compass, Couch, CreditCard, Crosshair,
  Crown, CurrencyDollar, Desktop, Diamond, DiceFive,
  Dna, Door, Egg, Eraser, Exam,
  EyeSlash, Fish as PhFish, FishSimple, Flask, FlowArrow,
  FrameCorners, Gavel, Globe, Grains, GrainsSlash,
  Hamburger, HandSoap, Handshake,
  Heartbeat, ImageSquare, Infinity, Invoice,
  Joystick, Key, Keyboard, Lamp, Lightbulb as PhLightbulb,
  Lock, MagicWand, MapPinLine,
  Martini, MathOperations, Medal, MegaphoneSimple, Microphone,
  Monitor, MoonStars, Motorcycle, NavigationArrow, Note,
  Notebook, Notepad, Package, PawPrint, Pen,
  PenNib, PenNibStraight, PencilCircle, PersonArmsSpread,
  PersonSimpleSnowboard, PersonSimpleThrow, PianoKeys, Pizza,
  Printer, Pulse, Racquet, Recycle, Rocket,
  Ruler, Sailboat, Scales, Seal, Shapes,
  ShieldPlus, ShoppingCart, Spiral, SpeakerHigh, StarFour,
  StarHalf, Suitcase, Swatches, Sword, Syringe,
  Television, TestTube, Thermometer, Toolbox, Train,
  Trash as PhTrash, TrendDown, TrendUp, UserCircle, UserPlus as PhUserPlus,
  UsersThree, Vault, VinylRecord, Virus, Waves,
  WashingMachine, Wind as PhWind2, Wrench,
  BellSimple,
} from './PhosphorIcons';
import { Layers, Sprout, LayoutGrid, History, CalendarHeart, Timer, ArchiveRestore, X, BarChart2, Paintbrush, Wind, Zap, Headphones, Users, Coins, Apple, Laptop, Home, Trees, Dumbbell, Brain, ClipboardList, Bell, CalendarCheck, CheckSquare, Shield, ShieldCheck, ShieldOff, Save, Edit3, ListTodo, Star, ArrowLeft, Share2, Copy, PinOff, LogOut, FileText, Target, BookMarked, Link, ExternalLink, Upload, Info, Activity, Flame, Gift, Leaf, Music, Pill, Moon, Sunrise, GraduationCap, Microscope, Flower2, Cloud, Snowflake, Dog, Fish, Cat, Baby, Bike, Plane, Sandwich, Coffee, NotebookText, Lightbulb, CircleDot, Rainbow, ShoppingBag, DollarSign, Film, Mail, Mic, Navigation, PenLine, Phone, Car, Bus, Camera, Briefcase, Code, Scissors, Droplets, Footprints, HeartPulse, Sofa, TrendingUp, Utensils, Wand2, Square, HeartCrack } from 'lucide-react';
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { EXTRA_STICKER_PACKS } from "./stickerPacks";
import { COLOR_STICKER_PACKS } from "./colorPacks";
import { createPortal } from "react-dom";
import { Toaster, toast as sonnerToast } from "sonner";
import { useGoogleCalendar } from "./google/useGoogleCalendar";
import { uploadToCloudinary, isCloudinaryConfigured, prettyBytes, compressImage } from "./cloudinary/upload";
import Modal from "./components/Modal";
import { NativePickerInput } from "./components/NativePickerInput";
import { LinkEditor } from "./components/LinkEditor";
import { HabitIconPicker } from "./components/pickers/IconPickers";
import { EmojiPicker } from "./components/pickers/EmojiPicker";
import { cleanHabitForm, repairNoDayHabits } from "./utils/habitFormSave";
import { LocationAutocomplete } from "./components/pickers/LocationAutocomplete";
import { ReminderPicker } from "./components/pickers/ReminderPicker";
import { RichNotesEditor } from "./components/RichNotesEditor";
import { MediaLightbox, AttachmentThumb } from "./components/attachments/AttachmentViewer";
import { AttachmentField } from "./components/attachments/AttachmentField";
import { MCPetalHost } from "./components/HabitCheckbox";
import { CategoriesTab } from "./features/categories/CategoriesTab";
import { StatisticsTab } from "./features/stats/StatisticsTab";
import { FocusTab } from "./features/focus/FocusTab";
import { ProfileTab } from "./features/profile/ProfileTab";
import { HabitsTab } from "./features/habits/HabitsTab";
import { JournalTab } from "./features/journal/JournalTab";
import { renderHabitForm } from "./features/habits/renderHabitForm";
import { WeekBlockPopoverPortal, ItemPanel } from "./features/calendar/CalendarExtras";
import { SettingsPanel } from "./features/settings/SettingsPanel";
import OnboardingFlow from "./onboarding/OnboardingFlow";
import CoachMarkTour, { buildPlannerTourSteps, buildPlannerExtrasTourSteps, CLOCKIN_TOUR_STEPS, CLOCKIN_CHART_TOUR_STEPS, FULLSTOP_TOUR_STEPS, LIMITED_TOUR_STEPS, SPACES_TOUR_STEPS, buildJournalTourSteps } from "./onboarding/CoachMarkTour";
import { isOnboardingDone, markOnboardingDone, isTourDone, markTourDone, isPlannerTourDone, markPlannerTourDone, isPlannerExtrasTourDone, markPlannerExtrasTourDone, isClockInTourDone, markClockInTourDone, isClockInChartTourDone, markClockInChartTourDone, isJournalTourDone, markJournalTourDone, isSpacesTourDone, markSpacesTourDone, isFullStopTourDone, markFullStopTourDone, isLimitedTourDone, markLimitedTourDone, resetOnboardingAndTour } from "./onboarding/onboardingStorage";
import { CalendarTab } from "./features/calendar/CalendarTab";
import RadialTabDial from "./components/RadialTabDial";
import { HABIT_COLORS, PETAL_COLORS, PICKER_PRESETS, DEFAULT_EVENT_COLOR } from "./constants/palettes";
import { DEFAULT_CATEGORIES, PHOSPHOR_TO_LUCIDE, LUCIDE_ICON_MAP, LUCIDE_ICON_CATEGORIES } from "./constants/icons";
import { MOOD_OPTIONS } from "./constants/moodOptions";
import { MONTHS, DAYS_SHORT } from "./constants/dates";
import { load, save, uid } from "./utils/storage";
import { softDeleteCalendarItems } from "./utils/trash";
import { fmt, todayStr, localDateStr } from "./utils/dateHelpers";
import { useInstallPrompt } from "./utils/useInstallPrompt";
import { useInAppBrowser } from "./utils/useInAppBrowser";
import InAppBrowserBanner from "./components/InAppBrowserBanner";
import { suggestEmojiFromName } from "./utils/emojiSuggest";
import {
  onColor, darken, pastelize, vividDark, hexToRgb, rgbToHsl, deepenAccent,
  setActiveBgTheme, setActiveDarkMode, categoryInk, themeToneText, isDarkBgTheme, DARK_BG_THEMES, barColorsFor,
  makeTheme, makeDarkTheme, DEFAULT_PRIMARY, themePrimary, APP_THEME_OPTIONS,
  PASTEL_BG, MASCULINE_BG, PEACH_BG, PURPLE_BG, MOCHA_BG, DUSK_BG, LILAC_BG, VELVET_BG,
  LAGOON_BG, CLOUD_BG, OCEAN_BG, FROST_BG, SAND_BG, MIST_BG, OPAL_BG, BLOOM_BG, TERRA_BG, GLACIER_BG, SHORE_BG, TIDE_BG, AURORA_BG,
} from "./theme/colorEngine";
import { S } from "./theme/sharedStyles";
import { NOTIF_GRACE_MS, NOTIFICATION_SOUND_FILE, ALARM_SOUND_OPTIONS } from "./constants/misc";
import { playAlarmSoundOption, playCustomAlarmSound, stopAlarmSound } from "./utils/alarmSound";
import { collectDueReminders, removeEventCascade, toggleTaskDoneOn } from "./utils/taskLogic";
import { collectDueHabitReminders, clearSpentCountReminders } from "./utils/habitLogic";
import { applyDueGoalChanges, withPendingGoal, goalFormFlags } from "./utils/habitWeeklyGoal";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, horizontalListSortingStrategy, verticalListSortingStrategy, useSortable, arrayMove } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Hands React the exact element it rendered last time — so it skips the whole
// subtree — while inactive, and also on reactivation when no data prop has
// changed. Function props are ignored in that comparison: every one passed to
// the kept tab is a state setter or a wrapper around one, so a fresh closure
// behaves the same as the old one. resetKey forces a fresh element.
const sameDataProps = (a, b) => {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
  for (const k of keys) {
    if (typeof a[k] === "function" && typeof b[k] === "function") continue;
    if (!Object.is(a[k], b[k])) return false;
  }
  return true;
};
function KeptTab({ active, resetKey, render }) {
  const cache = useRef(null);
  const c = cache.current;
  if (!c || c.resetKey !== resetKey) {
    cache.current = { resetKey, el: render() };
  } else if (active) {
    const next = render();
    if (next.key !== c.el.key || !sameDataProps(c.el.props, next.props)) cache.current = { resetKey, el: next };
  }
  return cache.current.el;
}

// Returns the previous children while frozen, so React skips that subtree.
function Freeze({ frozen, children }) {
  const last = useRef(children);
  if (!frozen) last.current = children;
  return last.current;
}

// Wraps one main-nav tab button so it can be long-pressed to reorder. A plain
// tap still switches tabs as normal — drag only activates after the pointer
// stays down past the delay below, which is also the signal to "expand" the
// button (scale it up) so the press-and-hold-to-drag affordance is visible
// before the user actually starts moving it.
// Render-prop, not a wrapping element — the nav buttons are flex items in a
// space-around row that shrinks them to fit (5 tabs at their "natural" width
// would overflow the pill bar). An extra wrapper div in between breaks that:
// the div itself has no explicit width, so its flex-basis is set by the
// button's own fixed width nested inside it, which can't shrink from one
// level down — the row overflowed past its own edge. Handing the sortable
// props to the caller lets the button itself stay the direct flex item.
function SortableTabButton({ id, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    transition: { duration: 220, easing: "cubic-bezier(0.34,1.56,0.64,1)" },
  });
  return children({
    ref: setNodeRef,
    dragProps: attributes,
    dragListeners: listeners,
    isDragging,
    // transition kept separate from dragStyle (below) rather than folded in —
    // dnd-kit's own transition can be undefined/null, and spreading that into
    // a style object still overwrites an earlier `transition` key, silently
    // dropping the button's own color-transition. Callers compose the two.
    dragTransition: transition,
    dragStyle: {
      touchAction: "none",
      transform: CSS.Transform.toString(transform ? { ...transform, scaleX: isDragging ? 1.12 : 1, scaleY: isDragging ? 1.12 : 1 } : transform),
      zIndex: isDragging ? 10 : "auto",
      filter: isDragging ? "drop-shadow(0 8px 18px rgba(0,0,0,0.28))" : "none",
    },
  });
}

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
// MONTHS, DAYS_SHORT, DAYS_FULL live in ./constants/dates (imported above).
// EVENT_COLORS, PRIORITY_COLORS, AUTO_PALETTE, GOAL_COLORS, HABIT_COLORS,
// NOTE_COLORS, NOTE_GRADIENTS live in ./constants/palettes (imported above).

// DEFAULT_CATEGORIES lives in ./constants/icons (imported above).

// Legacy phosphor → lucide mapping for any saved data that still has phosphorIcon
// PHOSPHOR_TO_LUCIDE lives in ./constants/icons (imported above).

// Map Lucide key → component (all keys used in LUCIDE_ICON_CATEGORIES + legacy saved-data keys)
// LUCIDE_ICON_MAP lives in ./constants/icons (imported above).

// Build flat array from lucide map
// CAT_ICON_OPTIONS lives in ./constants/icons (imported above).

// Renders icon for categories — supports phosphorIcon (Phosphor) or lucideIcon (Lucide legacy)
// CategoryIcon lives in ./components/CategoryIcon (imported above).

// ─── PHOSPHOR ICON REGISTRY ──────────────────────────────────────────────────
// Maps icon key strings → Phosphor components (duotone). Used by both pickers.
// PH_ICON_MAP lives in ./constants/icons (imported above).

// Categorized for the picker UI
// PHOSPHOR_ICON_CATEGORIES lives in ./constants/icons (imported above).



// HabitIcon lives in ./components/HabitIcon (imported above).

// PhosphorIconPicker, HabitIconPicker, LucideIconPicker live in ./components/pickers/IconPickers (imported above).

// ─── LUCIDE ICON REGISTRY (for categories) ────────────────────────────────────
// LUCIDE_ICON_CATEGORIES lives in ./constants/icons (imported above).

// FONTS lives in ./constants/fonts (imported above).
// NOTE_COLORS and NOTE_GRADIENTS live in ./constants/palettes (imported above).



// EMOJI_CATEGORIES lives in ./constants/emojiCategories (imported above).

// ─── STORAGE ──────────────────────────────────────────────────────────────────
// load, save and uid live in ./utils/storage (imported above).

// Planner keys a tab picks up straight away when another tab saves them.
const CROSS_TAB_KEYS = new Set([
  "clarity_calEvents", "clarity_tasks", "clarity_calReminders",
  "clarity_taskOccOverrides", "clarity_calEventOccOverrides",
]);

// ─── HELPERS ──────────────────────────────────────────────────────────────────
// fmt, todayStr, localDateStr live in ./utils/dateHelpers (imported above).

// ─── HABIT ENGINE ─────────────────────────────────────────────────────────────
// limitedOffDays, habitYearlyDueDate, isHabitCountedYearly, isHabitHiddenFromDaily,
// isHabitPaused, isHabitDueToday, isHabitDueOn, isHabitDoneOn, getStreak, isHabitDueOnKey,
// getPeriodStart, getPeriodBounds, fmtPeriodLabel, isHabitWobbledOn, getBoundaryStats,
// getPeriodScore, getConsistencyScore, getMonthlyBreakdown live in ./utils/habitLogic (imported above).

// isOccurringOn, isTaskOccurringOn, collectDueReminders, addDaysToDateStr, dateTimeToDate live in ./utils/taskLogic (imported above).

// isTaskDueToday was dead code (zero usages anywhere in src) — deleted rather than extracted.


// ─── SHARED STYLES ────────────────────────────────────────────────────────────
// Shared inline-style constants (S) live in ./theme/sharedStyles (imported above).

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────
// Card lives in ./components/Card (imported above).

// ─── HABIT CHECKBOX ───────────────────────────────────────────────────────────
// Animated checkbox: springy bounce + SVG checkmark draw + petal burst via portal
// PETAL_COLORS lives in ./constants/palettes (imported above).

// PetalPortal, HabitCheckbox, MultiCountButton, fireMCPetal, MCPetalHost live in ./components/HabitCheckbox.jsx (imported above).

// ─── HABIT KEYWORD → EMOJI MAP (offline auto-suggest) ────────────────────────
// HABIT_KEYWORD_MAP, EMOJI_PRIORITY, RESTRICTION_TRIGGERS, RESTRICTION_MAP, suggestEmojiFromName live in ./utils/emojiSuggest (imported above).

// ─── EMOJI PICKER ─────────────────────────────────────────────────────────────
// ─── TWEMOJI RENDERER ─────────────────────────────────────────────────────────
// Renders emojis as Twemoji images (consistent across all platforms/OS)
// emojiToCodePoint + TwemojiImg live in ./components/TwemojiImg (imported above).

// EmojiPicker lives in ./components/pickers/EmojiPicker (imported above).

// ─── BAR CHART ────────────────────────────────────────────────────────────────
// BarChart lives in ./components/BarChart (imported above).

// FocusStackedBarChart, FocusBulletChart, FocusPieChart live in ./components/charts/FocusCharts (imported above).


// FocusDayTimeline was dead code (zero usages anywhere in src) — deleted rather than extracted.


// Time-Restricted habit type was removed — existing habits saved with it become
// plain "Full Stop" restricted habits (their time-window fields are simply unused).
// Normalisation applied to habits every time they're loaded or arrive from a
// remote sync — both the old habitType rename and, since counted habits could
// carry reminders, emptying any whose armed day has passed. That sweep has to
// happen here rather than when the reminder fires: nothing of ours is running
// at that point, and the native alarm path can't write back to habit data.
// Also repairs habits saved on "Weekly" etc. with no days picked (due on no day,
// so invisible on Today) back to Daily — see repairNoDayHabits.
const migrateTimeRestricted = (arr) => applyDueGoalChanges(clearSpentCountReminders(repairNoDayHabits(
  arr.map(h => h.habitType === "timerestricted" ? { ...h, habitType: "nottodo" } : h)
)));

// ─── MAIN APP ─────────────────────────────────────────────────────────────────

// Theme / primary colour engine (hexToRgb, mix, tone helpers, ACTIVE_BG_THEME,
// makeTheme, APP_THEME_OPTIONS, BG gradients, etc.) lives in ./theme/colorEngine (imported above).

// Static half of App's global stylesheet — every theme's CSS class rules,
// resets, animations, etc. None of this depends on the active theme/accent,
// so it's hoisted to a module-level constant computed once instead of living
// inline in ClarityApp's JSX. Previously this ~1200-line block and the small
// dynamic :root{} block below it were ONE template literal recomputed on
// every render; React only touches the DOM when the resulting string value
// actually changes, which happens on every theme/accent switch (the :root
// vars change) — but that meant the browser had to reparse and recompute
// style for this entire stylesheet, not just the handful of custom
// properties that actually changed. Confirmed on device (Tecno KM7k) via
// Logcat: switching themes logged "Choreographer: Skipped 31 frames!" and
// an HWUI "Davey!" jank warning (~867ms), right at the tap. Splitting the
// static rules out means a theme switch now only touches the small :root{}
// style tag below — the browser never needs to re-touch this block.
// Wallpaper height for the gradient and mesh backgrounds (see the
// .*-main::before and div.clarity-main rules in STATIC_APP_CSS): the height
// the whole gradient is drawn over, so every colour of it is on screen.
// - Desktop (mouse): the window's own height, following resizes (no
//   on-screen keyboard there). It used to be the screen's LONG side, which
//   on a landscape monitor is its width (1920px for a ~900px window), so
//   only the top half of the gradient ever showed (Jade, 2026-10-22, Velvet).
// - Touch: the tallest window height seen in the current orientation, so the
//   keyboard shrinking the window never changes it (a custom property on the
//   root re-styles the whole app, so it must not change on every keyboard step).
const wpTallest = { p: 0, l: 0 };
let wpFrame = 0;
function setWallpaperHeight() {
  if (typeof window === "undefined") return;
  const ih = Math.round(window.innerHeight || 0);
  if (!ih) return;
  let h = ih;
  const touch = !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
  if (touch) {
    const key = (window.screen?.width || 0) > (window.screen?.height || 0) ? "l" : "p";
    wpTallest[key] = Math.max(wpTallest[key], ih);
    h = wpTallest[key];
  }
  const root = document.documentElement;
  if (root.style.getPropertyValue("--wp-h") !== `${h}px`) root.style.setProperty("--wp-h", `${h}px`);
}
function queueWallpaperHeight() {
  if (wpFrame) return;
  wpFrame = requestAnimationFrame(() => { wpFrame = 0; setWallpaperHeight(); });
}
setWallpaperHeight();
if (typeof window !== "undefined") { window.addEventListener("orientationchange", queueWallpaperHeight); window.addEventListener("resize", queueWallpaperHeight); }

// See-through habit cards on gradient backgrounds (Jade, 2026-10-22, after a
// research round: Material 3 tonal surfaces, Apple / Fluent glass). No blur:
// backdrop-filter on many cards in a scrolling list lags Android (the nav
// bar's blur already had to be paused during animations). Light gradients get
// a white wash + a white edge; dark ones (the colorEngine DARK_BG_THEMES) a
// wash of their own deepest colour with light text, at an opacity that keeps
// white text readable even over their lightest (bottom) colour. Default and
// dark mode never get a theme class, so they keep the solid card.
// .hb-card is doubled in the selectors to outrank each background's own
// '.xxx-main .habits-main-col .clarity-row-item' card rule (custom view rows).
const GLASS_LIGHT_THEMES = ["pastel", "masculine", "peach", "mocha", "aurora", "lilac", "lagoon", "cloud", "frost", "sand", "mist", "opal", "bloom", "terra", "shore"];
const GLASS_DARK_THEMES = { velvet: "20,14,28", dusk: "25,29,35", purple: "35,25,66", ocean: "2,16,36", glacier: "21,32,38", tide: "1,49,55" };
// The edge is an outline drawn just inside the card, not a border (Jade,
// 2026-10-23): on her Chrome a 1px border round the see-through fill showed
// as a doubled line along the top. An outline sits on top of the card, so
// there is no border / background seam to show.
const GLASS_LIGHT = "background: linear-gradient(var(--hb-tint, transparent), var(--hb-tint, transparent)), rgba(255,255,255,0.55) !important; border: none !important; outline: 1px solid var(--glass-line) !important; outline-offset: -1px; box-shadow: none !important;";
const glassDark = (rgb) => `background: linear-gradient(var(--hb-tint, transparent), var(--hb-tint, transparent)), rgba(${rgb},0.6) !important; border: none !important; outline: 1px solid var(--glass-line) !important; outline-offset: -1px; box-shadow: none !important;`;
const DARK_GLASS_TEXT = "--c-text: #ffffff; --c-text-mid: rgba(255,255,255,0.86); --c-text-soft: rgba(255,255,255,0.7); --c-text-accent: #ffffff;";
// What gets the see-through card: habit cards (.hb-card) and the Habit Stats
// page's cards (.hs-glass inside .hs-page). Classes doubled to outrank each
// background's own card rules.
// Fixed text colours on the Habit Stats page (Habits History rows) that are
// unreadable on the dark see-through cards, as the browser serialises them.
const HS_DARK_INKS = [
  ["rgb(90, 48, 80)", "var(--c-text)"],     // #5a3050 habit name
  ["rgb(46, 125, 64)", "#8fe0a0"],          // #2e7d40 done habit name
  ["rgb(59, 109, 17)", "#9be27a"],          // #3B6D11 "clean"
  ["rgb(163, 45, 45)", "#ff9a9a"],          // #A32D2D "slipped"
  ["rgb(160, 112, 144)", "var(--c-text-soft)"], // #a07090 goal pill
];
const GLASS_TARGETS = [".hb-card.hb-card", ".hs-page .hs-glass.hs-glass", ".hb-head-btn.hb-head-btn", ".list-glass.list-glass"];
const ALL_GLASS_THEMES = [...GLASS_LIGHT_THEMES, ...Object.keys(GLASS_DARK_THEMES)];
const sel = (themes, tail) => themes.map(t => `.${t}-main ${tail}`).join(", ");
// Light backgrounds whose accent text is too pale to read on a see-through card
// (under 3:1 on white: Mist 1.7, Terra 2.1, Frost / Shore 2.3, Sand 2.6). Inside
// the cards their accent text is the same hue, darkened to about 4:1 or more.
const PALE_ACCENT_INK = { mist: "#4f7c86", terra: "#8a6a4c", frost: "#8f5f61", shore: "#4f7471", sand: "#7a6152" };
// Card edges and the lines inside them (Jade, 2026-10-23): the accent as a
// light pastel on light gradients (darker than the white wash), and a lighter
// shade of it on dark ones so it shows against the deep card.
const GLASS_CARD_CSS = `
  ${GLASS_LIGHT_THEMES.map(t => `.${t}-main`).join(", ")} { --glass-line: color-mix(in srgb, var(--c-primary) 40%, #fff); }
  ${Object.keys(GLASS_DARK_THEMES).map(t => `.${t}-main`).join(", ")} { --glass-line: color-mix(in srgb, var(--c-primary) 50%, #fff); }
  ${GLASS_LIGHT_THEMES.flatMap(t => GLASS_TARGETS.map(g => `.${t}-main ${g}`)).join(", ")} { ${GLASS_LIGHT} }
  ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `${GLASS_TARGETS.map(g => `.${t}-main ${g}`).join(", ")} { ${glassDark(rgb)} ${DARK_GLASS_TEXT} }`).join("\n")}
  /* The rows inside a habit card: each background's own row rules paint them
     white, which would cover the see-through card. Only the done tint stays. */
  ${sel(ALL_GLASS_THEMES, ".hb-card .clarity-row-item")} {
    background: var(--hb-tint, transparent) !important;
    box-shadow: none !important;
  }
  /* A unit habit's "+ 4.5k/10k" button: no white fill on the see-through card
     (Jade, 2026-10-23); its coloured edge and text stay. */
  ${sel(ALL_GLASS_THEMES, ".hb-card .hb-amount-btn")} { background: transparent !important; }
  /* On dark backgrounds its colour is lifted toward white so the edge and the
     numbers read clearly (Jade, same day: they looked dull). */
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hb-amount-btn")}, html[data-dark] .hb-amount-btn { --amt-c: color-mix(in srgb, var(--amt-c-base) 62%, #fff); }
  /* A counted habit's "1/3" label: lighter on dark backgrounds, a bright green
     once the target is hit (Jade, 2026-10-26: hard to see on dark). */
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hb-count-label")}, html[data-dark] .hb-count-label { color: color-mix(in srgb, var(--cnt-c-base) 55%, #fff) !important; }
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hb-count-label.is-hit")}, html[data-dark] .hb-count-label.is-hit { color: #86DC74 !important; }
  /* Its "clear from today's list" button (the circle with a line) gets the same bright green. */
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hb-count-dismiss")}, html[data-dark] .hb-count-dismiss { color: #86DC74 !important; }
  ${sel(Object.keys(GLASS_DARK_THEMES), ".habit-cb")}, html[data-dark] .habit-cb { --cb-c: color-mix(in srgb, var(--cb-c-base) 62%, #fff); }
  /* The line between habits. Each background's own row rule sets "border: none",
     so it is drawn here; the first row of a group has "border-top: none" inline. */
  ${sel(ALL_GLASS_THEMES, '.hb-card .clarity-row-item:not([style*="border-top: none"])')} {
    border-top: 1px solid var(--glass-line) !important;
  }
  /* Habit Stats: the big outer "Habit Tracker" box goes (no glass on glass);
     its cards sit straight on the background. Anything inside the page that
     paints the card colour becomes clear, and the soft fill (alternate table
     rows, empty progress bars) a faint wash. The tab switcher's picked pill
     stays solid enough to read as picked. */
  ${sel(ALL_GLASS_THEMES, ".hs-page .graph-section-frost")} {
    background: transparent !important; border: none !important; box-shadow: none !important; padding: 0 !important;
  }
  ${sel(GLASS_LIGHT_THEMES, ".hs-page")} { --c-bg-card: transparent; --c-bg-soft: rgba(255,255,255,0.32); }
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .hs-seg")} { --c-bg-card: rgba(255,255,255,0.9); }
  /* The "HABIT TRACKER" title sits on the background itself now (its box is
     gone), so it takes the page ink, like the habit group labels (Jade,
     2026-10-23: it was the soft pink and vanished on Lilac). Its nav, on the
     right of the same row, sits on the background too. */
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .graph-section-frost .clarity-card-title")} { color: #2a2030 !important; }
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .hs-nav")} { --c-text-mid: #2a2030; }
  /* Tracker cards on light gradients: soft pastel (Jade, 2026-10-23, after
     a see-through white with white bands). A solid light shade of the accent,
     no edge, a soft accent glow; the band one shade deeper. Their empty
     squares are drawn after the grey ones below. */
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .habit-track-card.hs-glass.hs-glass")}, ${sel(GLASS_LIGHT_THEMES, ".hs-page .clarity-habit-month-card.hs-glass.hs-glass")} {
    background: color-mix(in srgb, var(--c-primary) 9%, #fff) !important;
    border: none !important; outline: none !important;
    box-shadow: 0 10px 28px color-mix(in srgb, var(--c-primary) 20%, transparent) !important;
  }
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .habit-track-card > div:first-child")}, ${sel(GLASS_LIGHT_THEMES, ".hs-page .hm-header")} {
    background: color-mix(in srgb, var(--c-primary) 14%, #fff) !important;
  }
  /* Habits header buttons (sort, manage, Habit Stats) get the cards' look; the
     sort button's open state keeps its accent ring. */
  ${sel(ALL_GLASS_THEMES, '.hb-head-btn.hb-head-btn[style*="solid var(--c-primary)"]')} { outline-color: var(--c-primary) !important; }
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hs-page .graph-section-frost .clarity-card-title")} { color: #ffffff !important; }
  /* Empty tracker squares on light gradients (Jade, same day: barely visible):
     a grey that reads on any light wash. Missed is the darker one, not-due /
     still-to-come the lighter one. Same colour lists as darkModeCss. */
  ${["221, 216, 234", "200, 192, 208", "232, 224, 240"].map(c => sel(GLASS_LIGHT_THEMES, `.hs-page [style*="background: rgb(${c})"]`)).join(", ")} { background: rgba(90,80,110,0.26) !important; }
  ${["232, 228, 240", "234, 230, 238", "221, 216, 228"].map(c => sel(GLASS_LIGHT_THEMES, `.hs-page [style*="background: rgb(${c})"]`)).join(", ")},
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .trk-future")} { background: rgba(90,80,110,0.13) !important; opacity: 1 !important; }
  /* Empty squares on the soft pastel tracker cards: shades of the accent
     instead of grey (missed deeper, not-due / still-to-come lighter). */
  ${["221, 216, 234", "200, 192, 208", "232, 224, 240"].flatMap(c => [".habit-track-card", ".clarity-habit-month-card"].map(k => sel(GLASS_LIGHT_THEMES, `.hs-page ${k} [style*="background: rgb(${c})"]`))).join(", ")} { background: color-mix(in srgb, var(--c-primary) 26%, #fff) !important; }
  ${["232, 228, 240", "234, 230, 238", "221, 216, 228"].flatMap(c => [".habit-track-card", ".clarity-habit-month-card"].map(k => sel(GLASS_LIGHT_THEMES, `.hs-page ${k} [style*="background: rgb(${c})"]`))).join(", ")},
  ${sel(GLASS_LIGHT_THEMES, ".hs-page .habit-track-card .trk-future")}, ${sel(GLASS_LIGHT_THEMES, ".hs-page .clarity-habit-month-card .trk-future")} { background: color-mix(in srgb, var(--c-primary) 16%, #fff) !important; opacity: 1 !important; }
  /* Desktop Categories cards on dark gradients (Jade, 2026-10-23): the habit
     cards' see-through look instead of a white card. The header wash and body
     read --c-bg-card, so it is clear inside. */
  /* Their header band: the To Do / Habit Tracker columns' frosted glass
     (same wash and blur, Jade, same day). So the band sees the page itself,
     the dark see-through fill moves from the card to the part under it. */
  ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .cat-desk-glass.cat-desk-glass.cat-desk-glass { background: transparent !important; } .${t}-main .cat-desk-glass .cat-desk-body { background: rgba(${rgb},0.6); flex: 1; }`).join("\n")}
  /* The name sits in a field like the light backgrounds' white one, in the
     colour of the card's lower part (Jade, same day). */
  ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .cat-desk-glass .cat-desk-pill { background: rgba(${rgb},0.6) !important; padding: 6px 14px 6px 6px !important; }`).join("\n")}
  /* No backdrop blur (Jade, 2026-10-23): it picked up what sat behind the
     band's right edge (the column's scrollbar, shown on hover) and drew it as
     a light strip. The band sits on the plain page gradient, which a blur
     leaves the same anyway. */
  ${sel(Object.keys(GLASS_DARK_THEMES), ".cat-desk-glass .cat-desk-band")} {
    background: rgba(255,255,255,0.32) !important;
  }
  /* Desktop side columns are dimmed (saturate filter, full colour on hover).
     On dark gradients that made the tracker colours dull next to the phone,
     so it is off there, as in dark mode (Jade, same day). */
  ${sel(Object.keys(GLASS_DARK_THEMES), ".habits-cat-col > div")}, ${sel(Object.keys(GLASS_DARK_THEMES), ".habits-graph-col > div")} { filter: none !important; }
  /* Habit Stats on a laptop, dark gradients (Jade, 2026-10-23: the blocks and
     bars looked dull next to the phone). There the cards sit on the column's
     light frosted glass instead of the dark page, which turned their 0.6 fill
     a muddy mid-tone. A deeper fill, and the colours themselves lifted. */
  @media (min-width: 1024px) {
    ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .habits-graph-col .hs-page .hs-glass.hs-glass.hs-glass { background: rgba(${rgb},0.86) !important; }`).join("\n    ")}
    /* The To Do column's habit cards sit on that column's light frosted glass
       too, so the 0.6 fill reads lighter there than on the "More categories"
       rows, which sit on the page (Jade, same day: should look the same).
       0.72 makes them match (measured against those rows on all six dark backgrounds). */
    ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .habits-main-col .hb-card.hb-card { background: linear-gradient(var(--hb-tint, transparent), var(--hb-tint, transparent)), rgba(${rgb},0.72) !important; }`).join("\n    ")}
    ${sel(Object.keys(GLASS_DARK_THEMES), ".habits-graph-col .hs-page .habit-track-card > div:not(:first-child)")},
    ${sel(Object.keys(GLASS_DARK_THEMES), ".habits-graph-col .hs-page .hm-grid")},
    ${sel(Object.keys(GLASS_DARK_THEMES), ".habits-graph-col .hs-page .hs-fill")} { filter: saturate(1.35) brightness(1.1); }
  }
  ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .cat-desk-glass.cat-desk-glass { ${glassDark(rgb)} ${DARK_GLASS_TEXT} --c-bg-card: transparent; }`).join("\n")}
  ${Object.entries(GLASS_DARK_THEMES).map(([t, rgb]) => `.${t}-main .cat-suggest-glass.cat-suggest-glass { ${glassDark(rgb)} ${DARK_GLASS_TEXT} }`).join("\n")}
  ${Object.entries(PALE_ACCENT_INK).map(([t, ink]) => `.${t}-main .hs-page, .${t}-main .hb-card { --c-text-accent: ${ink}; }`).join("\n")}
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hs-page")} {
    --c-bg-card: transparent; --c-bg-soft: rgba(255,255,255,0.08); --c-bg-active: rgba(255,255,255,0.14);
    --c-border: rgba(255,255,255,0.18); ${DARK_GLASS_TEXT}
  }
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hs-page .hs-seg")} { --c-bg-card: rgba(255,255,255,0.2); }
  /* Lines inside the Habit Stats cards: the tracker cards' header lines, and
     the pale pink dividers written as fixed colours in the tables / History
     rows (#f5eaf0, #f0dcea, #f5dcea, #c8f0d0, #e0d4e8, as the browser
     serialises them). */
  ${sel(ALL_GLASS_THEMES, ".hs-page .habit-track-card > div:first-child")}, ${sel(ALL_GLASS_THEMES, ".hs-page .hm-header")} { border-bottom-color: var(--glass-line) !important; }
  ${["245, 234, 240", "240, 220, 234", "245, 220, 234", "200, 240, 208", "224, 212, 232"].map(c => sel(GLASS_LIGHT_THEMES, `.hs-page [style*="rgb(${c})"]`)).join(",\n  ")} { border-color: var(--glass-line) !important; }
  /* On dark gradients those table / History lines stay the faint white they
     were before (Jade, 2026-10-23: the accent lines were too strong there). */
  ${["245, 234, 240", "240, 220, 234", "245, 220, 234", "200, 240, 208", "224, 212, 232"].map(c => sel(Object.keys(GLASS_DARK_THEMES), `.hs-page [style*="rgb(${c})"]`)).join(",\n  ")} { border-color: rgba(255,255,255,0.14) !important; }
  ${HS_DARK_INKS.map(([from, to]) => `${sel(Object.keys(GLASS_DARK_THEMES), `.hs-page [style^="color: ${from}"]`)}, ${sel(Object.keys(GLASS_DARK_THEMES), `.hs-page [style*="; color: ${from}"]`)} { color: ${to} !important; }`).join("\n")}
  ${sel(Object.keys(GLASS_DARK_THEMES), '.hs-page [style*="background: rgb(240, 232, 240)"]')} { background: rgba(255,255,255,0.12) !important; }
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hs-page .clarity-habit-month-card .hm-name")} { color: var(--c-text) !important; }
  /* Tracker squares (same colour lists as darkModeCss): missed ones were pale
     lavender, brighter than the done ones on a dark card. */
  ${["221, 216, 234", "200, 192, 208", "232, 224, 240"].map(c => sel(Object.keys(GLASS_DARK_THEMES), `.hs-page [style*="background: rgb(${c})"]`)).join(", ")} { background: rgba(255,255,255,0.22) !important; }
  ${["232, 228, 240", "234, 230, 238", "221, 216, 228"].map(c => sel(Object.keys(GLASS_DARK_THEMES), `.hs-page [style*="background: rgb(${c})"]`)).join(", ")},
  ${sel(Object.keys(GLASS_DARK_THEMES), ".hs-page .trk-future")} { background: rgba(255,255,255,0.08) !important; opacity: 1 !important; }
`;
const STATIC_APP_CSS = `
  /* Add / edit panels: no scrollbar (Jade, 2026-10-17). Every panel opened
     through Modal scrolls inside .clarity-modal-body or its panel; the global
     4px scrollbar rule needs !important to lose. */
  .clarity-modal-body, .clarity-modal-body > div { scrollbar-width: none !important; }
  .clarity-modal-body::-webkit-scrollbar, .clarity-modal-body > div::-webkit-scrollbar {
    width: 0 !important; height: 0 !important; display: none !important;
  }
        /* ── Toast variants ───────────────────────────────────────────────
           Error/warning toasts opt out of the default mint-green skin (see the
           Toaster above). !important is required: sonner applies toastOptions
           .style as an inline style, which normal class rules lose to. */
        .clarity-toast-error {
          background: #fdeceb !important;
          border-color: #e39a95 !important;
          color: #8a3b34 !important;
        }
        .clarity-toast-warning {
          background: #fff6e5 !important;
          border-color: #e6bd73 !important;
          color: #7a5417 !important;
        }
        /* ── Perf: tame "transition: all" ──────────────────────────────────
           Many buttons/cards across every tab use "transition: all", which makes
           the browser watch layout-affecting properties. On each click React
           re-applies inline styles, and "all" turned that into a full layout
           recalc across the tree — a desktop-wide delay before panels/buttons
           responded (~17ms of Layout per click, measured). Restrict transitions
           to cheap, non-layout properties globally. Nothing in the app
           intentionally animates width/height/position (drawers use transform,
           which stays covered), so this only removes the wasted layout work. */
        *, *::before, *::after {
          transition-property: background-color, color, border-color, box-shadow, transform, opacity, fill, stroke, backdrop-filter !important;
        }

        /* ── Extra fonts ──────────────────────────────────────────── */
        /* Quicksand loaded via index.html */

        /* ── Reset ────────────────────────────────────────────────── */
        * { box-sizing: border-box; }
        html { font-size: 15px; }
        html, body { max-width: 100vw; }

        /* ── Kill Chrome/Safari mobile blue tap flash ─────────────── */
        * { -webkit-tap-highlight-color: transparent !important; -webkit-touch-callout: none; }
        input, textarea, select { -webkit-tap-highlight-color: transparent !important; }

        /* ── Scrollbar ────────────────────────────────────────────── */
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: var(--c-scroll-thumb); border-radius: 4px; }
        /* Week grid: hide the scrollbar so the body columns stay full-width and
           line up with the (non-scrolling) day header. */
        .wk-grid-scroll { scrollbar-width: none; -ms-overflow-style: none; }
        .wk-grid-scroll::-webkit-scrollbar { width: 0; height: 0; display: none; }
        /* List panel: show a visible scrollbar */
        .list-panel-scroll::-webkit-scrollbar { width: 5px; }
        .list-panel-scroll::-webkit-scrollbar-track { background: transparent; border-radius: 4px; }
        .list-panel-scroll::-webkit-scrollbar-thumb { background: rgba(180,120,160,0.45); border-radius: 4px; }
        .list-panel-scroll::-webkit-scrollbar-thumb:hover { background: rgba(180,120,160,0.7); }

        /* ── Read-only rendered notes (RichNotesEditor output shown outside the
           editor itself — detail popups, list rows, etc.) ────────────────────
           RichNotesEditor's own [contenteditable] scope gives numbered/bullet
           lists 26px of left padding so markers clear the editor's border; that
           rule doesn't reach these read-only containers, so their markers sat
           flush against the box edge instead of matching the checkbox rows'
           indent. */
        .clarity-notes-view ol, .clarity-notes-view ul { padding-left: 26px; margin: 4px 0; }

        /* ── Buttons — smooth spring press ───────────────────────── */
        button {
          -webkit-tap-highlight-color: transparent !important;
          outline: none !important;
          min-height: 36px;
          min-width: 36px;
          transition: transform 0.14s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.14s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
        }
        button:focus { outline: none !important; }
        button:focus-visible { box-shadow: 0 0 0 3px rgba(212,120,154,0.4) !important; }
        button:active { transform: scale(0.93) !important; }

        /* ── Nav buttons ──────────────────────────────────────────── */
        .nav-btn { transition: all 0.2s cubic-bezier(0.34,1.56,0.64,1) !important; position: relative; overflow: visible; }
        .nav-btn::after { content: ''; position: absolute; inset: 0; border-radius: inherit; background: radial-gradient(circle at center, var(--c-bg-active) 0%, transparent 70%); opacity: 0; transform: scale(0.6); transition: opacity 0.25s ease, transform 0.25s ease; pointer-events: none; }
        .nav-btn:active::after { opacity: 1; transform: scale(1); }
        /* Scoped to real pointer devices only — on touchscreens, :hover has no "mouse leave"
           to clear it after a tap, so it was sticking as a lighter background filling the
           button's full hit area around the smaller, darker active pill (reading as a stray
           light ring/border around the selected mobile tab).
           EVERY :hover rule in this sheet is scoped the same way (Jade, 2026-10-22). A quick tap
           on a phone puts :hover on the tapped button's whole ancestor chain about 150ms after
           the tap, i.e. mid-way through a bottom sheet's slide-up, so the gradient backgrounds'
           card hover shadow (0.2s box-shadow transition on a big card) repainted every frame of
           the slide: "laggy if I tap quickly, smooth if I hold a second" (Clock-In's Add past
           session + Select sheets). A held press sets :hover before the release, so it was done
           by the time the sheet opened. A new :hover rule must go inside such a block too. */
        @media (hover: hover) and (pointer: fine) {
          .nav-btn:hover { background: var(--c-bg-active) !important; }
        }
        .nav-btn.active { transform: scale(1.0); }

        /* ── Primary (gradient) buttons — lift on hover ─────── */
        @media (hover: hover) and (pointer: fine) {
          .clarity-add-btn:hover { transform: translateY(-1px) scale(1.02) !important; box-shadow: 0 6px 20px var(--c-shadow-btn) !important; }
        }

        /* ── Clock-In check button + done pill ───────────────────── */
        .clarity-check-btn { position: relative; transition: transform 0.18s cubic-bezier(.2,.8,.2,1), box-shadow 0.18s ease; box-shadow: 0 8px 24px var(--c-shadow-btn); }
        @media (hover: hover) and (pointer: fine) {
          .clarity-check-btn:hover { transform: scale(1.05); box-shadow: 0 10px 30px var(--c-shadow-btn); }
        }
        .clarity-check-btn:active { transform: scale(0.9); box-shadow: 0 5px 16px var(--c-shadow-btn); }
        .clarity-check-btn svg { filter: drop-shadow(0 1px 2px rgba(0,0,0,0.15)); }
        .clarity-done-pill { position: relative; animation: clarityDonePop 0.5s cubic-bezier(.18,1.5,.4,1); will-change: transform, opacity; transition: transform 0.15s ease; overflow: visible; }
        @media (hover: hover) and (pointer: fine) {
          .clarity-done-pill:hover { transform: translateY(-1px) scale(1.03); }
        }
        .clarity-done-pill:active { transform: scale(0.96); }
        .clarity-done-pill::after { /* completion burst ring */ content: ''; position: absolute; inset: 0; border-radius: inherit; border: 2.5px solid var(--c-primary-deep); animation: clarityBurst 0.7s ease-out forwards; pointer-events: none; }
        .clarity-done-pill.sheet-enter-wait::after { animation-play-state: paused !important; }
        @keyframes clarityDonePop { 0% { transform: scale(0.4); opacity: 0; } 55% { transform: scale(1.14); opacity: 1; } 100% { transform: scale(1); } }
        @keyframes clarityBurst { 0% { transform: scale(1); opacity: 0.8; } 100% { transform: scale(1.5); opacity: 0; } }

        /* ── Input / textarea focus glow ─────────────────────────── */
        input:focus, textarea:focus, select:focus {
          outline: none !important;
          border-color: var(--c-primary) !important;
          box-shadow: 0 0 0 3px var(--c-shadow) !important;
          transition: border-color 0.18s ease, box-shadow 0.18s ease;
        }

        /* ── Date/time picker indicator — replaced with our own icon ─
           Every native date/time input's dropdown chevron sat flush against
           the field's right border. Two prior attempts (margin on the
           ::-webkit-calendar-picker-indicator pseudo-element, then
           padding-right on the input itself) both had zero visible effect
           on the actual Android device — that pseudo-element apparently
           doesn't honor box-model CSS at all on this WebView, so no CSS
           tweak aimed at it can be trusted to work.
           Instead: make the native indicator fully invisible AND stretch
           its tappable hit-region across the whole field (nicer on mobile
           besides — tap anywhere, not just a tiny icon), then let
           NativePickerInput (src/components/NativePickerInput.jsx) draw a
           real React icon on top with real, guaranteed spacing — a normal
           DOM element isn't subject to any of this pseudo-element's platform
           quirks. Every date/time field in the app should go through that
           wrapper rather than a bare <input type="date"/"time">. */
        input[type="date"]::-webkit-calendar-picker-indicator,
        input[type="time"]::-webkit-calendar-picker-indicator {
          opacity: 0;
          position: absolute; inset: 0; margin: 0; padding: 0;
        }
        /* Android WebView doesn't draw that pseudo-element at all — its arrow
           comes from the input's native dropdown appearance, so hiding the
           pseudo left it showing next to ours (a doubled arrow). Dropping the
           native appearance removes it; the picker still opens on tap. */
        input[type="date"],
        input[type="time"] {
          -webkit-appearance: none;
          appearance: none;
        }
        /* Without native appearance an empty date/time field can collapse to
           zero content height and centre its value (iOS); pin both. */
        input[type="date"]::-webkit-date-and-time-value,
        input[type="time"]::-webkit-date-and-time-value {
          min-height: 1.3em;
          text-align: left;
        }

        /* ── Card entrance ────────────────────────────────────────── */
        @keyframes cardIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes tapBounce { 0%{transform:scale(1)} 30%{transform:scale(0.93)} 70%{transform:scale(1.04)} 100%{transform:scale(1)} }
        @keyframes catPanelIn { from { opacity:0; transform:scale(0.88) translateY(12px); } to { opacity:1; transform:scale(1) translateY(0); } }
        @keyframes catDoneToastIn { 0% { opacity:0; transform:translate(-50%, 14px) scale(0.9); } 15% { opacity:1; transform:translate(-50%, 0) scale(1); } 80% { opacity:1; transform:translate(-50%, 0) scale(1); } 100% { opacity:0; transform:translate(-50%, -10px) scale(0.96); } }
        @keyframes catBadgePop { 0% { opacity:0; transform:scale(0.4); } 60% { opacity:1; transform:scale(1.15); } 100% { opacity:1; transform:scale(1); } }
        .cat-scroll::-webkit-scrollbar { display: none; }
        .clarity-card { animation: cardIn 0.32s cubic-bezier(0.22,1,0.36,1) both; }

        /* ── Tab content transition ──────────────────────────────────
           This div is keyed by tab (see its render below), so it remounts
           on every switch. A plain instant key-swap read as a hard "blink";
           a fade in/out cross-fade (an earlier version of this comment)
           fixed the blink but introduced its own problem — an opacity-0
           start means nothing is visible for the first stretch of the
           animation, which reads as a delay before the new tab's UI shows
           up, most noticeable on Planner (the heaviest tab to mount).
           This version never touches opacity — content is fully visible
           from frame 0. The scale(0.98->1) that used to be here (an earlier
           version of this comment) made the WHOLE container visibly grow —
           every header pill/button popping up in size together read as an
           "expanding" UI rather than a transition, on top of whichever
           per-card animation (.clarity-row-item's rowIn, .clarity-card's
           cardIn, etc.) the tab's own cards already play. Plain translateY
           only: the container just slides up slightly, no size change, so
           cards sliding in (their own animation) is the only motion that
           reads. Distinct from Planner's own Calendar/List switch animation
           (driven by plannerView state, not this remount, so it's untouched
           here). */
        @keyframes tabSettle { from { transform: translateY(10px); } to { transform: translateY(0); } }
        .clarity-tab-content { animation: tabSettle 0.18s cubic-bezier(0.22,1,0.36,1) both; }
        .anim-hold, .anim-hold .clarity-row-item, .anim-hold .clarity-card { animation-play-state: paused !important; }
        html:not([data-tab="calendar"]) [data-cal-portal],
        html:not([data-tab="habits"]) [data-habits-portal] { display: none !important; }
        html[data-app-edit] .cal-list-fab { display: none !important; }
        /* Clock-In timer page doesn't scroll at all (Jade, 2026-10-25): a stray swipe moved
           it on the phone. FocusTab sets data-ci-timer while that page shows; the Chart
           page still scrolls. */
        html[data-tab="focus"][data-ci-timer] .clarity-main { overflow-y: hidden !important; }

        /* ── Pastel background option (all tabs) — cards stay white ────── */
        .pastel-main {
          background: linear-gradient(180deg, #b1a5d4 0%, #c4add1 20%, #d9b5cd 40%, #efc0ca 60%, #f8d0c8 80%, #fde3d7 100%) !important;
          background-attachment: scroll !important; /* pinned to the scroll box, not its content: the whole gradient always fits the screen */
        }
        /* Frosted translucent nav bar (top rail / mobile bottom pill) for the soft
           gradient themes (pastel + masculine). Higher specificity + !important so
           it beats the mobile media-query white. */
        .clarity-sidebar.soft-nav {
          background: rgba(255,255,255,0.55) !important;
          -webkit-backdrop-filter: blur(20px) saturate(160%);
          backdrop-filter: blur(20px) saturate(160%);
        }
        /* While a bottom sheet is open the nav is under its dim, and the frosted
           blur only costs: the sheet slides over the bar, so the phone re-blurs
           it on every frame of the slide. That is why sheets lagged on gradient
           backgrounds only (Default's nav has no blur) (Jade, 2026-10-17). A
           sheet opts in with the class "no-nav-blur" on its root. */
        /* Same during a calendar swipe or the Clock-In Done pop (src/utils/navBlur.js).
           The white fill here is only a fallback: navBlur.js paints the page's own
           background behind the bar under the same 55% white (inline, !important),
           so the bar doesn't flash white (Jade, 2026-10-28). */
        .clarity-sidebar.soft-nav.nav-blur-paused {
          -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
          background: rgba(255,255,255,0.85) !important;
          transition-duration: 0s !important;
        }
        html:has(.no-nav-blur) .clarity-sidebar.soft-nav {
          -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
          transition-duration: 0s !important;
        }
        /* Unify white containers with the pastel theme: faint lavender-white fill +
           a soft pastel drop shadow (no colour-tinted bevel edges). */
        .pastel-main {
          --c-bg: #efc0ca;
          --c-bg-card: #fdfbff;
          --c-bg-soft: #fbf7fd;
          --c-bg-active: #f5edfb;
          --c-border: rgba(188,158,208,0.32);
          --c-border-light: rgba(188,158,208,0.20);
          --c-shadow: rgba(150,110,175,0.16);
          --c-grid-line: rgba(150,110,175,0.65);
          --c-grid-line-soft: rgba(150,110,175,0.42);
        }
        .pastel-main .clarity-card,
        .pastel-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(150,110,175,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .pastel-main .clarity-card:hover,
          .pastel-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(150,110,175,0.17) !important;
          }
        }
        /* Habit rows specifically: every other gradient/soft theme pins these to an
           opaque white card regardless of the "done" tint the row's inline style
           computes, so checking a habit only strikes through the label instead of
           fading the card into the gradient behind it. Pastel was missing this
           override, so its near-transparent done-state tint (themeTone()+alpha)
           showed the vivid gradient straight through — this brings it in line. */
        .pastel-main .habits-cat-col .clarity-row-item,
        .pastel-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fbf2f8 100%) !important;
          box-shadow: 0 8px 22px rgba(150,110,175,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .pastel-main .habits-cat-col .clarity-row-item:hover,
          .pastel-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(150,110,175,0.17) !important;
          }
        }
        /* ── Masculine (Steel) background option — cool slate gradient, all tabs ── */
        /* Same structure as pastel but with steel/graphite tinting: cool blue-grey
           fill, slate shadow, and beveled steel (top-left) → silver (bottom-right)
           edges that blend into the gradient. Cards stay light & readable. */
        .masculine-main {
          background: linear-gradient(180deg, #7d8aa3 0%, #8a96ae 20%, #9ca7bc 40%, #b2bbcb 60%, #cad0db 80%, #e6e9ee 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #b2bbcb;
          --c-bg-card: #f8fafc;
          --c-bg-soft: #f4f7fa;
          --c-bg-active: #eaeff5;
          --c-border: rgba(90,108,138,0.30);
          --c-border-light: rgba(90,108,138,0.18);
          --c-shadow: rgba(60,80,110,0.16);
          --c-grid-line: rgba(64,84,116,0.68);
          --c-grid-line-soft: rgba(64,84,116,0.45);
        }
        .masculine-main .clarity-card,
        .masculine-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(50,70,100,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .masculine-main .clarity-card:hover,
          .masculine-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(50,70,100,0.18) !important;
          }
        }
        /* Desktop "text on gradient" tabs (e.g. Clock-In) — retint the muted text
           tokens to cool slate so they stay readable on the steel gradient. */
        .masculine-main .focus-dashboard { --c-text-soft: #4a5870; --c-text-mid: #34455e; }
        /* Desktop dashboard strips the card bevel to a faint pink glow. On the steel
           theme keep the cards white with a soft cool gradient and a clean shadow —
           no colour-tinted bevel border. */
        .masculine-main .habits-cat-col .clarity-row-item,
        .masculine-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eef2f8 100%) !important;
          box-shadow: 0 8px 22px rgba(50,70,100,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .masculine-main .habits-cat-col .clarity-row-item:hover,
          .masculine-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(50,70,100,0.18) !important;
          }
        }
        /* ── Peach background option — warm apricot→blush gradient, all tabs ── */
        /* Same light-card structure as pastel/steel, tinted with soft coral: warm
           cream cards, peachy shadow, and gentle terracotta grid lines. Cards stay
           light & readable; the per-category accents are warmed via peachTone(). */
        .peach-main {
          background: linear-gradient(180deg, #FEB4A7 0%, #FFC69E 25%, #FED5CD 50%, #FADBC6 75%, #F8EDEB 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #FED5CD;
          --c-bg-card: #fffaf7;
          --c-bg-soft: #fdf4ef;
          --c-bg-active: #fce8df;
          --c-border: rgba(210,120,90,0.26);
          --c-border-light: rgba(210,120,90,0.16);
          --c-shadow: rgba(200,110,80,0.16);
          --c-grid-line: rgba(200,110,80,0.62);
          --c-grid-line-soft: rgba(200,110,80,0.40);
        }
        .peach-main .clarity-card,
        .peach-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(200,110,80,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .peach-main .clarity-card:hover,
          .peach-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(200,110,80,0.18) !important;
          }
        }
        /* Desktop "text on gradient" tabs (e.g. Clock-In) — retint muted text to
           warm brown so it stays readable on the peach gradient. */
        .peach-main .focus-dashboard { --c-text-soft: #9a6a55; --c-text-mid: #7a4736; }
        /* Desktop dashboard cards — keep them light with a warm cream gradient and a
           clean peach shadow (no colour-tinted bevel border). */
        .peach-main .habits-cat-col .clarity-row-item,
        .peach-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fdeee6 100%) !important;
          box-shadow: 0 8px 22px rgba(200,110,80,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .peach-main .habits-cat-col .clarity-row-item:hover,
          .peach-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(200,110,80,0.18) !important;
          }
        }
        /* ── Purple background option — pink-lavender→deep midnight gradient ── */
        /* Dreamy purple palette (#E0B1CB #BE95C4 #9F86C0 #5E548E #231942).
           Cards stay white/near-white; per-category accents pulled toward
           medium lavender via purpleTone(). */
        .purple-main {
          background: linear-gradient(180deg, #231942 0%, #5E548E 30%, #9F86C0 56%, #BE95C4 78%, #E0B1CB 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #9F86C0;
          --c-bg-card: #faf8fd;
          --c-bg-soft: #f0eaf8;
          --c-bg-active: #e4d9f5;
          --c-border: rgba(94,84,142,0.28);
          --c-border-light: rgba(94,84,142,0.16);
          --c-shadow: rgba(94,84,142,0.18);
          --c-grid-line: rgba(94,84,142,0.62);
          --c-grid-line-soft: rgba(94,84,142,0.40);
        }
        .purple-main .clarity-card,
        .purple-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(94,84,142,0.14) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .purple-main .clarity-card:hover,
          .purple-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(94,84,142,0.22) !important;
          }
        }
        .purple-main .focus-dashboard { --c-text-soft: #7a6898; --c-text-mid: #5E548E; }
        .purple-main .habits-cat-col .clarity-row-item,
        .purple-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #f0eaf8 100%) !important;
          box-shadow: 0 8px 22px rgba(94,84,142,0.14) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .purple-main .habits-cat-col .clarity-row-item:hover,
          .purple-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(94,84,142,0.22) !important;
          }
        }
        /* ── Mocha background option — deep espresso→warm cream gradient ── */
        /* Warm coffee palette (#3E2522 #8C6E63 #D3A376 #FFE0B2 #FFF2DF).
           Cards stay white/cream; per-category accents pulled toward
           caramel/tan via mochaTone(). */
        .mocha-main {
          background: linear-gradient(180deg, #3E2522 0%, #8C6E63 28%, #D3A376 54%, #FFE0B2 76%, #FFF2DF 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #D3A376;
          --c-bg-card: #fffcf7;
          --c-bg-soft: #fdf5e8;
          --c-bg-active: #f8e8d0;
          --c-border: rgba(62,37,34,0.22);
          --c-border-light: rgba(62,37,34,0.12);
          --c-shadow: rgba(62,37,34,0.16);
          --c-grid-line: rgba(62,37,34,0.58);
          --c-grid-line-soft: rgba(62,37,34,0.38);
        }
        .mocha-main .clarity-card,
        .mocha-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(62,37,34,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .mocha-main .clarity-card:hover,
          .mocha-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(62,37,34,0.20) !important;
          }
        }
        .mocha-main .focus-dashboard { --c-text-soft: #8C6E63; --c-text-mid: #3E2522; }
        .mocha-main .habits-cat-col .clarity-row-item,
        .mocha-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fdf0e0 100%) !important;
          box-shadow: 0 8px 22px rgba(62,37,34,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .mocha-main .habits-cat-col .clarity-row-item:hover,
          .mocha-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(62,37,34,0.20) !important;
          }
        }
        /* ── Dusk background option — deep slate→soft mist gradient ── */
        /* Moody slate palette (#191D23 #57707A 7E919F #979DAB #C5BAC4 #DEDCDC).
           Cards stay white/near-white; per-category accents pulled toward
           cool teal-grey via duskTone(). */
        .dusk-main {
          background: linear-gradient(180deg, #191D23 0%, #57707A 26%, #7E919F 46%, #979DAB 64%, #C5BAC4 82%, #DEDCDC 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #979DAB;
          --c-bg-card: #fafbfc;
          --c-bg-soft: #eef1f3;
          --c-bg-active: #dde3e7;
          --c-border: rgba(25,29,35,0.20);
          --c-border-light: rgba(25,29,35,0.11);
          --c-shadow: rgba(25,29,35,0.16);
          --c-grid-line: rgba(40,55,65,0.60);
          --c-grid-line-soft: rgba(40,55,65,0.40);
        }
        .dusk-main .clarity-card,
        .dusk-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(25,29,35,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .dusk-main .clarity-card:hover,
          .dusk-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(25,29,35,0.20) !important;
          }
        }
        .dusk-main .focus-dashboard { --c-text-soft: #5d6b74; --c-text-mid: #2b343b; }
        .dusk-main .habits-cat-col .clarity-row-item,
        .dusk-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eef1f3 100%) !important;
          box-shadow: 0 8px 22px rgba(25,29,35,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .dusk-main .habits-cat-col .clarity-row-item:hover,
          .dusk-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(25,29,35,0.20) !important;
          }
        }
        /* Every theme's blurred-mesh wallpaper (8 of them — Aurora, Lagoon,
           Cloud, Frost, Sand, Mist, Opal, Bloom, Terra, Shore) fades in instead of
           popping in at full opacity. Switching themes swaps which
           .xxx-main::before exists in the DOM, so the browser has to
           rasterize this fresh: six radial-gradients over a much-larger-
           than-viewport box (inset:-20%), then Gaussian-blur the whole
           thing by 90px — a genuinely heavy paint on a mid-range phone,
           worse under thermal/battery throttling. This doesn't make that
           work any cheaper, but it turns the stutter into what reads as an
           intentional soft reveal instead of a jarring flash. */
        @keyframes clarityWallpaperFadeIn { from { opacity: 0; } to { opacity: 1; } }
        /* ── Aurora background option — true fluid mesh (blurred-blob method) ── */
        /* The mesh itself lives on a fixed, full-screen ::before layer: a handful
           of solid colour stops melted together by a heavy filter: blur(). The
           blur is uniform in all directions, so the result is identical on desktop
           and tall mobile — no aspect-ratio smear. The main element just carries
           the neutral base colour the blurred layer sits on top of. */
        .aurora-main {
          background: #e2d8e4 !important;
          /* position+z-index makes this a stacking context so the z-index:-1
             ::before mesh paints ABOVE this element's own base background
             (but still behind all the cards/content). */
          position: relative;
          z-index: 0;
          --c-bg: #dbd6df;
          --c-bg-card: #faf9fc;
          --c-bg-soft: #f0edf5;
          --c-bg-active: #e4dff0;
          --c-border: rgba(115,143,189,0.24);
          --c-border-light: rgba(115,143,189,0.14);
          --c-shadow: rgba(115,143,189,0.16);
          --c-grid-line: rgba(115,143,189,0.60);
          --c-grid-line-soft: rgba(115,143,189,0.40);
        }
        /* Fixed full-screen blurred mesh layer. inset:-20% lets the blobs bleed
           past the viewport so the blur never produces a hard edge/vignette.
           z-index:-1 keeps it behind all content; pointer-events:none so it never
           intercepts taps. Doesn't scroll (fixed), so it stays put as you scroll. */
        .aurora-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 16% 18%, #738fbd 0%, transparent 45%),
            radial-gradient(circle at 84% 14%, #db88a4 0%, transparent 45%),
            radial-gradient(circle at 22% 78%, #a8c3d4 0%, transparent 45%),
            radial-gradient(circle at 88% 82%, #cc8eb1 0%, transparent 45%),
            radial-gradient(circle at 58% 44%, #e7c5ff 0%, transparent 48%),
            radial-gradient(circle at 46% 96%, #eec6c7 0%, transparent 42%),
            radial-gradient(circle at 92% 50%, #dbd6df 0%, transparent 40%),
            #e2d8e4;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .aurora-main .clarity-card,
        .aurora-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(115,143,189,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .aurora-main .clarity-card:hover,
          .aurora-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(115,143,189,0.20) !important;
          }
        }
        .aurora-main .focus-dashboard { --c-text-soft: #8a92b4; --c-text-mid: #5a6fa0; }
        .aurora-main .habits-cat-col .clarity-row-item,
        .aurora-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eeeaf5 100%) !important;
          box-shadow: 0 8px 22px rgba(115,143,189,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .aurora-main .habits-cat-col .clarity-row-item:hover,
          .aurora-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(115,143,189,0.20) !important;
          }
        }
        /* ── Lilac background option — periwinkle→pink pastel gradient ── */
        /* Soft dreamy palette (#BDCFFF #B8C0FF #C8B6FE #E7C5FF #FED5FF).
           Cards stay white; per-category accents pulled toward #C8B6FE lilac. */
        .lilac-main {
          background: linear-gradient(180deg, #BDCFFF 0%, #B8C0FF 25%, #C8B6FE 50%, #E7C5FF 75%, #FED5FF 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #C8B6FE;
          --c-bg-card: #fdfbff;
          --c-bg-soft: #f5f1fe;
          --c-bg-active: #ece5fc;
          --c-border: rgba(125,104,196,0.22);
          --c-border-light: rgba(125,104,196,0.13);
          --c-shadow: rgba(125,104,196,0.16);
          --c-grid-line: rgba(125,104,196,0.58);
          --c-grid-line-soft: rgba(125,104,196,0.38);
        }
        .lilac-main .clarity-card,
        .lilac-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(125,104,196,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .lilac-main .clarity-card:hover,
          .lilac-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(125,104,196,0.20) !important;
          }
        }
        .lilac-main .focus-dashboard { --c-text-soft: #8a7cc0; --c-text-mid: #5f4f99; }
        .lilac-main .habits-cat-col .clarity-row-item,
        .lilac-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #f3eefe 100%) !important;
          box-shadow: 0 8px 22px rgba(125,104,196,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .lilac-main .habits-cat-col .clarity-row-item:hover,
          .lilac-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(125,104,196,0.20) !important;
          }
        }
        /* ── Velvet background option — moonlit plum→rose gradient ── */
        /* Dramatic palette (#140E1C #462037 #683A46 #A1525F #C5757C #F9AAAD).
           Near-black at top melting down to soft pink. Cards stay white;
           per-category accents pulled toward #A1525F rosewood via velvetTone(). */
        .velvet-main {
          background: linear-gradient(180deg, #140E1C 0%, #462037 22%, #683A46 44%, #A1525F 64%, #C5757C 82%, #F9AAAD 100%) !important;
          background-attachment: scroll !important;
          --c-bg: #A1525F;
          --c-bg-card: #fffafb;
          --c-bg-soft: #fdf0f2;
          --c-bg-active: #f9e2e6;
          --c-border: rgba(104,58,70,0.24);
          --c-border-light: rgba(104,58,70,0.14);
          --c-shadow: rgba(70,32,55,0.18);
          --c-grid-line: rgba(104,58,70,0.60);
          --c-grid-line-soft: rgba(104,58,70,0.40);
        }
        .velvet-main .clarity-card,
        .velvet-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(70,32,55,0.15) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .velvet-main .clarity-card:hover,
          .velvet-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(70,32,55,0.22) !important;
          }
        }
        .velvet-main .focus-dashboard { --c-text-soft: #a06873; --c-text-mid: #683A46; }
        .velvet-main .habits-cat-col .clarity-row-item,
        .velvet-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fbeef0 100%) !important;
          box-shadow: 0 8px 22px rgba(70,32,55,0.15) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .velvet-main .habits-cat-col .clarity-row-item:hover,
          .velvet-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(70,32,55,0.22) !important;
          }
        }
        /* ── Lagoon background option — oceanic mesh (blurred-blob method) ── */
        /* Same technique as Aurora: a fixed, full-screen ::before paints a few
           solid colour stops melted by filter: blur(), uniform on any aspect
           ratio. Palette: #002B8C #4B0082 #87CEEB #E6E6FA #006982. */
        .lagoon-main {
          background: #dbe4f1 !important;
          position: relative;
          z-index: 0;
          --c-bg: #87CEEB;
          --c-bg-card: #f9fbfe;
          --c-bg-soft: #eef3fb;
          --c-bg-active: #dde8f6;
          --c-border: rgba(0,43,140,0.20);
          --c-border-light: rgba(0,43,140,0.12);
          --c-shadow: rgba(0,43,140,0.16);
          --c-grid-line: rgba(0,43,140,0.56);
          --c-grid-line-soft: rgba(0,43,140,0.36);
        }
        .lagoon-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 16% 16%, #002B8C 0%, transparent 46%),
            radial-gradient(circle at 86% 12%, #4B0082 0%, transparent 46%),
            radial-gradient(circle at 24% 80%, #006982 0%, transparent 46%),
            radial-gradient(circle at 88% 84%, #87CEEB 0%, transparent 46%),
            radial-gradient(circle at 56% 46%, #E6E6FA 0%, transparent 48%),
            radial-gradient(circle at 50% 96%, #87CEEB 0%, transparent 42%),
            radial-gradient(circle at 94% 50%, #006982 0%, transparent 40%),
            #dbe4f1;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .lagoon-main .clarity-card,
        .lagoon-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(0,43,140,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .lagoon-main .clarity-card:hover,
          .lagoon-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(0,43,140,0.20) !important;
          }
        }
        .lagoon-main .focus-dashboard { --c-text-soft: #5b7fb0; --c-text-mid: #002B8C; }
        .lagoon-main .habits-cat-col .clarity-row-item,
        .lagoon-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #ecf1fb 100%) !important;
          box-shadow: 0 8px 22px rgba(0,43,140,0.13) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .lagoon-main .habits-cat-col .clarity-row-item:hover,
          .lagoon-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(0,43,140,0.20) !important;
          }
        }
        /* ── Cloud background option — dreamy pastel mesh (blurred-blob method) ── */
        /* Same technique as Aurora/Lagoon: a fixed, full-screen ::before paints a
           few solid colour stops melted by filter: blur(), uniform on any aspect
           ratio. Palette: #F8E0D0 #F5CAC8 #E7B7C5 #CBAFC7 #C2C4DC. */
        .cloud-main {
          background: #f3e3e6 !important;
          position: relative;
          z-index: 0;
          --c-bg: #E7B7C5;
          --c-bg-card: #fffafb;
          --c-bg-soft: #fdf3f4;
          --c-bg-active: #f9e7ea;
          --c-border: rgba(181,101,140,0.20);
          --c-border-light: rgba(181,101,140,0.12);
          --c-shadow: rgba(181,101,140,0.16);
          --c-grid-line: rgba(181,101,140,0.54);
          --c-grid-line-soft: rgba(181,101,140,0.36);
        }
        .cloud-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 16% 14%, #F8E0D0 0%, transparent 46%),
            radial-gradient(circle at 86% 12%, #F5CAC8 0%, transparent 46%),
            radial-gradient(circle at 22% 82%, #C2C4DC 0%, transparent 46%),
            radial-gradient(circle at 88% 84%, #E7B7C5 0%, transparent 46%),
            radial-gradient(circle at 56% 46%, #CBAFC7 0%, transparent 48%),
            radial-gradient(circle at 48% 96%, #F5CAC8 0%, transparent 42%),
            radial-gradient(circle at 94% 50%, #CBAFC7 0%, transparent 40%),
            #f3e3e6;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .cloud-main .clarity-card,
        .cloud-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(181,101,140,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .cloud-main .clarity-card:hover,
          .cloud-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(181,101,140,0.20) !important;
          }
        }
        .cloud-main .focus-dashboard { --c-text-soft: #b888a0; --c-text-mid: #8a5570; }
        .cloud-main .habits-cat-col .clarity-row-item,
        .cloud-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fceef0 100%) !important;
          box-shadow: 0 8px 22px rgba(181,101,140,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .cloud-main .habits-cat-col .clarity-row-item:hover,
          .cloud-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(181,101,140,0.20) !important;
          }
        }

        /* ── Ocean theme — deep navy-to-sky linear gradient ───────── */
        /* Palette: #021024 #052659 #5483B3 #7DA0CA #C1E8FF.           */
        .ocean-main {
          --c-bg: #e8f4fd;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f1f5f9;
          --c-border: rgba(84,131,179,0.18);
          --c-border-light: rgba(84,131,179,0.10);
          --c-text: #021024;
          --c-text-soft: #5483B3;
          --c-text-mid: #052659;
          --c-text-accent: #7DA0CA;
          --c-shadow: rgba(5,38,89,0.18);
          --c-grid-line: rgba(84,131,179,0.52);
          --c-grid-line-soft: rgba(84,131,179,0.34);
        }
        .ocean-main .clarity-card,
        .ocean-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(5,38,89,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .ocean-main .clarity-card:hover,
          .ocean-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(5,38,89,0.20) !important;
          }
        }
        .ocean-main .focus-dashboard { --c-text-soft: #5483B3; --c-text-mid: #052659; }
        .ocean-main .habits-cat-col .clarity-row-item,
        .ocean-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eaf4fd 100%) !important;
          box-shadow: 0 8px 22px rgba(5,38,89,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .ocean-main .habits-cat-col .clarity-row-item:hover,
          .ocean-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(5,38,89,0.20) !important;
          }
        }

        /* ── Frost theme — winter dusk mesh gradient ──────────────── */
        /* Palette: #525871 #857C91 #CD9FA0 #F2C1A3 #F8CCAA.          */
        .frost-main {
          background: #f0e6e4 !important;
          position: relative;
          z-index: 0;
          --c-bg: #f8eeec;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f5f5f6;
          --c-border: rgba(133,124,145,0.18);
          --c-border-light: rgba(133,124,145,0.10);
          --c-text: #2e2b35;
          --c-text-soft: #857C91;
          --c-text-mid: #525871;
          --c-text-accent: #CD9FA0;
          --c-shadow: rgba(82,88,113,0.16);
          --c-grid-line: rgba(133,124,145,0.52);
          --c-grid-line-soft: rgba(133,124,145,0.34);
        }
        .frost-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 15% 20%, #857C91 0%, transparent 48%),
            radial-gradient(circle at 80% 10%, #525871 0%, transparent 42%),
            radial-gradient(circle at 60% 55%, #CD9FA0 0%, transparent 50%),
            radial-gradient(circle at 25% 75%, #F2C1A3 0%, transparent 44%),
            radial-gradient(circle at 88% 80%, #F8CCAA 0%, transparent 46%),
            radial-gradient(circle at 50% 35%, #857C91 0%, transparent 38%),
            #f0e6e4;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .frost-main .clarity-card,
        .frost-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(82,88,113,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .frost-main .clarity-card:hover,
          .frost-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(82,88,113,0.20) !important;
          }
        }
        .frost-main .focus-dashboard { --c-text-soft: #857C91; --c-text-mid: #525871; }
        .frost-main .habits-cat-col .clarity-row-item,
        .frost-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fdf0ee 100%) !important;
          box-shadow: 0 8px 22px rgba(82,88,113,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .frost-main .habits-cat-col .clarity-row-item:hover,
          .frost-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(82,88,113,0.20) !important;
          }
        }

        /* ── Sand theme — warm beige-neutral mesh gradient ────────── */
        /* Palette: #D7BDB0 #E3D5CA #F5EBE1 #D6CCC2 #EDEEE9.          */
        .sand-main {
          background: #ece2da !important;
          position: relative;
          z-index: 0;
          --c-bg: #f6efe9;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f7f5f3;
          --c-border: rgba(156,125,108,0.18);
          --c-border-light: rgba(156,125,108,0.10);
          --c-text: #4a3f38;
          --c-text-soft: #9c7d6c;
          --c-text-mid: #6e5a4e;
          --c-text-accent: #b89a8a;
          --c-shadow: rgba(120,95,80,0.16);
          --c-grid-line: rgba(156,125,108,0.50);
          --c-grid-line-soft: rgba(156,125,108,0.32);
        }
        .sand-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 18% 22%, #D7BDB0 0%, transparent 48%),
            radial-gradient(circle at 82% 15%, #E3D5CA 0%, transparent 44%),
            radial-gradient(circle at 60% 50%, #F5EBE1 0%, transparent 50%),
            radial-gradient(circle at 25% 78%, #D6CCC2 0%, transparent 46%),
            radial-gradient(circle at 85% 82%, #EDEEE9 0%, transparent 46%),
            radial-gradient(circle at 50% 32%, #D7BDB0 0%, transparent 38%),
            #ece2da;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .sand-main .clarity-card,
        .sand-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(120,95,80,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .sand-main .clarity-card:hover,
          .sand-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(120,95,80,0.20) !important;
          }
        }
        .sand-main .focus-dashboard { --c-text-soft: #9c7d6c; --c-text-mid: #6e5a4e; }
        .sand-main .habits-cat-col .clarity-row-item,
        .sand-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #f7f0ea 100%) !important;
          box-shadow: 0 8px 22px rgba(120,95,80,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .sand-main .habits-cat-col .clarity-row-item:hover,
          .sand-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(120,95,80,0.20) !important;
          }
        }

        /* ── Mist theme — serene blue-sage-pink mesh gradient ─────── */
        /* Palette: #99CDD8 #DAEBE3 #FDE8D3 #F3C3B2 #CFD6C4 #657166.  */
        .mist-main {
          background: #dde8e6 !important;
          position: relative;
          z-index: 0;
          --c-bg: #e8f1ef;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f3f4f3;
          --c-border: rgba(101,113,102,0.16);
          --c-border-light: rgba(101,113,102,0.09);
          --c-text: #2e3a33;
          --c-text-soft: #657166;
          --c-text-mid: #4a5e52;
          --c-text-accent: #99CDD8;
          --c-shadow: rgba(80,105,90,0.16);
          --c-grid-line: rgba(101,113,102,0.50);
          --c-grid-line-soft: rgba(101,113,102,0.32);
        }
        .mist-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 12% 18%, #99CDD8 0%, transparent 46%),
            radial-gradient(circle at 78% 12%, #DAEBE3 0%, transparent 44%),
            radial-gradient(circle at 55% 52%, #FDE8D3 0%, transparent 48%),
            radial-gradient(circle at 22% 80%, #F3C3B2 0%, transparent 44%),
            radial-gradient(circle at 88% 75%, #CFD6C4 0%, transparent 46%),
            radial-gradient(circle at 48% 28%, #657166 0%, transparent 36%),
            #dde8e6;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .mist-main .clarity-card,
        .mist-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(80,105,90,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .mist-main .clarity-card:hover,
          .mist-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(80,105,90,0.19) !important;
          }
        }
        .mist-main .focus-dashboard { --c-text-soft: #657166; --c-text-mid: #4a5e52; }
        .mist-main .habits-cat-col .clarity-row-item,
        .mist-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eef6f4 100%) !important;
          box-shadow: 0 8px 22px rgba(80,105,90,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .mist-main .habits-cat-col .clarity-row-item:hover,
          .mist-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(80,105,90,0.19) !important;
          }
        }

        /* ── Opal theme — pearly pink, aqua & lilac mesh ───────────── */
        /* Palette: #F3B9CB #FFDCCB #FDF0F9 #AFEBF3 #8ED5F3 #B5A2D4.   */
        .opal-main {
          background: #f6eefa !important;
          position: relative;
          z-index: 0;
          --c-bg: #f7f0fb;
          --c-bg-card: #ffffff;
          --c-bg-soft: #faf5fc;
          --c-border: rgba(95,107,181,0.16);
          --c-border-light: rgba(95,107,181,0.09);
          --c-text: #2a2140;
          --c-text-soft: #6a5a86;
          --c-text-mid: #45385f;
          --c-text-accent: #5F6BB5;
          --c-shadow: rgba(95,107,181,0.14);
          --c-grid-line: rgba(95,107,181,0.42);
          --c-grid-line-soft: rgba(95,107,181,0.26);
        }
        .opal-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 16% 12%, #B5A2D4 0%, transparent 42%),
            radial-gradient(circle at 84% 14%, #8ED5F3 0%, transparent 42%),
            radial-gradient(circle at 50% 30%, #F3B9CB 0%, transparent 38%),
            radial-gradient(circle at 14% 54%, #AFEBF3 0%, transparent 44%),
            radial-gradient(circle at 88% 56%, #FFDCCB 0%, transparent 44%),
            radial-gradient(circle at 24% 90%, #FDF0F9 0%, transparent 44%),
            radial-gradient(circle at 80% 92%, #F3B9CB 0%, transparent 46%),
            #f6eefa;
          filter: blur(80px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .opal-main .clarity-card,
        .opal-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(95,107,181,0.10) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .opal-main .clarity-card:hover,
          .opal-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(95,107,181,0.18) !important;
          }
        }
        .opal-main .focus-dashboard { --c-text-soft: #6a5a86; --c-text-mid: #45385f; }
        .opal-main .habits-cat-col .clarity-row-item,
        .opal-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #f8f1fb 100%) !important;
          box-shadow: 0 8px 22px rgba(95,107,181,0.10) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .opal-main .habits-cat-col .clarity-row-item:hover,
          .opal-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(95,107,181,0.18) !important;
          }
        }

        /* ── Bloom theme — peach, coral & butter flower mesh ───────── */
        /* Palette: #FAEBCB #F9A58F #FCB588 #FBD78E #E1DE9B.           */
        .bloom-main {
          background: #fbeed3 !important;
          position: relative;
          z-index: 0;
          --c-bg: #fcefd6;
          --c-bg-card: #ffffff;
          --c-bg-soft: #fdf6e8;
          --c-border: rgba(184,85,63,0.18);
          --c-border-light: rgba(184,85,63,0.10);
          --c-text: #3a2418;
          --c-text-soft: #85604d;
          --c-text-mid: #5e3f30;
          --c-text-accent: #B8553F;
          --c-shadow: rgba(184,85,63,0.14);
          --c-grid-line: rgba(184,85,63,0.42);
          --c-grid-line-soft: rgba(184,85,63,0.26);
        }
        .bloom-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 16% 12%, #F9A58F 0%, transparent 42%),
            radial-gradient(circle at 84% 14%, #FCB588 0%, transparent 42%),
            radial-gradient(circle at 50% 30%, #FBD78E 0%, transparent 40%),
            radial-gradient(circle at 14% 54%, #FAEBCB 0%, transparent 46%),
            radial-gradient(circle at 88% 58%, #E1DE9B 0%, transparent 40%),
            radial-gradient(circle at 24% 90%, #E1DE9B 0%, transparent 42%),
            radial-gradient(circle at 80% 92%, #FAEBCB 0%, transparent 46%),
            #fbeed3;
          filter: blur(80px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .bloom-main .clarity-card,
        .bloom-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(184,85,63,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .bloom-main .clarity-card:hover,
          .bloom-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(184,85,63,0.19) !important;
          }
        }
        .bloom-main .focus-dashboard { --c-text-soft: #85604d; --c-text-mid: #5e3f30; }
        .bloom-main .habits-cat-col .clarity-row-item,
        .bloom-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #fdf1dc 100%) !important;
          box-shadow: 0 8px 22px rgba(184,85,63,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .bloom-main .habits-cat-col .clarity-row-item:hover,
          .bloom-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(184,85,63,0.19) !important;
          }
        }

        /* ── Terra theme — earthy Mediterranean mesh gradient ─────── */
        /* Palette: #A1B5A8 #CBB093 #DFA477 #A4624D #F5DFC5.          */
        .terra-main {
          background: #e3d3bf !important;
          position: relative;
          z-index: 0;
          --c-bg: #f1e4d3;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f8f2f1;
          --c-border: rgba(164,98,77,0.16);
          --c-border-light: rgba(164,98,77,0.09);
          --c-text: #4a342b;
          --c-text-soft: #a4624d;
          --c-text-mid: #7d4a3a;
          --c-text-accent: #CBB093;
          --c-shadow: rgba(124,74,58,0.16);
          --c-grid-line: rgba(164,98,77,0.48);
          --c-grid-line-soft: rgba(164,98,77,0.32);
        }
        .terra-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 15% 18%, #A1B5A8 0%, transparent 46%),
            radial-gradient(circle at 80% 14%, #CBB093 0%, transparent 44%),
            radial-gradient(circle at 58% 50%, #DFA477 0%, transparent 48%),
            radial-gradient(circle at 22% 78%, #A4624D 0%, transparent 44%),
            radial-gradient(circle at 86% 80%, #F5DFC5 0%, transparent 46%),
            radial-gradient(circle at 48% 30%, #CBB093 0%, transparent 36%),
            #e3d3bf;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        .terra-main .clarity-card,
        .terra-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(124,74,58,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .terra-main .clarity-card:hover,
          .terra-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(124,74,58,0.20) !important;
          }
        }
        .terra-main .focus-dashboard { --c-text-soft: #a4624d; --c-text-mid: #7d4a3a; }
        .terra-main .habits-cat-col .clarity-row-item,
        .terra-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #f8ece0 100%) !important;
          box-shadow: 0 8px 22px rgba(124,74,58,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .terra-main .habits-cat-col .clarity-row-item:hover,
          .terra-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(124,74,58,0.20) !important;
          }
        }

        /* ── Glacier theme — deep pine-to-sunbeam linear gradient ─── */
        /* Palette: #152026 #1B3D59 #6A97C0 #B3D5F1 #D4EEF8 #F3EED8.  */
        .glacier-main {
          --c-bg: #e8f3fa;
          --c-bg-card: #ffffff;
          --c-bg-soft: #eff1f3;
          --c-border: rgba(27,61,89,0.16);
          --c-border-light: rgba(27,61,89,0.09);
          --c-text: #152026;
          --c-text-soft: #6A97C0;
          --c-text-mid: #1B3D59;
          --c-text-accent: #B3D5F1;
          --c-shadow: rgba(21,32,38,0.18);
          --c-grid-line: rgba(106,151,192,0.50);
          --c-grid-line-soft: rgba(106,151,192,0.32);
        }
        .glacier-main .clarity-card,
        .glacier-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(21,32,38,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .glacier-main .clarity-card:hover,
          .glacier-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(21,32,38,0.20) !important;
          }
        }
        .glacier-main .focus-dashboard { --c-text-soft: #6A97C0; --c-text-mid: #1B3D59; }
        .glacier-main .habits-cat-col .clarity-row-item,
        .glacier-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eaf4fc 100%) !important;
          box-shadow: 0 8px 22px rgba(21,32,38,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .glacier-main .habits-cat-col .clarity-row-item:hover,
          .glacier-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(21,32,38,0.20) !important;
          }
        }

        /* ── Shore theme — coastal teal-sage mesh gradient ────────── */
        /* Palette: #597F86 #679391 #87B2B0 #99B4AE #ACB8AE #ADB1A5.  */
        .shore-main {
          background: #c8d8d6 !important;
          position: relative;
          z-index: 0;
          --c-bg: #d8e7e5;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f2f5f5;
          --c-border: rgba(89,127,134,0.16);
          --c-border-light: rgba(89,127,134,0.09);
          --c-text: #2c3f42;
          --c-text-soft: #597F86;
          --c-text-mid: #3e6068;
          --c-text-accent: #87B2B0;
          --c-shadow: rgba(70,110,115,0.16);
          --c-grid-line: rgba(89,127,134,0.48);
          --c-grid-line-soft: rgba(89,127,134,0.32);
        }
        .shore-main::before {
          content: "";
          position: fixed;
          inset: -20%;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(circle at 14% 20%, #597F86 0%, transparent 46%),
            radial-gradient(circle at 82% 12%, #679391 0%, transparent 44%),
            radial-gradient(circle at 55% 52%, #87B2B0 0%, transparent 50%),
            radial-gradient(circle at 20% 80%, #99B4AE 0%, transparent 44%),
            radial-gradient(circle at 88% 78%, #ACB8AE 0%, transparent 46%),
            radial-gradient(circle at 50% 32%, #ADB1A5 0%, transparent 38%),
            #c8d8d6;
          filter: blur(90px);
          animation: clarityWallpaperFadeIn 0.45s ease both;
        }
        /* Mesh backgrounds lagged with the keyboard (Jade, 2026-10-11). Their
           blurred layer was sized to the viewport (inset -20%), so every
           viewport resize, which is what opening or closing the keyboard is,
           re-drew the whole 80-90px blur: about 200x Default's raster work in
           a 6x-throttled trace. Sizing it from the SCREEN instead (--wp-h,
           set once in App.jsx and not changed by the keyboard) keeps its box
           the same, so the keyboard only moves things in front of it.
           NOT promoted to its own layer (no translateZ / will-change): on its
           own layer the 80-90px blur is re-applied by the compositor on EVERY
           frame anything moves on top, so every bottom-sheet slide ran at
           ~20fps on these backgrounds only (Jade, 2026-10-16: "smooth on
           Default, laggy on a gradient"). Unpromoted, the blur is drawn into
           the tiles once and reused: 60fps, and keyboard resizes still cost
           ~19ms of raster over 9 resizes (Default ~7ms). Don't re-add it. */
        .aurora-main::before, .lagoon-main::before, .cloud-main::before, .frost-main::before,
        .sand-main::before, .mist-main::before, .opal-main::before, .bloom-main::before,
        .terra-main::before, .shore-main::before {
          inset: auto;
          top: calc(var(--wp-h, 100vh) * -0.2);
          left: -20vw;
          width: 140vw;
          height: calc(var(--wp-h, 100vh) * 1.4);
        }
        /* Same keyboard lag, smaller, on the plain gradient backgrounds (Pastel,
           Peach, Purple...): the gradient was stretched to the box, so each
           resize re-drew it on both the app root and .clarity-main (~5x
           Default). Fixed to the screen height it stays the same image, and
           the keyboard just covers its lower part. Halved the raster work. */
        div.clarity-main, .clarity-root {
          background-size: 100% var(--wp-h, 100vh) !important;
          background-repeat: no-repeat !important;
        }
        /* .clarity-main sits below the status bar (--sat), so it is that much
           shorter than the window: size its gradient to its own height, or the
           last colour of the gradient falls just off the bottom. */
        div.clarity-main {
          background-size: 100% calc(var(--wp-h, 100vh) - var(--sat, 0px)) !important;
        }
        .shore-main .clarity-card,
        .shore-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(70,110,115,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .shore-main .clarity-card:hover,
          .shore-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(70,110,115,0.19) !important;
          }
        }
        .shore-main .focus-dashboard { --c-text-soft: #597F86; --c-text-mid: #3e6068; }
        .shore-main .habits-cat-col .clarity-row-item,
        .shore-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #eaf3f2 100%) !important;
          box-shadow: 0 8px 22px rgba(70,110,115,0.11) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .shore-main .habits-cat-col .clarity-row-item:hover,
          .shore-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(70,110,115,0.19) !important;
          }
        }

        /* ── Tide theme — deep midnight-teal-to-ice linear gradient ─ */
        /* Palette: #013137 #215E68 #297376 #5C9396 #C1D9DE.         */
        .tide-main {
          --c-bg: #e6f1f2;
          --c-bg-card: #ffffff;
          --c-bg-soft: #f0f5f5;
          --c-border: rgba(41,115,118,0.16);
          --c-border-light: rgba(41,115,118,0.09);
          --c-text: #013137;
          --c-text-soft: #5C9396;
          --c-text-mid: #215E68;
          --c-text-accent: #297376;
          --c-shadow: rgba(1,49,55,0.18);
          --c-grid-line: rgba(41,115,118,0.50);
          --c-grid-line-soft: rgba(41,115,118,0.32);
        }
        .tide-main .clarity-card,
        .tide-main .clarity-row-item {
          box-shadow: 0 8px 22px rgba(1,49,55,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        @media (hover: hover) and (pointer: fine) {
          .tide-main .clarity-card:hover,
          .tide-main .clarity-row-item:hover {
            box-shadow: 0 12px 28px rgba(1,49,55,0.20) !important;
          }
        }
        .tide-main .focus-dashboard { --c-text-soft: #5C9396; --c-text-mid: #215E68; }
        .tide-main .habits-cat-col .clarity-row-item,
        .tide-main .habits-main-col .clarity-row-item {
          border: none !important;
          background: linear-gradient(155deg, #ffffff 0%, #e8f3f4 100%) !important;
          box-shadow: 0 8px 22px rgba(1,49,55,0.12) !important;
          transition: box-shadow 0.2s ease, transform 0.2s ease !important;
        }
        @media (hover: hover) and (pointer: fine) {
          .tide-main .habits-cat-col .clarity-row-item:hover,
          .tide-main .habits-main-col .clarity-row-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px rgba(1,49,55,0.20) !important;
          }
        }
        }

        /* ── Calendar sub-view fade transition ────────────────────── */
        @keyframes calViewIn { from { opacity: 0; transform: translateY(8px) scale(0.99); } to { opacity: 1; transform: translateY(0) scale(1); } }
        .cal-subview { animation: calViewIn 0.22s cubic-bezier(0.22,1,0.36,1) both; }

        /* ── View switcher panel pop-up ───────────────────────────── */
        @keyframes viewPanelIn { from { opacity: 0; transform: translateY(10px) scale(0.96); } to { opacity: 1; transform: translateY(0) scale(1); } }
        .cal-view-panel { animation: viewPanelIn 0.2s cubic-bezier(0.34,1.56,0.64,1) both; }

        /* ── Arrow / pill button ──────────────────────────────────── */
        .cal-view-btn { transition: all 0.18s cubic-bezier(0.34,1.56,0.64,1) !important; }
        .cal-view-btn:active { transform: scale(0.88) !important; }

        /* ── Bottom nav press effect ──────────────────────────────── */
        .cal-bottom-nav-btn { transition: all 0.18s cubic-bezier(0.34,1.56,0.64,1) !important; }
        .cal-bottom-nav-btn:active { transform: scale(0.88) !important; opacity: 0.8; }
        .cal-bottom-nav-btn.active { transform: scale(1.05); }
        .cal-bottom-nav-btn.active:active { transform: scale(0.95) !important; }

        /* ── Settings drawer ──────────────────────────────────────── */
        @keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }
        /* ── Centered panel pop-in (Jade, 2026-10-05) — every centered panel uses the
           Categories panel's own animation (catPanelIn: scale 0.88 + 12px rise, 0.22s,
           slight overshoot), which Jade picked as the best one — then the overshoot
           (bounce) removed at her ask: plain ease-out, no going past full size.
           .clarity-pop: panels centred by a flex parent (Modal + custom overlays).
           .clarity-pop-c: panels centred with top/left 50% + translate(-50%,-50%).
           .clarity-fade: a backdrop that is a SIBLING of its panel.
           .clarity-dim: a backdrop that CONTAINS its panel (Modal): fades only its
           background colour, never its opacity, or the panel inside would fade twice
           (that double fade read as a blink before the pop). */
        @keyframes clarityPopIn { from { opacity: 0; transform: scale(0.88) translateY(12px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        @keyframes clarityPopInC { from { opacity: 0; transform: translate(-50%, -50%) scale(0.88) translateY(12px); } to { opacity: 1; transform: translate(-50%, -50%) scale(1) translateY(0); } }
        @keyframes clarityDimIn { from { background-color: transparent; } }
        .clarity-pop { animation: clarityPopIn 0.22s cubic-bezier(0.22,1,0.36,1) both; }
        .clarity-pop-c { animation: clarityPopInC 0.22s cubic-bezier(0.22,1,0.36,1) both; }
        .clarity-fade { animation: overlayIn 0.2s ease both; }
        .clarity-dim { animation: clarityDimIn 0.2s ease both; }
        @media (prefers-reduced-motion: reduce) { .clarity-pop, .clarity-pop-c, .clarity-fade, .clarity-dim { animation: none; } }
        @keyframes drawerIn { from { transform: translateX(-100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        .clarity-overlay-bg { animation: overlayIn 0.2s ease both; }
        .clarity-drawer { animation: drawerIn 0.28s cubic-bezier(0.22,1,0.36,1) both; }

        /* ── Modal / sheet entrance ───────────────────────────────── */
        @keyframes sheetIn { from { transform: translateY(32px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        .clarity-modal-sheet { animation: sheetIn 0.28s cubic-bezier(0.22,1,0.36,1) both; }

        /* ── Row items (stagger via animationDelay on style) ─────── */
        @keyframes rowIn { from { opacity: 0; transform: translateX(-8px); } to { opacity: 1; transform: translateX(0); } }
        .clarity-row-item { animation: rowIn 0.24s cubic-bezier(0.22,1,0.36,1) both; }

        /* ── Hoverable cards ──────────────────────────────────────── */
        .clarity-hover-card { transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease !important; }
        @media (hover: hover) and (pointer: fine) {
          .clarity-hover-card:hover { box-shadow: 0 6px 24px var(--c-shadow) !important; transform: translateY(-1px) !important; border-color: var(--c-border) !important; }
        }

        /* ── Emoji picker pop ─────────────────────────────────────── */
        @keyframes pickerPop { from { opacity: 0; transform: scale(0.88) translateY(-6px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        .clarity-emoji-picker { animation: pickerPop 0.2s cubic-bezier(0.34,1.56,0.64,1) both; }

        /* ── Accordion expand ─────────────────────────────────────── */
        @keyframes expandDown { from { opacity: 0; transform: scaleY(0.92); transform-origin: top; } to { opacity: 1; transform: scaleY(1); transform-origin: top; } }
        .clarity-expand { animation: expandDown 0.2s ease both; }

        /* ── Deep-linked settings row (e.g. Clock-In's "Open Settings" jumping
           straight to App Blocker) — a couple of soft flashes so the row that
           was scrolled to is obvious, then settles back to normal. ────────── */
        @keyframes settingsRowPulse {
          0%, 100% { background: transparent; }
          20%, 60% { background: var(--c-bg-active, #fdeef4); }
        }
        .settings-row-pulse { animation: settingsRowPulse 1.1s ease-in-out 1; border-radius: 12px; }

        /* ── Logo petal float ─────────────────────────────────────── */
        @keyframes floatPetal { 0%,100% { transform: translateY(0px) rotate(0deg); opacity: 0.8; } 40% { transform: translateY(-6px) rotate(5deg); opacity: 1; } 70% { transform: translateY(-2px) rotate(-3deg); opacity: 0.9; } }
        .clarity-logo-petal { display: inline-block; animation: floatPetal 4s ease-in-out infinite; }

        /* ── Hide scrollbar (still scrollable) ────────────────────── */
        .clarity-no-scrollbar { scrollbar-width: none; -ms-overflow-style: none; }
        .clarity-no-scrollbar::-webkit-scrollbar { display: none; width: 0; height: 0; }

        /* Onboarding: keep scrollbars out of layout on every scrollable region
           inside the quiz overlay. The global 4px ::-webkit-scrollbar above
           takes real width, so one appearing a frame after first paint (once
           overflow is detected) shrank the content box and re-wrapped headings
           sitting near their line-break threshold — text visibly shifting just
           after a screen appeared. */
        .clarity-onboarding-screen ::-webkit-scrollbar { display: none; width: 0; height: 0; }

        /* Dark background themes: hide the MAIN screen's own scrollbar (the page
           scroller each tab scrolls in). Deliberately not every element: scrollers inside
           containers (the Planner's filter panel, lists, sheets) keep theirs.
           The !important beats the global 4px ::-webkit-scrollbar rule above. */
        html[data-dark-bg], html[data-dark-bg] body, html[data-dark-bg] .clarity-main, html[data-dark-bg] .clarity-tab-content { scrollbar-width: none !important; -ms-overflow-style: none !important; }
        html[data-dark-bg]::-webkit-scrollbar, html[data-dark-bg] body::-webkit-scrollbar, html[data-dark-bg] .clarity-main::-webkit-scrollbar, html[data-dark-bg] .clarity-tab-content::-webkit-scrollbar { width: 0 !important; height: 0 !important; display: none !important; }

        /* ── Focus timer pulse ────────────────────────────────────── */
        @keyframes pulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(1.3); } }

        /* ── Habit completion animations (defined once here, not injected per
           instance/burst — injecting a <style> tag on each checkbox click forced
           a full-document style recalc, which made the petal burst stutter). ── */
        @keyframes petalFly {
          0%   { transform: translate(0,0) scale(1) rotate(0deg); opacity: 1; }
          70%  { opacity: 0.85; }
          100% { transform: translate(var(--ptx), var(--pty)) scale(0.1) rotate(var(--pr)); opacity: 0; }
        }
        @keyframes hcBounce {
          0%   { transform: scale(0.75); }
          45%  { transform: scale(1.2); }
          70%  { transform: scale(0.92); }
          100% { transform: scale(1); }
        }
        @keyframes mcBounce {
          0%   { transform: scale(0.75); }
          45%  { transform: scale(1.22); }
          70%  { transform: scale(0.93); }
          100% { transform: scale(1); }
        }

        /* ── Habits dashboard: categories + graphs beside habits on wide screens ── */
        .habits-cat-col { width: 100%; }
        .habits-graph-col { display: none; }
        .habits-add-menu { display: none; }
        .cat-cards-grid { grid-template-columns: 1fr 1fr; }
        @media (min-width: 1024px) {
          /* Side columns are quieted (saturation dialed back) so the middle To-Do column reads as the hero.
             Hover restores full color, so nothing feels permanently dimmed. Desktop-only — mobile untouched. */
          .habits-cat-col { width: 212px; flex-shrink: 0; position: sticky; top: 0; max-height: calc(100vh - 40px); overflow-y: auto; }
          /* Hide the redundant "Categories" header on desktop so the first card aligns with the To-Do panel */
          .habits-cat-col .cat-section-header { display: none !important; }
          /* Breathing room at the bottom so the last category card never looks cut off when scrolled */
          .habits-cat-col .cat-scroll { padding-bottom: 28px; }
          /* Quieting filter goes on the inner content, NOT the scrolling column — a filter on a
             scroll/overflow container leaves a faint 1px composited-layer seam at its clipped edge. */
          .habits-cat-col > div { filter: saturate(0.7); transition: filter 0.25s ease; }
          .habits-cat-col:hover > div { filter: saturate(1); }
          /* One category block per row on desktop (mobile Spaces tab keeps 2-up) */
          .habits-cat-col .cat-cards-grid { grid-template-columns: 1fr; }
          /* Same frosted-glass panel treatment as .habits-main-col (0.32 white wash) so both
             columns read as equally visible glass cards — a much lighter wash here previously
             let this column blend almost invisibly into the background gradient.
             transform: translateZ(0) forces its own GPU compositing layer immediately at
             layout time — without it, Chrome/WebKit has a known bug where backdrop-filter on
             a position:sticky element fails to composite on first paint and only kicks in
             after some later repaint (e.g. switching tabs and back forces the remount that
             "fixes" it). Forcing the layer up front avoids relying on that repaint. */
          .habits-graph-col { display: block; background: rgba(255,255,255,0.32); -webkit-backdrop-filter: blur(22px) saturate(160%); backdrop-filter: blur(22px) saturate(160%); border-radius: 22px; padding: 14px; box-shadow: 0 8px 30px rgba(180,100,140,0.08); transform: translateZ(0); -webkit-transform: translateZ(0); will-change: transform; }
          .habits-graph-col > div { filter: saturate(0.82); transition: filter 0.25s ease; }
          .habits-graph-col:hover > div { filter: saturate(1); }
          /* Force the white theme tokens to pure #fff inside the column so every inner box —
             individual habit cards, the Target Completion box, the Bar Graph box and the Habits
             History box — reads as a crisp solid-white surface against the gradient. */
          .habits-graph-col { --c-bg-card: #ffffff; --c-bg-soft: #ffffff; }
          /* Section wrappers default to a solid white card (this is the Habits History box). */
          .habits-graph-col .clarity-card { border: none !important; box-shadow: 0 4px 18px rgba(180,100,140,0.10) !important; padding: 14px 16px !important; background: #ffffff !important; }
          /* …except the Habit Tracker wrapper, which is frosted transparent so its individual
             habit cards / Target / Bar boxes float on the frosted glass with gradient around them. */
          .habits-graph-col .graph-section-frost { background: transparent !important; box-shadow: none !important; padding-left: 4px !important; padding-right: 4px !important; }
          /* The frosted Habit Tracker card's title + empty-state text sit directly on the
             gradient wallpaper (no white card behind them), so a soft theme-tinted colour
             washes out. Force near-black on light themes, white on the dark-gradient themes. */
          .habits-graph-col .graph-section-frost .clarity-card-title { color: #2a2030 !important; }
          .dusk-main .habits-graph-col .graph-section-frost .clarity-card-title,
          .purple-main .habits-graph-col .graph-section-frost .clarity-card-title,
          .velvet-main .habits-graph-col .graph-section-frost .clarity-card-title,
          .ocean-main .habits-graph-col .graph-section-frost .clarity-card-title,
          .glacier-main .habits-graph-col .graph-section-frost .clarity-card-title,
          .tide-main .habits-graph-col .graph-section-frost .clarity-card-title { color: #ffffff !important; }
          /* Hero: the middle To-Do column gets a soft (more transparent) elevated panel so it reads
             as the primary surface. Same sticky/max-height/overflow + backdrop-filter treatment as
             .habits-graph-col so both columns scroll independently at equal height, instead of this
             one growing with content and pushing the whole page to scroll. */
          .habits-main-col { background: rgba(255,255,255,0.32); -webkit-backdrop-filter: blur(22px) saturate(160%); backdrop-filter: blur(22px) saturate(160%); border-radius: 22px; padding: 18px; box-shadow: 0 8px 30px rgba(180,100,140,0.08); position: sticky; top: 0; max-height: calc(100vh - 40px); overflow-y: auto; transform: translateZ(0); -webkit-transform: translateZ(0); will-change: transform; }
          .habits-stats-btn { display: none !important; }
          .habits-add-menu { display: block; }
          .cat-add-btn-mobile { display: none !important; }
          .habit-fab-mobile { display: none !important; }
          /* Remove tinted/beveled border lines on dashboard cards & blocks (the pastel theme
             adds inset lavender/peach bevels via box-shadow — strip those, keep a soft drop shadow). */
          .habits-cat-col .clarity-row-item,
          .habits-main-col .clarity-row-item {
            border: none !important;
            box-shadow: 0 6px 20px rgba(150,110,175,0.10) !important;
          }
          .habits-graph-col .habit-track-card { border: none !important; }
          .habits-graph-col .graph-quicknav { border: none !important; }
          .habits-graph-col .graph-quicknav > button { border-right: none !important; }
          /* ── Planner: fix topbar alignment (was pinned to the old 96px sidebar) + curvier edges ── */
          .cal-topbar {
            left: 72px !important;
            right: 16px !important;
            padding-left: 16px !important;
            border: none !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            background: transparent !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }
          /* Hide the ☰ drawer button inside the topbar on desktop — it lives in the upper-left corner instead */
          .cal-topbar .cal-drawer-btn { display: none !important; }
          /* Inline category pills (Row 1, desktop): hide the scrollbar so it stays clean */
          .cal-pills-inline::-webkit-scrollbar { width: 0 !important; height: 0 !important; display: none !important; }
          .cal-week-card { border-radius: 22px !important; }
          /* ── Clock-In: uses the same single-column mobile layout on desktop too
             (cards kept, no two-column dashboard), so just constrain its width via
             the centered content wrapper. ── */
          /* Donut sized to match the timer ring box. */
          .focus-stats-col .focus-donut-svg { width: 210px !important; max-width: 210px !important; height: auto !important; }
          /* Icon-only nav: kill the hover pill and the active glow so only the Lucide icons show */
          .nav-btn:hover { background: transparent !important; }
          .nav-btn::after { display: none !important; }
          /* Hide the pink scrollbars on the dashboard side panels (and any inner scrollers).
             display:none alone can be overridden by the global ::-webkit-scrollbar width — match the
             app's proven hide pattern (width/height 0 + display none) and cover descendants. */
          .habits-cat-col, .habits-graph-col, .habits-main-col, .habits-cat-col *, .habits-graph-col *, .habits-main-col * { scrollbar-width: none !important; -ms-overflow-style: none !important; }
          .habits-cat-col::-webkit-scrollbar, .habits-graph-col::-webkit-scrollbar, .habits-main-col::-webkit-scrollbar, .habits-cat-col *::-webkit-scrollbar, .habits-graph-col *::-webkit-scrollbar, .habits-main-col *::-webkit-scrollbar { width: 0 !important; height: 0 !important; display: none !important; }
        }

        /* ── Responsive sidebar ───────────────────────────────────── */
        @media (max-width: 1023.98px) {
          /* The gap above the bar is 16px on the web, but native runs edge-to-edge
             and adds the gesture-bar inset on top of it, which floats the bar
             noticeably higher than it sits in a browser. Trim the constant on
             native only so it rides closer to the bottom; the --sab term stays so
             it still clears the system navigation buttons. */
          .clarity-sidebar { width: calc(100% - 40px) !important; height: 64px !important; flex-direction: row !important; top: auto !important; bottom: calc(${Capacitor.isNativePlatform() ? "4px" : "16px"} + var(--sab, 0px)) !important; left: 20px !important; border-right: none !important; border-top: none !important; border-radius: 999px !important; padding: 0 16px !important; justify-content: space-around !important; box-shadow: 0 4px 24px rgba(0,0,0,0.12), 0 1px 6px rgba(0,0,0,0.07) !important; background: #ffffff !important; }
          .clarity-main { margin-left: 0 !important; padding-bottom: calc(140px + var(--sab, 0px)) !important; overflow-x: hidden !important; max-width: 100vw !important; }
          .clarity-tab-content { padding-left: 10px !important; padding-right: 10px !important; box-sizing: border-box !important; }
          .cal-topbar { padding-left: 12px !important; left: 0 !important; }
          .cal-topbar-add-btn { display: none !important; }
          .cal-fab-mobile { display: flex !important; }
          .cal-fab-desktop { display: none !important; }
          .planner-view-toggle { flex-direction: row !important; margin-top: 0 !important; padding: 0 6px !important; display: none !important; }
          .planner-view-toggle > div { flex-direction: row !important; border-radius: 20px !important; padding: 3px !important; }
        }${GLASS_CARD_CSS}
`;

export default function ClarityApp() {
  // Desktop (≥1024px) gets the merged Dashboard; mobile keeps the original Spaces + Habits tabs untouched.
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(min-width: 1024px)");
    const handler = e => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  const [tab, setTab] = useState("habits");
  // A tab's content mount (Planner's calendar grid especially) is one big
  // synchronous commit. If the nav highlight rides in that same commit, the
  // tapped button can't light up until the whole new tab is built. So the
  // highlight (activeNavTab) commits first on its own, and the content swap
  // (setTab) runs after that frame has painted. Measured against
  // startTransition (which also gives an instant highlight): startTransition
  // made the calendar itself paint ~70ms later; this doesn't.
  const [activeNavTab, setActiveNavTab] = useState(tab);
  const pendingTabRef = useRef(null);
  // True only between a nav tap's highlight commit and its content swap; the
  // tab content is frozen meanwhile so the highlight commit stays cheap.
  const [navSwapPending, setNavSwapPending] = useState(false);
  const goToTab = (id) => {
    setNavSwapPending(true);
    setActiveNavTab(id);
    pendingTabRef.current = id;
    requestAnimationFrame(() => setTimeout(() => {
      if (pendingTabRef.current !== id) return; // a newer tap supersedes
      setNavSwapPending(false);
      setTab(id);
    }, 0));
  };
  // Every OTHER setTab call in this file (onboarding-finish fallbacks, the
  // Settings drawer's "New Note"/"Add New" shortcuts, etc.) sets tab directly
  // rather than going through goToTab, so this keeps activeNavTab from
  // drifting out of sync with tab whenever one of those fires instead.
  useEffect(() => { setActiveNavTab(tab); }, [tab]);
  // Habits is kept mounted (hidden) while another tab shows — see the content
  // render below. It still comes back fresh on every visit, like a remount
  // would: habitsGen re-keys it once the user has left, during idle time, so
  // that rebuild never sits between a tap and the tab appearing.
  const habitsKeptRef = useRef(false);
  if (tab === "habits") habitsKeptRef.current = true;
  const [habitsGen, setHabitsGen] = useState(0);
  const habitsActive = tab === "habits";
  useEffect(() => {
    if (habitsActive || !habitsKeptRef.current) return;
    stopAlarmSound(); // what Habits' own unmount cleanup used to do on leaving
    if (window.requestIdleCallback) {
      const id = window.requestIdleCallback(() => setHabitsGen(g => g + 1), { timeout: 1000 });
      return () => window.cancelIdleCallback(id);
    }
    const id = setTimeout(() => setHabitsGen(g => g + 1), 400);
    return () => clearTimeout(id);
  }, [habitsActive]);
  // Planner lingers (hidden, frozen) for a moment after you leave it; its
  // teardown then runs after the next tab has appeared and animated in,
  // instead of inside the tap. Coming straight back reuses it.
  const [prevTab, setPrevTab] = useState(tab);
  const [lingerCal, setLingerCal] = useState(false);
  if (prevTab !== tab) {
    setPrevTab(tab);
    setLingerCal(prevTab === "calendar");
  }
  useEffect(() => {
    if (!lingerCal) return;
    let idle = 0;
    const t = setTimeout(() => {
      idle = window.requestIdleCallback
        ? window.requestIdleCallback(() => setLingerCal(false), { timeout: 1000 })
        : setTimeout(() => setLingerCal(false), 0);
    }, 1200);
    return () => { clearTimeout(t); if (idle) (window.cancelIdleCallback || clearTimeout)(idle); };
  }, [lingerCal]);
  // Hides Planner's portalled UI (topbar, FABs, sheets — all wrapped in
  // [data-cal-portal]) the same frame Planner is hidden; see the CSS rule.
  React.useLayoutEffect(() => { document.documentElement.dataset.tab = tab; }, [tab]);
  // Habits' card slide is held for two frames after the tab is shown and only
  // then released, so it starts once the tab's first (heaviest) frame is on
  // screen. Started in the same frame, a slow phone could spend the whole
  // 0.24s animation on that one frame and the cards would just appear.
  const habitsWrapRef = useRef(null);
  React.useLayoutEffect(() => {
    const el = habitsWrapRef.current;
    if (!habitsActive || !el) return;
    el.classList.add("anim-hold");
    let r2 = 0;
    const r1 = requestAnimationFrame(() => { r2 = requestAnimationFrame(() => el.classList.remove("anim-hold")); });
    return () => { cancelAnimationFrame(r1); cancelAnimationFrame(r2); el.classList.remove("anim-hold"); };
  }, [habitsActive]);
  // If the viewport crosses into desktop while on the (now-removed) Spaces tab, fall back to the Dashboard.
  useEffect(() => { if (isDesktop && tab === "categories") setTab("habits"); }, [isDesktop, tab]);
  // ── Tab visibility — users can hide tabs from the nav (data is never touched,
  //    so toggling a tab back on restores everything). At least one tab must stay on.
  const [enabledTabs, setEnabledTabs] = useState(() => load("clarity_enabledTabs", {}));
  const toggleTab = (id) => setEnabledTabs(prev => {
    const allIds = isDesktop
      ? ["habits", "calendar", "focus", "journal"]
      : ["habits", "calendar", "focus", "journal", "categories"];
    const turningOff = prev[id] !== false;
    if (turningOff && allIds.filter(i => prev[i] !== false).length <= 1) return prev;
    const next = { ...prev, [id]: prev[id] === false ? true : false };
    save("clarity_enabledTabs", next);
    return next;
  });
  // If the currently-open tab gets hidden, fall back to the first tab that's still enabled.
  useEffect(() => {
    if (enabledTabs[tab] !== false) return;
    const allIds = isDesktop
      ? ["habits", "calendar", "focus", "journal"]
      : ["habits", "calendar", "focus", "journal", "categories"];
    const fallback = allIds.find(i => enabledTabs[i] !== false);
    if (fallback) setTab(fallback);
  }, [enabledTabs, tab, isDesktop]);
  // ── Tab order — long-press a nav tab to drag-reorder it (SortableTabButton
  //    above). A list of tab ids in display order; ids not in it (a tab that
  //    didn't exist yet when this was saved) sort to the end, in their
  //    default order. Reordering only touches whichever tabs are visible
  //    right now — a hidden tab keeps its old spot in the list for whenever
  //    it's turned back on.
  const [tabOrder, setTabOrder] = useState(() => load("clarity_tabOrder", null));
  const orderTabs = (list, order) => {
    if (!order || !order.length) return list;
    const byId = new Map(list.map(t => [t.id, t]));
    const ordered = order.map(id => byId.get(id)).filter(Boolean);
    const remaining = list.filter(t => !order.includes(t.id));
    return [...ordered, ...remaining];
  };
  const tabDndSensors = useSensors(useSensor(PointerSensor, { activationConstraint: { delay: 260, tolerance: 6 } }));
  const handleTabDragEnd = (visibleTabs, allTabs) => (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const ids = visibleTabs.map(t => t.id);
    const oldIndex = ids.indexOf(active.id);
    const newIndex = ids.indexOf(over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const reordered = arrayMove(ids, oldIndex, newIndex);
    const hiddenIds = allTabs.map(t => t.id).filter(id => !ids.includes(id));
    const next = [...reordered, ...hiddenIds];
    setTabOrder(next);
    save("clarity_tabOrder", next);
  };
  // Mobile-only alternate nav: a corner dial you press-drag or tap to switch tabs,
  // instead of the bottom bar (src/components/RadialTabDial.jsx). Hidden from
  // Settings for now (pending a decision on whether to bring it back), so this
  // is hard-coded to "bar" rather than read from storage.
  const navStyle = "bar";
  const [showBackToTop, setShowBackToTop] = useState(false);
  React.useEffect(() => {
    const el = document.querySelector(".clarity-main");
    if (!el) return;
    const onScroll = () => setShowBackToTop(el.scrollTop > 300);
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  // weekBlockPop + editModal lifted to App root — escapes CalendarTab stacking contexts
  const [weekBlockPop, setWeekBlockPop] = useState(null);
  const closeWeekBlockPop = () => setWeekBlockPop(null);
  const [appEditModal, setAppEditModal] = useState(null); // { item, type, form }
  // Planner is frozen while this is open (see the tab Freeze), so its own
  // externalPanelOpen prop can't hide the list "+" button; CSS does instead.
  React.useLayoutEffect(() => {
    const el = document.documentElement;
    if (appEditModal) el.setAttribute("data-app-edit", "");
    else el.removeAttribute("data-app-edit");
  }, [!!appEditModal]); // eslint-disable-line react-hooks/exhaustive-deps
  const closeAppEditModal = () => setAppEditModal(null);
  const [pendingHabitEditId, setPendingHabitEditId] = useState(null); // habit id queued for editing after tab-switch (from Clock-In queue)
  const [appHabitEdit, setAppHabitEdit] = useState(null); // { id, form } — in-place habit editor (opened from Clock-In queue, no tab change)
  const [showNewCatInAppHabitEdit, setShowNewCatInAppHabitEdit] = useState(false); // inline "+ New category" in that editor
  const saveAppHabitEdit = () => {
    const prevHabit = habits.find(h => h.id === appHabitEdit?.id);
    const fm = appHabitEdit?.form && cleanHabitForm(appHabitEdit.form, prevHabit);
    if (!fm?.name?.trim()) return;
    const catColor = categories.find(c => c.id === fm.goalId)?.color || "#d4789a";
    const budget = fm.allowanceMode && fm.habitType === "limited";
    setHabits(p => p.map(h => h.id === appHabitEdit.id ? { ...h, ...fm, allowanceMode: budget ? fm.allowanceMode : "", attemptLog: h.attemptLog || [], color: catColor, ...(fm.addToClockIn ? { clockInRestoreDate: undefined } : {}) } : h));
    setAppHabitEdit(null);
  };
  const [primaryColor, setPrimaryColor] = useState(() => {
    // Migrate: older builds stored a theme key in clarity_appTheme (also a hex).
    const saved = load("clarity_primaryColor", null) || load("clarity_appTheme", null);
    return (typeof saved === "string" && saved.startsWith("#")) ? saved : DEFAULT_PRIMARY;
  });
  useEffect(() => { save("clarity_primaryColor", primaryColor); }, [primaryColor]);
  // The Default theme ("none") has no background gradient to lean on like every other
  // theme, so its own accent is user-pickable (a pastel swatch grid in Settings) instead
  // of the fixed pink it shared with Pastel. Kept separate from primaryColor so
  // re-selecting Default restores this instead of resetting to the shared default.
  const [defaultAccent, setDefaultAccent] = useState(() => load("clarity_defaultAccent", DEFAULT_PRIMARY));
  useEffect(() => { save("clarity_defaultAccent", defaultAccent); }, [defaultAccent]);
  // Dark mode (Jade, 2026-10-17). darkPref: "off" | "on" (a stored "auto" from the
  // removed "Match phone" switch reads as off).
  // It sits ON TOP of the Background choice: while dark is showing, the gradient
  // flags below read as off (their saved values are untouched, so turning dark off
  // brings the chosen background back), and the accent is the Default accent.
  const [darkPref, setDarkPref] = useState(() => load("clarity_darkMode", "off"));
  useEffect(() => { save("clarity_darkMode", darkPref); }, [darkPref]);
  const darkActive = darkPref === "on";
  const T = useMemo(() => darkActive ? makeDarkTheme(defaultAccent, "dark") : makeTheme(primaryColor), [darkActive, defaultAccent, primaryColor]);
  const [peachModeRaw, setPeachMode] = useState(() => load("clarity_peachMode", false));
  useEffect(() => { save("clarity_peachMode", peachModeRaw); }, [peachModeRaw]);
  const [purpleModeRaw, setPurpleMode] = useState(() => load("clarity_purpleMode", false));
  useEffect(() => { save("clarity_purpleMode", purpleModeRaw); }, [purpleModeRaw]);
  const [mochaModeRaw, setMochaMode] = useState(() => load("clarity_mochaMode", false));
  useEffect(() => { save("clarity_mochaMode", mochaModeRaw); }, [mochaModeRaw]);
  const [duskModeRaw, setDuskMode] = useState(() => load("clarity_duskMode", false));
  useEffect(() => { save("clarity_duskMode", duskModeRaw); }, [duskModeRaw]);
  const [auroraModeRaw, setAuroraMode] = useState(() => load("clarity_auroraMode", false));
  useEffect(() => { save("clarity_auroraMode", auroraModeRaw); }, [auroraModeRaw]);
  const [lilacModeRaw, setLilacMode] = useState(() => load("clarity_lilacMode", false));
  useEffect(() => { save("clarity_lilacMode", lilacModeRaw); }, [lilacModeRaw]);
  const [velvetModeRaw, setVelvetMode] = useState(() => load("clarity_velvetMode", false));
  useEffect(() => { save("clarity_velvetMode", velvetModeRaw); }, [velvetModeRaw]);
  const [lagoonModeRaw, setLagoonMode] = useState(() => load("clarity_lagoonMode", false));
  useEffect(() => { save("clarity_lagoonMode", lagoonModeRaw); }, [lagoonModeRaw]);
  const [cloudModeRaw, setCloudMode] = useState(() => load("clarity_cloudMode", false));
  useEffect(() => { save("clarity_cloudMode", cloudModeRaw); }, [cloudModeRaw]);
  const [oceanModeRaw, setOceanMode] = useState(() => load("clarity_oceanMode", false));
  useEffect(() => { save("clarity_oceanMode", oceanModeRaw); }, [oceanModeRaw]);
  const [frostModeRaw, setFrostMode] = useState(() => load("clarity_frostMode", false));
  useEffect(() => { save("clarity_frostMode", frostModeRaw); }, [frostModeRaw]);
  const [sandModeRaw, setSandMode] = useState(() => load("clarity_sandMode", false));
  useEffect(() => { save("clarity_sandMode", sandModeRaw); }, [sandModeRaw]);
  const [mistModeRaw, setMistMode] = useState(() => load("clarity_mistMode", false));
  useEffect(() => { save("clarity_mistMode", mistModeRaw); }, [mistModeRaw]);
  // Warm the purchase page's first open (Intl data + font weights) once the
  // app has settled, so the first Upgrade tap's fade-in isn't eaten by it.
  useEffect(() => {
    const t = setTimeout(() => {
      if (window.requestIdleCallback) window.requestIdleCallback(warmPremiumPage, { timeout: 3000 });
      else warmPremiumPage();
    }, 2500);
    return () => clearTimeout(t);
  }, []);
  const [opalModeRaw, setOpalMode] = useState(() => load("clarity_opalMode", false));
  useEffect(() => { save("clarity_opalMode", opalModeRaw); }, [opalModeRaw]);
  const [bloomModeRaw, setBloomMode] = useState(() => load("clarity_bloomMode", false));
  useEffect(() => { save("clarity_bloomMode", bloomModeRaw); }, [bloomModeRaw]);
  const [terraModeRaw, setTerraMode] = useState(() => load("clarity_terraMode", false));
  useEffect(() => { save("clarity_terraMode", terraModeRaw); }, [terraModeRaw]);
  const [glacierModeRaw, setGlacierMode] = useState(() => load("clarity_glacierMode", false));
  useEffect(() => { save("clarity_glacierMode", glacierModeRaw); }, [glacierModeRaw]);
  const [shoreModeRaw, setShoreMode] = useState(() => load("clarity_shoreMode", false));
  useEffect(() => { save("clarity_shoreMode", shoreModeRaw); }, [shoreModeRaw]);
  const [tideModeRaw, setTideMode] = useState(() => load("clarity_tideMode", false));
  useEffect(() => { save("clarity_tideMode", tideModeRaw); }, [tideModeRaw]);
  const [pastelModeRaw, setPastelMode] = useState(() => load("clarity_pastelMode", false));
  useEffect(() => { save("clarity_pastelMode", pastelModeRaw); }, [pastelModeRaw]);
  // Steel theme was removed from the picker — force any previously-saved
  // selection back to false so those users fall back to Default on load.
  const [masculineModeRaw, setMasculineMode] = useState(() => false);
  useEffect(() => { save("clarity_masculineMode", masculineModeRaw); }, [masculineModeRaw]);
  // What's on screen: every gradient reads as off while dark mode is showing.
  const peachMode = peachModeRaw && !darkActive;
  const purpleMode = purpleModeRaw && !darkActive;
  const mochaMode = mochaModeRaw && !darkActive;
  const duskMode = duskModeRaw && !darkActive;
  const auroraMode = auroraModeRaw && !darkActive;
  const lilacMode = lilacModeRaw && !darkActive;
  const velvetMode = velvetModeRaw && !darkActive;
  const lagoonMode = lagoonModeRaw && !darkActive;
  const cloudMode = cloudModeRaw && !darkActive;
  const oceanMode = oceanModeRaw && !darkActive;
  const frostMode = frostModeRaw && !darkActive;
  const sandMode = sandModeRaw && !darkActive;
  const mistMode = mistModeRaw && !darkActive;
  const opalMode = opalModeRaw && !darkActive;
  const bloomMode = bloomModeRaw && !darkActive;
  const terraMode = terraModeRaw && !darkActive;
  const glacierMode = glacierModeRaw && !darkActive;
  const shoreMode = shoreModeRaw && !darkActive;
  const tideMode = tideModeRaw && !darkActive;
  const pastelMode = pastelModeRaw && !darkActive;
  const masculineMode = masculineModeRaw && !darkActive;
  // The saved light choice, for the Settings picker (unaffected by dark mode).
  const savedBgTheme = bloomModeRaw ? "bloom" : opalModeRaw ? "opal" : tideModeRaw ? "tide" : shoreModeRaw ? "shore" : glacierModeRaw ? "glacier" : terraModeRaw ? "terra" : mistModeRaw ? "mist" : sandModeRaw ? "sand" : frostModeRaw ? "frost" : oceanModeRaw ? "ocean" : cloudModeRaw ? "cloud" : lagoonModeRaw ? "lagoon" : velvetModeRaw ? "velvet" : lilacModeRaw ? "lilac" : auroraModeRaw ? "aurora" : duskModeRaw ? "dusk" : mochaModeRaw ? "mocha" : purpleModeRaw ? "purple" : peachModeRaw ? "peach" : pastelModeRaw ? "pastel" : "none";
  // App background themes are mutually exclusive — picking one clears the others.
  const bgTheme = bloomMode ? "bloom" : opalMode ? "opal" : tideMode ? "tide" : shoreMode ? "shore" : glacierMode ? "glacier" : terraMode ? "terra" : mistMode ? "mist" : sandMode ? "sand" : frostMode ? "frost" : oceanMode ? "ocean" : cloudMode ? "cloud" : lagoonMode ? "lagoon" : velvetMode ? "velvet" : lilacMode ? "lilac" : auroraMode ? "aurora" : duskMode ? "dusk" : mochaMode ? "mocha" : purpleMode ? "purple" : peachMode ? "peach" : pastelMode ? "pastel" : masculineMode ? "masculine" : "none";
  const selectBgTheme = (id) => {
    // Picking a light background turns dark mode off.
    if (darkPref !== "off") setDarkPref("off");
    setBloomMode(id === "bloom");
    setOpalMode(id === "opal");
    setTideMode(id === "tide");
    setShoreMode(id === "shore");
    setGlacierMode(id === "glacier");
    setTerraMode(id === "terra");
    setMistMode(id === "mist");
    setSandMode(id === "sand");
    setFrostMode(id === "frost");
    setOceanMode(id === "ocean");
    setCloudMode(id === "cloud");
    setLagoonMode(id === "lagoon");
    setVelvetMode(id === "velvet");
    setLilacMode(id === "lilac");
    setAuroraMode(id === "aurora");
    setDuskMode(id === "dusk");
    setMochaMode(id === "mocha");
    setPurpleMode(id === "purple");
    setPeachMode(id === "peach");
    setPastelMode(id === "pastel");
    setMasculineMode(id === "masculine");
    // The chosen theme drives the app's primary accent colour. Default has no
    // gradient of its own to lean on, so it uses whatever pastel the user last
    // picked for it (see selectDefaultAccent) instead of a fixed shared pink —
    // deepened just enough that light picks stay visible on the white canvas.
    const hex = id === "none" ? deepenAccent(defaultAccent) : themePrimary(id);
    setPrimaryColor(hex);
    save("clarity_primaryColor", hex);
  };
  // A gradient background's accent is fixed by the background itself, so derive
  // it rather than trust the separately stored clarity_primaryColor. The two are
  // separate synced keys (one per theme flag, plus the colour), and an account
  // switch — wipe, pull the other account, wipe, pull back — could restore the
  // background without its colour: Peach with a purple accent until the
  // background was re-picked (Jade, 2026-10-06). Default ("none") keeps its own
  // user-picked accent; themes not in the picker are left alone.
  React.useLayoutEffect(() => {
    if (bgTheme === "none" || !APP_THEME_OPTIONS.some(o => o.id === bgTheme)) return;
    const want = themePrimary(bgTheme);
    if (primaryColor !== want) setPrimaryColor(want);
  }, [bgTheme, primaryColor]);
  // Premium backgrounds (`premium: true` in colorEngine's APP_THEME_OPTIONS)
  // only stay on while the account is Premium. The picker in Settings locks
  // them, but a choice made while Premium (or synced in from another account's
  // data) would otherwise stay on for good after a lapse. Waits for
  // usePremium's loading so a paying user is never reset during sign-in.
  const { isPremium, loading: premiumLoading } = usePremium();
  useEffect(() => {
    if (premiumLoading || isPremium) return;
    if (APP_THEME_OPTIONS.some(o => o.id === savedBgTheme && o.premium)) selectBgTheme("none");
  }, [premiumLoading, isPremium, savedBgTheme]); // eslint-disable-line react-hooks/exhaustive-deps
  // Dark backgrounds (Dusk, Purple, Velvet, Ocean, Glacier, Tide) hide the main
  // screen's own scrollbar: the accent-coloured 4px bar read as a stray line
  // against them. Only the page-level scroller — inner containers keep theirs.
  // Scrolling itself is unchanged. See the `html[data-dark-bg]` rule in the CSS.
  React.useLayoutEffect(() => {
    const root = document.documentElement;
    if (DARK_BG_THEMES.has(bgTheme) || darkActive) root.setAttribute("data-dark-bg", "");
    else root.removeAttribute("data-dark-bg");
  }, [bgTheme, darkActive]);
  // Sets the Default theme's own accent (swatch grid in Settings, shown only when
  // Default is the active theme) — separate from selectBgTheme since it doesn't
  // change which theme is active, just Default's own colour. defaultAccent stores the
  // raw pastel (for the swatch's selected state); the applied primary is deepened so
  // the light pastels don't wash out the app's lines/icons/buttons.
  const selectDefaultAccent = (hex) => {
    setDefaultAccent(hex);
    save("clarity_defaultAccent", hex);
    if (savedBgTheme === "none") { const applied = deepenAccent(hex); setPrimaryColor(applied); save("clarity_primaryColor", applied); }
  };
  // Settings → Background: the Dark card.
  const selectDark = () => setDarkPref("on");
  // html[data-dark] drives the dark-mode CSS (catch-alls for colours written
  // straight into components) and color-scheme (native inputs, scrollbars).
  React.useLayoutEffect(() => {
    const root = document.documentElement;
    if (darkActive) root.setAttribute("data-dark", "dark"); else root.removeAttribute("data-dark");
  }, [darkActive]);
  const [categories, setCategories] = useState(() => {
    const saved = load("clarity_categories", null);
    if (saved !== null) {
      // Trust whatever the user has saved — suggestions they added are real categories
      return saved;
    }
    const oldGoals = load("clarity_goals", null);
    if (oldGoals !== null) {
      return oldGoals.map(g => ({ ...g, title: g.name || g.title, isGoal: true, goalDescription: g.description || "" }));
    }
    return [];
  });
  const [deletedHabits, setDeletedHabits] = useState(() => load("clarity_deletedHabits", {}));
  const [habits, setHabits] = useState(() => {
    const raw = load("clarity_habits", []);
    // Drop any habit that's been tombstoned (deleted on this or another device).
    // The cloud blob for clarity_habits can momentarily still contain a deleted
    // habit after a "remote wins" merge; the tombstone is the source of truth for
    // deletions, so we always filter against it on load.
    const tombstones = load("clarity_deletedHabits", {});
    const alive = (arr) => arr.filter(h => !(h.id in tombstones));
    // Migration v3: clear quitDate from non-nottodo habits AND fix ISO createdAt timezone issue
    // Save directly to localStorage so it persists immediately on first render
    if (!localStorage.getItem("clarity_migration_v3")) {
      const cleaned = alive(raw).map(h => {
        const fixed = { ...h };
        // Clear quitDate for non-nottodo habits
        if (h.habitType !== "nottodo") fixed.quitDate = "";
        // Fix createdAt: if full ISO string, convert to local YYYY-MM-DD
        if (fixed.createdAt && fixed.createdAt.length > 10) {
          const d = new Date(fixed.createdAt);
          fixed.createdAt = d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0") + "-" + String(d.getDate()).padStart(2,"0");
        }
        return fixed;
      });
      localStorage.setItem("clarity_habits", JSON.stringify(cleaned));
      localStorage.setItem("clarity_migration_v3", "done");
      return migrateTimeRestricted(cleaned);
    }
    return migrateTimeRestricted(alive(raw));
  });
  const [habitLogs, setHabitLogs] = useState(() => load("clarity_habitLogs", {}));
  const [habitSkips, setHabitSkips] = useState(() => load("clarity_habitSkips", []));
  // cleanLog: { [dateStr]: [habitId, ...] } — nottodo habits explicitly confirmed clean that day
  const [cleanLog, setCleanLog] = useState(() => load("clarity_cleanLog", {}));
  const [tasks, setTasks] = useState(() => load("clarity_tasks", []));
  const [taskOccurrenceOverrides, setTaskOccurrenceOverrides] = useState(() => load("clarity_taskOccOverrides", {}));
  const [calEventOccurrenceOverrides, setCalEventOccurrenceOverrides] = useState(() => load("clarity_calEventOccOverrides", {}));
  const [focusSessions, setFocusSessions] = useState(() => load("clarity_focusSessions", []));
  const [calEvents, setCalEvents] = useState(() => load("clarity_calEvents", []));
  const [calReminders, setCalReminders] = useState(() => load("clarity_calReminders", []));
  const [diary, setDiary] = useState(() => load("clarity_diary", {}));
  // Live cross-device sync (no reload): sync.js dispatches this event right
  // after a remote change to a LIVE_PATCH_KEYS key lands in localStorage, so
  // the owning feature can pick it up immediately instead of only on next
  // reload. Each key here is safe to apply directly to state because nothing
  // buffers an in-progress edit to it outside of state + the debounced push
  // queue that sync.js itself already protects (see `pending`/`inFlight` in
  // sync.js — a key with a local edit still queued is never overwritten by a
  // remote snapshot in the first place, so there's nothing extra to guard
  // here):
  //  - clarity_diary: the note editor's live text lives only in the DOM while
  //    a note is open (see JournalTab's editor-fill effect) and only gets
  //    written into this state on its own ~2s autosave, so a remote update
  //    here can't stomp an in-progress keystroke.
  //  - clarity_habits / clarity_deletedHabits: HabitsTab's add/edit modal
  //    edits a local form buffer and only merges it into `habits` on Save
  //    (via a functional setHabits update), so it always merges onto
  //    whatever the latest — possibly just-arrived-remotely — array is.
  //  - clarity_habitLogs / clarity_habitSkips / clarity_cleanLog: checkbox
  //    toggles and skip/clean confirmations write synchronously, no debounce
  //    buffer to clobber.
  //  - clarity_calEvents / clarity_tasks / clarity_calReminders / occurrence
  //    overrides: CalendarTab's drag, resize, and "draw to create" gestures
  //    all keep their live ghost position in local UI state (dragPos/dragSnap/
  //    resizeItem/weekDrawState) and only call setCalEvents/setTasks/etc. once,
  //    on release — and that commit always spreads onto the LATEST item from
  //    the functional-update array (`p.map(x => x.id === id ? {...x, ...moved}
  //    : x)`), not a stale drag-start snapshot, so it can never revert a
  //    concurrent remote edit to the same item. The edit modal's Save follows
  //    the same latest-state-merge pattern. Deletion here is a plain array
  //    filter (no tombstone map like habits has), so a remote delete just
  //    removes the item directly — nothing extra to coordinate.
  //  - clarity_focusSessions: completed session history only, a plain
  //    append-only array like calEvents. The actively-running countdown timer
  //    itself is deliberately excluded — see LIVE_PATCH_KEYS in sync.js.
  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      if ('clarity_diary' in detail) {
        try { setDiary(JSON.parse(detail.clarity_diary || '{}') || {}); } catch {}
      }
      if ('clarity_habits' in detail) {
        try { setHabits(migrateTimeRestricted(JSON.parse(detail.clarity_habits || '[]') || [])); } catch {}
      }
      if ('clarity_deletedHabits' in detail) {
        try { setDeletedHabits(JSON.parse(detail.clarity_deletedHabits || '{}') || {}); } catch {}
      }
      if ('clarity_habitLogs' in detail) {
        try { setHabitLogs(JSON.parse(detail.clarity_habitLogs || '{}') || {}); } catch {}
      }
      if ('clarity_habitSkips' in detail) {
        try { setHabitSkips(JSON.parse(detail.clarity_habitSkips || '[]') || []); } catch {}
      }
      if ('clarity_cleanLog' in detail) {
        try { setCleanLog(JSON.parse(detail.clarity_cleanLog || '{}') || {}); } catch {}
      }
      if ('clarity_calEvents' in detail) {
        try { setCalEvents(JSON.parse(detail.clarity_calEvents || '[]') || []); } catch {}
      }
      if ('clarity_tasks' in detail) {
        try { setTasks(JSON.parse(detail.clarity_tasks || '[]') || []); } catch {}
      }
      if ('clarity_calReminders' in detail) {
        try { setCalReminders(JSON.parse(detail.clarity_calReminders || '[]') || []); } catch {}
      }
      if ('clarity_taskOccOverrides' in detail) {
        try { setTaskOccurrenceOverrides(JSON.parse(detail.clarity_taskOccOverrides || '{}') || {}); } catch {}
      }
      if ('clarity_calEventOccOverrides' in detail) {
        try { setCalEventOccurrenceOverrides(JSON.parse(detail.clarity_calEventOccOverrides || '{}') || {}); } catch {}
      }
      if ('clarity_focusSessions' in detail) {
        try { setFocusSessions(JSON.parse(detail.clarity_focusSessions || '[]') || []); } catch {}
      }
    };
    window.addEventListener('clarity:remote-update', handler);
    // Another tab of the app saved Planner data. The cloud listener can't tell
    // this tab (the shared localStorage already holds the new value, so it sees
    // no change), and a tab left on old data would undo the other tab's edits on
    // its next save; with Google Calendar it even deleted the new event there.
    // A removed key (sign-out wipe) is ignored, never applied as "empty".
    const onStorage = (e) => {
      if (e.storageArea !== window.localStorage || e.newValue == null || !CROSS_TAB_KEYS.has(e.key)) return;
      handler({ detail: { [e.key]: e.newValue } });
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('clarity:remote-update', handler);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  const [plannerView, setPlannerViewState] = useState(() => load("clarity_plannerView", "calendar")); // "calendar" | "list"
  const setPlannerView = (v) => { setPlannerViewState(v); save("clarity_plannerView", v); };
  // NOTE: listSubTab moved into CalendarTab — keeping it at the app root made the
  // Upcoming/Finished/Missed buttons re-render the entire app (sidebar, style block,
  // split-view week grid) on every tap. It's only ever used inside the planner.
  const [savedColors, setSavedColors] = useState(() => {
    try { return JSON.parse(localStorage.getItem("clarity_savedColors") || "[]"); } catch { return []; }
  });
  const addSavedColor = (hex) => {
    setSavedColors(prev => {
      const next = [hex, ...prev.filter(c => c !== hex)].slice(0, 16);
      localStorage.setItem("clarity_savedColors", JSON.stringify(next));
      return next;
    });
  };
  const [focusTimerState, setFocusTimerState] = useState(null);
  const [journalSearchSlot, setJournalSearchSlot] = useState(null); // DOM node in the mobile top bar that JournalTab portals its search bar into
  const [focusTopSlot, setFocusTopSlot] = useState(null); // DOM node in the mobile top bar that FocusTab portals its Select / Chart / ⋯ buttons into
  // Lifted (rather than kept local to SettingsPanel) so the Planner's week/month
  // grid can actually react to it — it used to be saved but never read anywhere.
  const [weekStart, setWeekStartState] = useState(() => load("clarity_weekStart", "sunday"));
  const saveWeekStart = (w) => { setWeekStartState(w); save("clarity_weekStart", w); };
  // Planner calendar grid surface (Jade, 2026-10-15): "match" (the default, so a
  // new install blends with its background) = no surface, only the grid lines over
  // the background; "white" = the white card. Drives the --c-cal-* variables below
  // and html[data-cal-grid] (CalendarTab's CSS).
  const [calGridSurface, setCalGridSurfaceState] = useState(() => load("clarity_calGridSurface", "match") === "white" ? "white" : "match");
  const saveCalGridSurface = (v) => { setCalGridSurfaceState(v); save("clarity_calGridSurface", v); };
  const calGridMatch = calGridSurface === "match";
  // On a dark background a matched grid has white lines and text (Jade, 2026-10-15).
  const calGridDark = calGridMatch && DARK_BG_THEMES.has(bgTheme);
  React.useLayoutEffect(() => { document.documentElement.dataset.calGrid = calGridMatch ? "match" : "white"; }, [calGridMatch]);
  // Which hour (0-23) the Day/Week timeline grid's first row represents —
  // defaults to midnight so anyone who hasn't set this sees the grid exactly
  // as before. Same lift-to-App pattern as weekStart above.
  const [dayStartHour, setDayStartHourState] = useState(() => load("clarity_dayStartHour", 0));
  const saveDayStartHour = (h) => { setDayStartHourState(h); save("clarity_dayStartHour", h); };
  const { canInstall, promptInstall } = useInstallPrompt();
  const { browserName: inAppBrowserName } = useInAppBrowser();
  const [inAppBannerDismissed, setInAppBannerDismissed] = useState(false);
  // Coming back from a web checkout (PayMongo / Lemon Squeezy send you to
  // /?upgrade=success or cancel) lands on Settings, where the Premium row shows
  // the result (Jade, 2026-10-28). PremiumRow reads and clears the parameter.
  const [settingsOpen, setSettingsOpen] = useState(() => {
    try { return new URLSearchParams(window.location.search).has("upgrade"); } catch { return false; }
  });
  const [widgetGateOpen, setWidgetGateOpen] = useState(false); // a locked widget was tapped
  // Set right before opening Settings to have it land already expanded/
  // scrolled to a specific row (e.g. Clock-In's "Open Settings" link on the
  // App Blocker toggle) instead of the drawer's default collapsed state.
  // Cleared on close so a normal open (hamburger/menu) doesn't inherit it.
  const [settingsInitialSection, setSettingsInitialSection] = useState(null);
  // ── Onboarding quiz + coach mark tour (draft) — flags live in localStorage
  //    via onboardingStorage.js. ──
  const [onboardingDone, setOnboardingDone] = useState(() => isOnboardingDone());
  const [tourActive, setTourActive] = useState(false);
  // Reactive mirror of the main tour's "done" flag. The per-tab tours below all
  // wait on it, and they need it as STATE, not as a live isTourDone() read:
  // a localStorage read only re-evaluates when some *other* dependency happens
  // to change, so a per-tab effect that ran a moment too early (while the main
  // tour was still going) would sit on that stale "not done yet" answer and
  // never open its tour, even once the main tour had finished.
  const [tourDone, setTourDone] = useState(() => isTourDone());
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const finishMainTour = useCallback(() => {
    markTourDone();
    setTourDone(true);
    setTourActive(false);
  }, []);
  useEffect(() => {
    if (onboardingDone && !isTourDone()) setTourActive(true);
  }, [onboardingDone]);
  // The main tour only ever points at Habits-tab UI (the nav bar, the + button,
  // the new-habit form's type toggle), so it cannot carry on anywhere else. The
  // user can only *get* anywhere else while it's waiting on a target it hasn't
  // found yet — the one state in which it deliberately renders nothing at all —
  // so arriving on another tab means it's effectively over. End it here rather
  // than leaving it nominally active: until it ends, every per-tab tour below is
  // held behind it, which is what made a tab's guide fail to appear the first
  // time it was opened and then show up on a later visit.
  useEffect(() => {
    if (tourActive && tab !== "habits") finishMainTour();
  }, [tab, tourActive, finishMainTour]);
  // Per-tab tours (Planner, Clock-In) — each fires once, the first time the
  // user opens that tab (and only once the main tour is out of the way, so
  // the two never overlap).
  //
  // Gated on the `tourDone` STATE rather than on `!tourActive` or a live
  // isTourDone() call. `!tourActive` is wrong because the moment onboardingDone
  // flips true, these effects and the main tour's own trigger effect all react
  // to that same change in one batch, and these would still see the pre-update
  // `tourActive === false` — so a user already sitting on e.g. the Planner tab
  // when onboarding finished got that tab's tour AND the main tour stacked on
  // top of each other. A live isTourDone() read fixes that but introduces the
  // opposite failure: it isn't reactive, so an effect that ran while the main
  // tour was still going would keep that stale answer until some unrelated
  // dependency changed. `tourDone` is set in the same breath as markTourDone(),
  // so it is both correct at onboarding time and re-triggers these the instant
  // the main tour actually ends.
  const [plannerTourActive, setPlannerTourActive] = useState(false);
  const [clockInTourActive, setClockInTourActive] = useState(false);
  // The later Planner tour (List view + Week lock) starts once the first one is
  // done — including the moment it finishes, hence plannerTourActive in deps.
  const [plannerExtrasTourActive, setPlannerExtrasTourActive] = useState(false);
  useEffect(() => {
    if (tab === "calendar" && !isDesktop && onboardingDone && tourDone && !plannerTourActive && isPlannerTourDone() && !isPlannerExtrasTourDone()) setPlannerExtrasTourActive(true);
    else if (tab !== "calendar") setPlannerExtrasTourActive(false);
  }, [tab, isDesktop, onboardingDone, tourDone, plannerTourActive]);
  useEffect(() => {
    if (tab === "calendar" && onboardingDone && tourDone && !isPlannerTourDone()) setPlannerTourActive(true);
    else if (tab !== "calendar") setPlannerTourActive(false);
  }, [tab, onboardingDone, tourDone]);
  useEffect(() => {
    if (tab === "focus" && onboardingDone && tourDone && !isClockInTourDone()) setClockInTourActive(true);
    else if (tab !== "focus") setClockInTourActive(false);
  }, [tab, onboardingDone, tourDone]);
  // The Clock-In Chart page tour starts once the first Clock-In tour is done,
  // including the moment it finishes (hence clockInTourActive in deps).
  const [clockInChartTourActive, setClockInChartTourActive] = useState(false);
  useEffect(() => {
    if (tab === "focus" && onboardingDone && tourDone && !clockInTourActive && isClockInTourDone() && !isClockInChartTourDone()) setClockInChartTourActive(true);
    else if (tab !== "focus") setClockInChartTourActive(false);
  }, [tab, onboardingDone, tourDone, clockInTourActive]);
  // Restricted habit chip guides: once each, on the Habits tab, as soon as the user
  // has a Full Stop / day-based Limited habit (the chip's only shown for those).
  // Full Stop's runs first when both apply (hence fullStopTourActive in deps).
  const hasFullStop = habits.some(h => h.habitType === "nottodo");
  const hasLimitedShield = habits.some(h => h.habitType === "limited" && !h.allowanceMode);
  const [fullStopTourActive, setFullStopTourActive] = useState(false);
  const [limitedTourActive, setLimitedTourActive] = useState(false);
  useEffect(() => {
    if (tab === "habits" && onboardingDone && tourDone && !tourActive && hasFullStop && !isFullStopTourDone()) setFullStopTourActive(true);
    else if (tab !== "habits" || !hasFullStop) setFullStopTourActive(false);
  }, [tab, onboardingDone, tourDone, tourActive, hasFullStop]);
  useEffect(() => {
    if (tab === "habits" && onboardingDone && tourDone && !tourActive && !fullStopTourActive && hasLimitedShield && !isLimitedTourDone()) setLimitedTourActive(true);
    else if (tab !== "habits" || !hasLimitedShield) setLimitedTourActive(false);
  }, [tab, onboardingDone, tourDone, tourActive, fullStopTourActive, hasLimitedShield]);
  const [journalTourActive, setJournalTourActive] = useState(false);
  const [spacesTourActive, setSpacesTourActive] = useState(false);
  useEffect(() => {
    if (tab === "journal" && onboardingDone && tourDone && !isJournalTourDone()) setJournalTourActive(true);
    else if (tab !== "journal") setJournalTourActive(false);
  }, [tab, onboardingDone, tourDone]);
  useEffect(() => {
    if (tab === "categories" && onboardingDone && tourDone && !isSpacesTourDone()) setSpacesTourActive(true);
    else if (tab !== "categories") setSpacesTourActive(false);
  }, [tab, onboardingDone, tourDone]);
  // Mobile and desktop journals lay the folder flow out differently; the step
  // list needs to know which copy to use for the toolbar step.
  const journalTourSteps = useMemo(() => buildJournalTourSteps(!isDesktop), [isDesktop]);
  // The swipe-navigation step only exists on mobile — desktop's calendar grid
  // has no swipe gesture (see the comment on buildPlannerTourSteps).
  // Built for the view the Planner opens on (a phone's calendar views have no "+").
  const plannerTourSteps = useMemo(() => buildPlannerTourSteps(!isDesktop, plannerView), [isDesktop, plannerTourActive]); // eslint-disable-line react-hooks/exhaustive-deps
  const plannerExtrasTourSteps = useMemo(() => buildPlannerExtrasTourSteps(!isDesktop), [isDesktop]);
  // Settings' "Replay Guide" button. Clears every onboarding/tour flag (both
  // in localStorage via resetOnboardingAndTour, and the React state mirrors
  // of them so the effects above re-fire without a reload) and lands on
  // Habits — see the "Land on Habits" comment on OnboardingFlow's onComplete
  // below for why that tab specifically.
  const replayOnboarding = useCallback(() => {
    resetOnboardingAndTour();
    setOnboardingDone(false);
    setTourDone(false);
    setTourActive(false);
    setTourStepIndex(0);
    setPlannerTourActive(false);
    setPlannerExtrasTourActive(false);
    setClockInTourActive(false);
    setJournalTourActive(false);
    setSpacesTourActive(false);
    setTab("habits");
    setSettingsOpen(false);
    setSettingsInitialSection(null);
  }, []);
  const [settingsWide, setSettingsWide] = useState(false); // widen drawer for the widget preview page

  // ── Google Calendar integration ────────────────────────────────────────────
  // The hook owns the connection; calEvents stay here. We auto-sync (debounced)
  // whenever local events change, on a slow interval, and when the tab refocuses.
  const gcal = useGoogleCalendar();
  const gcalSyncRef = useRef();
  gcalSyncRef.current = () => gcal.syncNow(calEvents, setCalEvents, calEventOccurrenceOverrides, setCalEventOccurrenceOverrides);
  // Google Calendar sync is Premium. The connection itself is a server cookie
  // on this browser/phone, not tied to the Clarity account, so it outlives a
  // lapse and carries over to any account signed in here — sync only runs
  // while the signed-in account is Premium (Settings shows the lock + Disconnect).
  const gcalConnected = gcal.connected && isPremium;
  // Debounced push/pull on local changes (and once right after connecting).
  useEffect(() => {
    if (!gcalConnected) return;
    const t = setTimeout(() => gcalSyncRef.current?.(), 3000);
    return () => clearTimeout(t);
  }, [calEvents, calEventOccurrenceOverrides, gcalConnected, gcal.calendarId]);
  // Slow poll to pull in changes made on other Google Calendar clients.
  useEffect(() => {
    if (!gcalConnected) return;
    const id = setInterval(() => gcalSyncRef.current?.(), 5 * 60 * 1000);
    const onFocus = () => gcalSyncRef.current?.();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [gcalConnected]);

  // Same pattern as above, for non-recurring Tasks against a Google Tasks list.
  const gtaskSyncRef = useRef();
  gtaskSyncRef.current = () => gcal.syncTasksNow(tasks, setTasks);
  useEffect(() => {
    if (!gcalConnected) return;
    const t = setTimeout(() => gtaskSyncRef.current?.(), 3000);
    return () => clearTimeout(t);
  }, [tasks, gcalConnected, gcal.taskListId]);
  useEffect(() => {
    if (!gcalConnected) return;
    const id = setInterval(() => gtaskSyncRef.current?.(), 5 * 60 * 1000);
    const onFocus = () => gtaskSyncRef.current?.();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [gcalConnected]);

  // ── Notifications ──────────────────────────────────────────────────────────
  // Tier 1 (in-app toast + custom sound) and Tier 2 (SW system notification while
  // backgrounded) are handled entirely client-side below. Tier 3 (push via FCM,
  // works even with the app fully closed) additionally needs Firebase + sign-in,
  // so it no-ops otherwise — see src/firebase/messaging.js.
  const { user: authUser } = useAuth();
  useEffect(() => { bindAndroidBackButton(); }, []);
  useWidgetPremium(); // locks the Premium widgets (Planner, Donut, Habit Tracker) when Premium lapses
  useWidgetSync({
    tasks, calEvents, taskOccurrenceOverrides, calEventOccurrenceOverrides, categories,
    habits, habitLogs, habitSkips, weekStart, focusSessions,
    // Any change to the theme or accent re-reads the colours for the Planner widget.
    themeKey: `${bgTheme}|${primaryColor}|${defaultAccent}`,
  });

  // Shared by the Settings drawer shortcuts and the home-screen widgets: both
  // hand the destination tab a one-shot localStorage flag it reads on mount.
  const startNewNote = () => {
    const id = uid();
    const date = todayStr();
    setDiary(prev => ({ ...prev, [date]: [...(prev[date] || []), { id, title: "", htmlContent: "", content: "", pinned: false, font: "normal", color: "#fff7f9", noteStyle: "plain", noteBg: null, folder: null, date, updatedAt: new Date().toISOString() }] }));
    try { localStorage.setItem("clarity_journal_screen", "editor"); localStorage.setItem("clarity_journal_activeNoteId", id); } catch {}
    setTab("journal");
    setSettingsOpen(false);
  };
  const startAddNew = (type = "task") => {
    try { localStorage.setItem("clarity_calendar_openAdd", "1"); localStorage.setItem("clarity_calendar_openAddType", type); } catch {}
    setPlannerView("calendar");
    setTab("calendar");
    setSettingsOpen(false);
  };

  // A home-screen widget was tapped. Planner reads its one-shot
  // flag only when they mount, so when the app is already sitting on that tab
  // we leave it alone: setting a flag nobody will read would ambush the user
  // with a stale editor later, and remounting would drop unsaved editor text.
  useWidgetLaunchActions((action) => {
    const { name, arg } = parseWidgetAction(action);
    if (name === "planner") { setPlannerView("calendar"); setTab("calendar"); }
    else if (name === "planner_add_task") { if (tab !== "calendar") startAddNew("task"); else setPlannerView("calendar"); }
    else if (name === "habits") setTab("habits");
    else if (name === "premium") setWidgetGateOpen(true);
    else if (name === "planner_day:") {
      if (/^\d{4}-\d{2}-\d{2}$/.test(arg)) {
        try { localStorage.setItem(PLANNER_OPEN_DATE_FLAG, arg); } catch {}
        window.dispatchEvent(new Event(PLANNER_OPEN_DATE_EVENT));
      }
      setPlannerView("calendar"); setTab("calendar");
    }
  });
  useWidgetPendingToggles(setHabitLogs);
  useWidgetPendingTaskToggles(tasks, setTasks, setTaskOccurrenceOverrides);
  useAlarmSync(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips);
  useNotificationSync(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips);
  // Same inputs as the two above, but writes when this device is next due to
  // Firestore rather than scheduling anything locally — it's what lets the
  // server pusher stop reading every user every minute. See nextAlarmHint.js.
  useNextAlarmHint(authUser?.uid, tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips);
  // Plays whichever sound a due reminder calls for: the one fixed Notification
  // sound, or (for alert type "alarm") either a custom device-picked sound
  // (native only — see utils/alarmSound.js's SoundPicker wrapper) or the
  // option matching the reminder's chosen ALARM_SOUND_OPTIONS id — routed
  // through the shared single-slot player so it can't overlap with (or
  // outlive) a reminder-picker preview.
  const playReminderSound = (due) => {
    if (due.alertType === "alarm") {
      if (due.alarmSoundUri && Capacitor.isNativePlatform()) playCustomAlarmSound(due.alarmSoundUri);
      else playAlarmSoundOption(ALARM_SOUND_OPTIONS.find(s => s.id === due.alarmSound) || ALARM_SOUND_OPTIONS[0]);
    } else {
      try { new Audio(NOTIFICATION_SOUND_FILE).play().catch(() => {}); } catch {}
    }
  };
  // Reminders/alarms set on a task or event are always active — no separate
  // app-level opt-in toggle. Permission (browser Notification / native
  // POST_NOTIFICATIONS) is requested automatically the moment it's actually
  // needed, rather than gating the whole feature behind a settings switch.
  const [notifPermission, setNotifPermission] = useState(() => (typeof Notification !== "undefined" ? Notification.permission : "unsupported"));
  useEffect(() => {
    if (typeof Notification === "undefined" || Notification.permission !== "default") return;
    Notification.requestPermission().then(setNotifPermission).catch(() => {});
  }, []);

  // Tier 3 registration: only meaningful when signed in with Firebase configured.
  // Tracks the last signed-in uid so a sign-out can clean up its push token
  // (authUser is already null by the time that effect run happens).
  const lastAuthUidRef = useRef(null);
  useEffect(() => {
    if (authUser) {
      lastAuthUidRef.current = authUser.uid;
      if (isNativePush) { registerNativePush(authUser.uid); return; }
      if (isPushConfigured && notifPermission === "granted") registerPush(authUser.uid);
      return;
    }
    const uid = lastAuthUidRef.current;
    if (!uid) return;
    lastAuthUidRef.current = null;
    if (isNativePush) unregisterNativePush(uid);
    else if (isPushConfigured) unregisterPush(uid);
  }, [notifPermission, authUser]);

  // Boots Play Billing as soon as someone's signed in on native Android,
  // rather than waiting for them to open the Upgrade sheet. This matters for
  // recovery: if a purchase's server-side verification failed (e.g. a Play
  // Developer API outage, or a transient propagation delay right after
  // paying), Google Play still considers the purchase made — it just never
  // got handed back to our server successfully. Merely re-running
  // store.initialize() does NOT reliably replay that: real-world testing
  // showed zero retry attempts reached our server even after several fresh
  // app opens and Upgrade taps, because the plugin doesn't re-surface an
  // already-known "approved" purchase from a past session on its own.
  // restorePlayBillingPurchases() calls the plugin's dedicated
  // restorePurchases(), which explicitly re-queries Play for every purchase
  // this device's Play Store account owns and feeds each one back through
  // the same approved → verify → grant pipeline as a fresh purchase — so
  // someone who already paid gets their premium unlocked automatically on
  // their next app open, instead of needing to know to tap Upgrade again
  // (which, for an already-owned item, just fails with ITEM_ALREADY_OWNED
  // and never even reaches our server).
  useEffect(() => {
    if (authUser && isPlayBillingAvailable()) restorePlayBillingPurchases();
  }, [authUser]);

  // On native, a reminder that comes due while the app is closed/backgrounded
  // is already delivered by the native AlarmManager scheduler (ringing +
  // system notification) — so the very first tick of the poller below after
  // the app comes back to foreground must NOT also fire Tier 1 (in-app toast
  // + sound) for anything already due, or the user gets alerted twice for
  // the same reminder. True on mount (app could've just been reopened from
  // fully closed) and again whenever the app is backgrounded; consumed
  // (reset to false) by the first tick that runs while visible.
  const pendingResumeCatchupRef = useRef(true);
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    const sub = CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) pendingResumeCatchupRef.current = true;
    });
    return () => { sub.then((h) => h.remove()).catch(() => {}); };
  }, []);

  // Tiers 1 & 2 poller: every 25s, scan for reminders that just came due.
  const notifFiredRef = useRef(null);
  useEffect(() => {
    if (notifFiredRef.current === null) notifFiredRef.current = load("clarity_notifFired", {});
    // eslint-disable-next-line no-console
    console.log(`[ClarityTierPoll] effect (re)mounted — tab=${tab} tasks=${tasks.length} calEvents=${calEvents.length} calReminders=${calReminders.length}`);
    const tick = () => {
      const firedMap = notifFiredRef.current;
      const cutoff = Date.now() - 2 * 86400000; // prune fired-keys older than 2 days
      for (const k of Object.keys(firedMap)) if (firedMap[k] < cutoff) delete firedMap[k];

      const due = [
        ...collectDueReminders({
          tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides,
          firedMap, nowDate: new Date(),
        }),
        ...collectDueHabitReminders({ habits, habitLogs, habitSkips, firedMap, nowDate: new Date() }),
      ];
      if (due.length) {
        // eslint-disable-next-line no-console
        console.log(`[ClarityTierPoll] firing ${due.length} due item(s) — tab=${tab}`, due.map(d => ({ title: d.title, key: d.key, deltaMs: d.deltaMs, alertType: d.alertType })));
        const hidden = document.visibilityState === "hidden";
        // Consume the catch-up flag on the first tick that actually runs
        // while visible — everything due in THIS tick was either already
        // handled natively (we were away) or is safe to toast from here on.
        const isNativeCatchup = !hidden && Capacitor.isNativePlatform() && pendingResumeCatchupRef.current;
        if (!hidden) pendingResumeCatchupRef.current = false;
        due.forEach(d => {
          firedMap[d.key] = Date.now();
          if (isNativeCatchup) {
            // Native already rang/posted this while we were closed/backgrounded —
            // just record it as fired, no duplicate toast/sound.
          } else if (!hidden) {
            // Tier 1: only while the tab is visible — a custom sound can't play
            // on a system-level notification, so this is the one place it fires.
            sonnerToast(d.title, {
              description: d.body,
              icon: <Bell size={16} />,
              style: { background: "var(--c-bg-card, #fff)", border: "1.5px solid var(--c-border-light, #eee)", borderRadius: "12px", color: "var(--c-text, #2d2233)", fontFamily: "'Quicksand', sans-serif", fontSize: "13px", fontWeight: 700 },
            });
            playReminderSound(d);
          } else if (!Capacitor.isNativePlatform() && notifPermission === "granted" && "serviceWorker" in navigator && navigator.serviceWorker.controller) {
            // Tier 2: backgrounded tab, SW alive — default OS sound, not the custom one.
            // Web only. On native, the WebView keeps running while the app is
            // backgrounded, so this used to fire *in addition to* the native
            // AlarmManager notification — two competing systems posting for the
            // same reminder. That's what was showing the old "Starting now" body
            // (this path reads collectDueReminders, not the native scheduler's
            // payload) and causing the duplicate/inconsistent popups. Native
            // reminders are owned entirely by NotificationSchedulerPlugin.
            navigator.serviceWorker.controller.postMessage({ type: "CLARITY_SHOW_NOTIFICATION", title: `${d.title}`, body: d.body, key: d.key });
          }
        });
      }
      save("clarity_notifFired", firedMap);
    };
    tick();
    const id = setInterval(tick, 25000);
    return () => clearInterval(id);
  }, [notifPermission, tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips]);

  // Set appStartDate on first load
  useEffect(() => {
    if (!localStorage.getItem("clarity_startDate")) localStorage.setItem("clarity_startDate", todayStr());
  }, []);

  // Detect day rollover while the app stays open, so "today" stays aligned to
  // the real calendar day without the user having to reload. Bumping this state
  // re-renders the tree; every todayStr() call then recomputes for the new day.
  const [dayTick, setDayTick] = useState(0);
  useEffect(() => {
    let currentDay = todayStr();
    const checkDay = () => {
      const t = todayStr();
      if (t !== currentDay) { currentDay = t; setDayTick(n => n + 1); }
    };
    const id = setInterval(checkDay, 30000);              // catch midnight within ~30s
    document.addEventListener("visibilitychange", checkDay); // app brought back to foreground
    window.addEventListener("focus", checkDay);              // window/tab refocused
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", checkDay);
      window.removeEventListener("focus", checkDay);
    };
  }, []);

  // A goal changed in a habit's edit form is parked until the next period
  // starts; this moves it into effect on mount and when the day rolls over.
  // (applyDueGoalChanges hands back the same array when nothing is due.)
  useEffect(() => { setHabits(p => applyDueGoalChanges(p)); }, [dayTick]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-restore habits/tasks that were removed from Clock-In "just for today".
  // That temporary removal unchecks Add-to-Clock-In and stamps clockInRestoreDate;
  // once today reaches that date we flip Add-to-Clock-In back on and drop the
  // marker, so the item returns on its next scheduled day — whether the app was
  // reopened (mount) or just left open across midnight (dayTick bumps above).
  useEffect(() => {
    const today = todayStr();
    const restore = (arr) => {
      let changed = false;
      const next = arr.map(x => {
        if (x.clockInRestoreDate && x.clockInRestoreDate <= today) {
          changed = true;
          const { clockInRestoreDate, ...rest } = x;
          return { ...rest, addToClockIn: true };
        }
        return x;
      });
      return changed ? next : arr;
    };
    setHabits(restore);
    setTasks(restore);
  }, [dayTick]); // eslint-disable-line


  useEffect(() => { save("clarity_categories", categories); }, [categories]);
  useEffect(() => { save("clarity_habits", habits); }, [habits]);
  useEffect(() => { save("clarity_deletedHabits", deletedHabits); }, [deletedHabits]);
  // Belt-and-suspenders: if a tombstoned habit ever slips back into state (e.g. a
  // stale cloud blob arriving via the live sync listener), prune it immediately so
  // a deleted habit can never reappear in the UI.
  useEffect(() => {
    if (!deletedHabits || !Object.keys(deletedHabits).length) return;
    setHabits(prev => {
      const next = prev.filter(h => !(h.id in deletedHabits));
      return next.length === prev.length ? prev : next;
    });
  }, [deletedHabits, habits]);
  // One-time sweep for habits deleted before per-habit history was purged on
  // delete: strip any logs/skips/clean-log entries still referencing a
  // tombstoned habit ID, so old deletions get fully cleaned up too.
  useEffect(() => {
    const ids = deletedHabits ? Object.keys(deletedHabits) : [];
    if (!ids.length) return;
    setHabitLogs(prev => {
      let changed = false;
      const next = {};
      for (const [date, entries] of Object.entries(prev)) {
        const hit = entries && ids.some(id => id in entries);
        if (!hit) { next[date] = entries; continue; }
        changed = true;
        const rest = { ...entries };
        for (const id of ids) delete rest[id];
        next[date] = rest;
      }
      return changed ? next : prev;
    });
    setHabitSkips(prev => {
      const next = prev.filter(s => !ids.includes(s.habitId));
      return next.length === prev.length ? prev : next;
    });
    setCleanLog(prev => {
      let changed = false;
      const next = {};
      for (const [date, list] of Object.entries(prev)) {
        const filtered = (list || []).filter(id => !ids.includes(id));
        if (filtered.length !== (list || []).length) changed = true;
        next[date] = filtered;
      }
      return changed ? next : prev;
    });
  }, [deletedHabits]);
  useEffect(() => { save("clarity_habitLogs", habitLogs); }, [habitLogs]);
  useEffect(() => { save("clarity_habitSkips", habitSkips); }, [habitSkips]);

  // Listen for inline category creation from Clock In tab
  useEffect(() => {
    const handler = (e) => setCategories(p => [...p, e.detail]);
    window.addEventListener("clarity:addCategory", handler);
    return () => window.removeEventListener("clarity:addCategory", handler);
  }, []);
  useEffect(() => { save("clarity_cleanLog", cleanLog); }, [cleanLog]);
  useEffect(() => { save("clarity_tasks", tasks); }, [tasks]);
  useEffect(() => { save("clarity_taskOccOverrides", taskOccurrenceOverrides); }, [taskOccurrenceOverrides]);
  useEffect(() => { save("clarity_calEventOccOverrides", calEventOccurrenceOverrides); }, [calEventOccurrenceOverrides]);
  useEffect(() => { save("clarity_focusSessions", focusSessions); }, [focusSessions]);
  useEffect(() => { save("clarity_calEvents", calEvents); }, [calEvents]);
  useEffect(() => { save("clarity_calReminders", calReminders); }, [calReminders]);
  useEffect(() => { save("clarity_diary", diary); }, [diary]);


    const ALL_TABS = isDesktop ? [
    { id: "habits",     icon: Sprout,        label: "Dashboard" },
    { id: "calendar",   icon: CalendarHeart, label: "Planner" },
    { id: "focus",      icon: Timer,         label: "Clock-In" },
    { id: "journal",    icon: BookMarked,    label: "Journal" },
  ] : [
    { id: "habits",     icon: Sprout,        label: "Habits" },
    { id: "calendar",   icon: CalendarHeart, label: "Planner" },
    { id: "focus",      icon: Timer,         label: "Clock-In" },
    { id: "journal",    icon: BookMarked,    label: "Journal" },
    { id: "categories", icon: Layers,        label: "Categories" },
  ];
  // Any tab can be hidden, as long as at least one stays visible (enforced in toggleTab).
  const orderedAllTabs = orderTabs(ALL_TABS, tabOrder);
  const TABS = orderedAllTabs.filter(t => enabledTabs[t.id] !== false);
  const tabOptions = orderedAllTabs;

  // ── Background-theme derived tokens ───────────────────────────────────
  // pastel + masculine + peach are full-bleed gradient canvases that frost the
  // nav and keep cards light; only the accent hues differ between them.
  const softBgTheme = pastelMode || masculineMode || peachMode || purpleMode || mochaMode || duskMode || auroraMode || lilacMode || velvetMode || lagoonMode || cloudMode || oceanMode || frostMode || sandMode || mistMode || opalMode || bloomMode || terraMode || glacierMode || shoreMode || tideMode;
  setActiveBgTheme(bgTheme);   // expose to module-level colour helpers (themeTone)
  setActiveDarkMode(darkActive);
  const rootBg = pastelMode ? PASTEL_BG : masculineMode ? MASCULINE_BG : peachMode ? PEACH_BG : purpleMode ? PURPLE_BG : mochaMode ? MOCHA_BG : duskMode ? DUSK_BG : auroraMode ? AURORA_BG : lilacMode ? LILAC_BG : velvetMode ? VELVET_BG : lagoonMode ? LAGOON_BG : cloudMode ? CLOUD_BG : oceanMode ? OCEAN_BG : frostMode ? FROST_BG : sandMode ? SAND_BG : mistMode ? MIST_BG : opalMode ? OPAL_BG : bloomMode ? BLOOM_BG : terraMode ? TERRA_BG : glacierMode ? GLACIER_BG : shoreMode ? SHORE_BG : tideMode ? TIDE_BG : T.bg;
  // Keep the browser/PWA status-bar area (the <meta name="theme-color"> the
  // OS tints it with) matching whatever background theme is actually on
  // screen — a static meta tag can't track rootBg's ~19 possible themes, so
  // this re-reads it on every change and pulls out its first color (works
  // for both a plain hex like LAGOON_BG and a `linear-gradient(...)` string
  // like PEACH_BG, since both just need the first #hex found). Without this
  // the status bar stays whatever the static index.html default says
  // regardless of the theme actually picked, which is the mismatched white
  // band this replaces.
  useEffect(() => {
    const match = rootBg.match(/#[0-9a-fA-F]{3,8}/);
    if (!match) return;
    document.querySelectorAll('meta[name="theme-color"]').forEach(m => m.setAttribute("content", match[0]));
  }, [rootBg]);
  const navActiveColor  = pastelMode ? "#c75c92" : masculineMode ? "#33455e" : peachMode ? "#c5573a" : purpleMode ? "#5E548E" : mochaMode ? "#3E2522" : duskMode ? "#191D23" : auroraMode ? "#5a6fa0" : lilacMode ? "#7d68c4" : velvetMode ? "#140E1C" : lagoonMode ? "#002B8C" : cloudMode ? "#b5658c" : oceanMode ? "#7DA0CA" : frostMode ? "#525871" : sandMode ? "#9c7d6c" : mistMode ? "#657166" : opalMode ? "#5F6BB5" : bloomMode ? "#B8553F" : terraMode ? "#A4624D" : glacierMode ? "#1B3D59" : shoreMode ? "#597F86" : tideMode ? "#013137" : T.textAccent;
  const navIdleColor    = pastelMode ? "#8a6f9c" : masculineMode ? "#62718a" : peachMode ? "#a8806f" : purpleMode ? "#BE95C4" : mochaMode ? "#8C6E63" : duskMode ? "#7E919F" : auroraMode ? "#a8a0bc" : lilacMode ? "#a99bd8" : velvetMode ? "#A1525F" : lagoonMode ? "#5b86b8" : cloudMode ? "#c79ab0" : oceanMode ? "#5483B3" : frostMode ? "#857C91" : sandMode ? "#b89a8a" : mistMode ? "#99CDD8" : opalMode ? "#9AA6D8" : bloomMode ? "#D9A08C" : terraMode ? "#CBB093" : glacierMode ? "#6A97C0" : shoreMode ? "#87B2B0" : tideMode ? "#5C9396" : T.textSoft;
  const navActiveShadow = pastelMode ? "rgba(199,92,146,0.25)" : masculineMode ? "rgba(51,69,94,0.22)" : peachMode ? "rgba(197,87,58,0.24)" : purpleMode ? "rgba(94,84,142,0.28)" : mochaMode ? "rgba(62,37,34,0.25)" : duskMode ? "rgba(25,29,35,0.22)" : auroraMode ? "rgba(115,143,189,0.26)" : lilacMode ? "rgba(125,104,196,0.26)" : velvetMode ? "rgba(20,14,28,0.24)" : lagoonMode ? "rgba(0,43,140,0.24)" : cloudMode ? "rgba(181,101,140,0.24)" : oceanMode ? "rgba(84,131,179,0.28)" : frostMode ? "rgba(82,88,113,0.24)" : sandMode ? "rgba(156,125,108,0.24)" : mistMode ? "rgba(101,113,102,0.22)" : opalMode ? "rgba(95,107,181,0.22)" : bloomMode ? "rgba(184,85,63,0.22)" : terraMode ? "rgba(164,98,77,0.24)" : glacierMode ? "rgba(27,61,89,0.22)" : shoreMode ? "rgba(89,127,134,0.22)" : tideMode ? "rgba(41,115,118,0.24)" : T.shadow;
  // A couple of themes (Velvet, Dusk) use a near-black navActiveColor by design —
  // there's too little lightness left in that hex for either pastelize() or a plain
  // darken() to pull a real hue out of, so both would read as gray/near-black no
  // matter what. For those, fall back to the theme's own navIdleColor (e.g. Velvet's
  // rosewood #A1525F) as the hue source instead — every other theme is unaffected.
  const navChipHueSource = rgbToHsl(hexToRgb(navActiveColor).r, hexToRgb(navActiveColor).g, hexToRgb(navActiveColor).b).l < 0.15
    ? navIdleColor : navActiveColor;
  // Mobile active tab: icon + label go a shade darker than the flat accent (navActiveColor)
  // so they read clearly against the chip highlight behind them.
  const navActiveColorDark = navChipHueSource === navActiveColor ? darken(navActiveColor, 0.25) : vividDark(navChipHueSource);
  // Mobile tab icons/labels not highlighted: the dark accent above vanished on a dark
  // background, so dark mode uses a light pastel of the accent (Jade, 2026-10-17).
  const navIdleInk = darkActive ? categoryInk(T.primary) : navActiveColorDark;
  // A solid pastel tint (not a low-alpha rgba over the rail) so the active tab's
  // backdrop chip reads as its own opaque color instead of a washed-out/frosted tint
  // bleeding through from whatever sits behind the nav rail. Several theme accents are
  // themselves dark/desaturated (slate, near-black, navy) — a straight mix-toward-white
  // on those has too little chroma left and reads as grey, so pastelize() pulls just the
  // hue out and rebuilds it at a fixed light-but-colourful saturation instead.
  const navActiveChipBg = pastelize(navChipHueSource);
  // Keep the browser/PWA chrome (desktop title bar, mobile status bar) in step
  // with the app canvas: set <meta theme-color> to the TOP color of the active
  // theme background so the bar blends in and effectively disappears.
  useEffect(() => {
    // barColorsFor() knows the difference between a gradient theme (read its
    // first stop) and a mesh theme (whose *_BG is only the flat base hidden
    // under the blur — its real top edge is a measured value). The plain
    // first-hex read stays as the fallback for anything it doesn't cover.
    const top = barColorsFor(bgTheme, rootBg)?.top
      || (typeof rootBg === "string" && rootBg.trim().startsWith("#")
        ? rootBg.trim()
        : (String(rootBg).match(/#[0-9a-fA-F]{3,8}/) || ["#ffffff"])[0]);
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) { meta = document.createElement("meta"); meta.setAttribute("name", "theme-color"); document.head.appendChild(meta); }
    meta.setAttribute("content", top);
    // Also publish the top-of-gradient colour as a CSS var so the fixed
    // Planner topbar can paint itself with it in mobile list/reflect mode —
    // there the page scrolls underneath the (otherwise transparent) topbar,
    // so it needs an opaque band to hide the content passing behind it.
    document.documentElement.style.setProperty("--root-bg-top", top);
    // Native Android ignores <meta theme-color> entirely — the strips behind
    // the status bar and the gesture bar are painted by the decor view, not
    // the page. Hand the theme's real top/bottom edge colours to the native
    // side so those strips blend in instead of showing the default pale band.
    syncClarityBars(bgTheme, rootBg);
  }, [rootBg, bgTheme]);

  return (
    <div className="clarity-root" style={{ fontFamily: "'Quicksand', sans-serif", minHeight: "100vh", background: rootBg, color: T.text, display: "flex", overflowX: "hidden", maxWidth: "100vw", paddingTop: "calc(var(--sat, 0px) + var(--in-app-banner-h, 0px))" }}>
      {inAppBrowserName && !inAppBannerDismissed && (
        <InAppBrowserBanner browserName={inAppBrowserName} onDismiss={() => setInAppBannerDismissed(true)} />
      )}
      <MCPetalHost />
      {!onboardingDone && (
        <OnboardingFlow
          onComplete={(answers) => {
            if (answers?.name?.trim()) save("clarity_displayName", answers.name.trim());
            markOnboardingDone(answers || {});
            // Land on Habits, because that's where every step of the main tour
            // that runs next actually points. Matters for "Replay Onboarding"
            // from Settings, which leaves the user on whatever tab they opened
            // Settings from: finishing the quiz on, say, the Planner tab would
            // otherwise start the main tour with none of its targets on screen.
            setTab("habits");
            setOnboardingDone(true);
          }}
          setHabits={setHabits}
          setCategories={setCategories}
          saveWeekStart={saveWeekStart}
          setPlannerView={setPlannerView}
          gcal={gcal}
        />
      )}
      {onboardingDone && tourActive && (
        <CoachMarkTour habits={habits} onStepChange={setTourStepIndex} onFinish={finishMainTour} />
      )}
      {plannerTourActive && (
        <CoachMarkTour steps={plannerTourSteps} persistKey="planner" onFinish={() => { markPlannerTourDone(); setPlannerTourActive(false); }} />
      )}
      {plannerExtrasTourActive && !plannerTourActive && (
        <CoachMarkTour steps={plannerExtrasTourSteps} persistKey="plannerExtras" onFinish={() => { markPlannerExtrasTourDone(); setPlannerExtrasTourActive(false); }} />
      )}
      {clockInTourActive && (
        <CoachMarkTour steps={CLOCKIN_TOUR_STEPS} persistKey="clockin" onFinish={() => { markClockInTourDone(); setClockInTourActive(false); }} />
      )}
      {fullStopTourActive && !tourActive && (
        <CoachMarkTour steps={FULLSTOP_TOUR_STEPS} persistKey="fullStop" onFinish={() => { markFullStopTourDone(); setFullStopTourActive(false); }} />
      )}
      {limitedTourActive && !fullStopTourActive && !tourActive && (
        <CoachMarkTour steps={LIMITED_TOUR_STEPS} persistKey="limited" onFinish={() => { markLimitedTourDone(); setLimitedTourActive(false); }} />
      )}
      {clockInChartTourActive && !clockInTourActive && (
        <CoachMarkTour steps={CLOCKIN_CHART_TOUR_STEPS} persistKey="clockinChart" onFinish={() => { markClockInChartTourDone(); setClockInChartTourActive(false); }} />
      )}
      {journalTourActive && (
        <CoachMarkTour steps={journalTourSteps} persistKey="journal" onFinish={() => { markJournalTourDone(); setJournalTourActive(false); }} />
      )}
      {spacesTourActive && (
        <CoachMarkTour steps={SPACES_TOUR_STEPS} persistKey="spaces" onFinish={() => { markSpacesTourDone(); setSpacesTourActive(false); }} />
      )}
      {/* toastOptions.style applies to EVERY toast, so it's kept theme-neutral
          (a pastel tint of the current accent color, not a fixed color) —
          a fixed green previously painted failures green too, a real Play
          Billing error ("we couldn't confirm your purchase") arrived looking
          like a success. classNames re-tints the error and warning variants;
          the rules live in the <style> block below and need !important
          because sonner writes `style` inline, which a plain class can't
          outrank. The offsets are native-only: on the web the default top
          position already clears the browser chrome, but native runs
          edge-to-edge, so without them a toast overlaps the status bar.
          BOTH props are required — sonner drives its top position from
          --offset-top above 600px wide and from --mobile-offset-top at or
          below it, fed by `offset` and `mobileOffset` respectively. A phone
          is always the second case, so setting `offset` alone left every
          toast on device at sonner's 16px mobile default, i.e. on top of the
          status bar. */}
      <Toaster position="top-center" expand visibleToasts={3}
        offset={Capacitor.isNativePlatform() ? { top: "calc(var(--sat, 0px) + 28px)" } : undefined}
        mobileOffset={Capacitor.isNativePlatform() ? { top: "calc(var(--sat, 0px) + 28px)" } : undefined}
        toastOptions={{
          style: {
            background: "var(--c-bg-active)",
            border: "1.5px solid var(--c-border-mid)",
            borderRadius: "12px",
            color: "#000000",
            fontFamily: "'Quicksand', sans-serif",
            fontSize: "13px",
            fontWeight: 700,
          },
          classNames: {
            error: "clarity-toast-error",
            warning: "clarity-toast-warning",
          },
        }} />
      <style>{STATIC_APP_CSS}</style>
      <style>{DARK_MODE_CSS}</style>
      <style>{`
        /* Planner grid (Settings → Calendar Grid). Declared on .clarity-main too so
           the var(--c-grid-line) etc. they reference pick up each background's own
           overrides, which live on .clarity-main (a custom property resolves its
           var() where it is declared). */
        :root, .clarity-main {
          --c-cal-surface: ${calGridMatch ? "transparent" : darkActive ? "var(--c-bg-card)" : "#ffffff"};
          --c-cal-weekend: ${calGridMatch ? "transparent" : darkActive ? "color-mix(in srgb, #ffffff 3%, var(--c-bg-card))" : "#fdf5fa"};
          --c-cal-selected: ${calGridMatch ? "color-mix(in srgb, var(--c-primary) 16%, transparent)" : darkActive ? "color-mix(in srgb, var(--c-primary) 18%, var(--c-bg-card))" : "#fef0f6"};
          --c-cal-other-month: ${calGridMatch ? "transparent" : "var(--c-bg-soft)"};
          --c-cal-shadow: ${calGridMatch ? "none" : "0 4px 20px var(--c-shadow)"};
          --c-cal-line: ${calGridDark ? "rgba(255,255,255,0.5)" : darkActive ? "rgba(255,255,255,0.32)" : calGridMatch ? "color-mix(in srgb, var(--c-cal-line-outer) 50%, transparent)" : "var(--c-grid-line)"};
          --c-cal-line-soft: ${calGridDark ? "rgba(255,255,255,0.25)" : darkActive ? "rgba(255,255,255,0.2)" : calGridMatch ? "color-mix(in srgb, var(--c-cal-line-outer) 28%, transparent)" : "var(--c-grid-line-soft)"};
          /* The accent mixed toward black: several backgrounds set a light --c-text-accent
             (Shore #87B2B0, Glacier #B3D5F1…) that made match-mode lines near invisible. */
          --c-cal-line-outer: ${calGridDark ? "rgba(255,255,255,0.9)" : darkActive ? "rgba(255,255,255,0.5)" : calGridMatch ? "color-mix(in srgb, var(--c-text-accent) 55%, #1a1a1a)" : "var(--c-grid-line)"};
          --c-cal-ink: ${(calGridDark || darkActive) ? "#ffffff" : "#1a1a1a"};
          --c-cal-ink-strong: ${(calGridDark || darkActive) ? "#ffffff" : "#000000"};
          --c-cal-ink-soft: ${(calGridDark || darkActive) ? "rgba(255,255,255,0.78)" : "#8a7080"};
          --c-cal-line-w: 1px;
          --c-cal-today-name: ${(calGridDark || darkActive) ? "#ffffff" : "var(--c-primary)"};
        }
        :root {
          --c-primary: ${T.primary};
          --c-primary-deep: ${T.primaryDeep};
          --c-primary-light: ${T.primaryLight};
          --c-on-primary: ${T.onPrimary};
          --c-bg: ${T.bg};
          --c-bg-soft: ${T.bgSoft};
          --c-bg-card: ${T.bgCard};
          --c-bg-raised: ${T.bgRaised};
          --c-bg-active: ${T.bgActive};
          --c-border: ${T.border};
          --c-border-light: ${T.borderLight};
          --c-border-mid: ${T.borderMid};
          --c-grid-line: ${T.gridLine};
          --c-grid-line-soft: ${T.gridLineSoft};
          --c-sidebar: ${T.sidebar};
          --c-topbar: ${T.topbar};
          --c-scroll-thumb: ${T.scrollThumb};
          --c-text: ${T.text};
          --c-text-mid: ${T.textMid};
          --c-text-soft: ${T.textSoft};
          --c-text-accent: ${T.textAccent};
          /* Fixed accent for text that sits directly on a gradient wallpaper
             (calendar/reflections nav date labels). Gradient theme classes
             below (.mist-main etc.) locally override --c-text-accent to
             match their own palette — sometimes landing on a colour close to
             the wallpaper itself — but never touch this one, so it stays the
             same legible tone everywhere regardless of which theme is active. */
          --c-nav-label: ${T.textAccent};
          --c-shadow: ${T.shadow};
          --c-shadow-btn: ${T.shadowBtn};
          --c-gradient: ${T.gradient};
          --c-border-grad: ${T.borderGrad};
          --c-hero-gradient: ${rootBg};
        }
      `}</style>

      {/* Mobile "Dial" nav style — a corner dial instead of the bottom bar (Settings → Tabs).
          Desktop always keeps the bar, so this only ever replaces the bar on mobile. */}
      {!isDesktop && navStyle === "dial" && TABS.length > 1 && (
        <RadialTabDial tabs={TABS} activeTab={activeNavTab} onSelect={goToTab} />
      )}

      {/* Sidebar — skipped on mobile when the Dial nav style is active (it renders above instead). */}
      {/* Desktop rail is one shared frosted-glass capsule around ALL tabs (not a separate
          chip per icon) — background picked via isDarkBgTheme() so the whole strip reads as
          a clear light-or-dark surface regardless of the gradient behind it, giving every
          icon (active or idle) a stable, predictable backdrop to be colored against. */}
      {/* Only one tab switched on in Settings: no tab bar at all, there's
          nothing to switch to (Jade, 2026-10-26). */}
      {(isDesktop || navStyle !== "dial") && TABS.length > 1 && (
      <div data-tour="nav-bar" className={"clarity-sidebar" + (!isDesktop && softBgTheme ? " soft-nav" : "")} style={isDesktop ? {
        width: 60,
        background: isDarkBgTheme() ? "rgba(24,20,28,0.38)" : "rgba(255,255,255,0.55)",
        WebkitBackdropFilter: "blur(20px) saturate(160%)",
        backdropFilter: "blur(20px) saturate(160%)",
        border: `1px solid ${isDarkBgTheme() ? "rgba(255,255,255,0.14)" : "rgba(255,255,255,0.5)"}`,
        boxShadow: "0 8px 26px rgba(0,0,0,0.14)",
        borderRadius: 20,
        padding: "16px 4px",
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: 24,
        position: "fixed", top: "50%", left: 12, transform: "translateY(-50%)",
        zIndex: 100,
      } : { width: 96, background: softBgTheme ? "rgba(255,255,255,0.55)" : "#ffffff", WebkitBackdropFilter: softBgTheme ? "blur(20px) saturate(160%)" : undefined, backdropFilter: softBgTheme ? "blur(20px) saturate(160%)" : undefined, borderRight: `1px solid ${softBgTheme ? "rgba(255,255,255,0.5)" : T.border}`, display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 18, gap: 2, position: "fixed", top: 0, left: 0, height: "100vh", zIndex: 100 }}>
        <DndContext sensors={tabDndSensors} collisionDetection={closestCenter} onDragEnd={handleTabDragEnd(TABS, orderedAllTabs)}>
        <SortableContext items={TABS.map(t => t.id)} strategy={isDesktop ? verticalListSortingStrategy : horizontalListSortingStrategy}>
        {TABS.map(t => {
          // During the tour's first step (the "look at all the tabs" overview),
          // suppress the current tab's active styling so every tab reads the same —
          // otherwise Habits (the default tab) would look pre-selected/special.
          const isActive = activeNavTab === t.id && !(tourActive && tourStepIndex === 0);
          return (
          <SortableTabButton key={t.id} id={t.id}>
          {({ ref, dragProps, dragListeners, dragStyle, dragTransition }) => (
          <button ref={ref} {...dragProps} {...dragListeners} className={`nav-btn${isActive ? " active" : ""}`} onClick={() => goToTab(t.id)}
            title={t.label}
            style={{ width: isDesktop ? 52 : 76, height: isDesktop ? 52 : 76, border: "none", outline: "none", WebkitTapHighlightColor: "transparent", borderRadius: 20, background: "transparent", color: isDesktop ? (isActive ? navActiveColor : navIdleColor) : navIdleInk, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: isDesktop ? 0 : 3, position: "relative", ...dragStyle, transition: [dragTransition, "color 0.18s"].filter(Boolean).join(", ") }}>
            {/* Desktop: unchanged — rail follows isDarkBgTheme() for idle icons, active
                fills solid with the accent (icon flips to a contrasting on-color).
                Mobile: EVERY icon (idle or not) uses the same darker-than-accent shade
                (navActiveColorDark), so tabs read consistently instead of tracking each
                theme's raw accent. The active tab stands out via a filled dark
                rounded-square (icon flips to white) plus a solid pastel backdrop chip
                (navActiveChipBg — an opaque tint, not a low-alpha rgba, so it doesn't
                read as frosted/washed-out) — the chip is purely decorative (position:
                absolute, behind the icon/label at zIndex 0) so it never affects the
                icon+label layout: both keep the exact same box size/gap as idle, and
                the label never shifts position between active and idle. */}
            {!isDesktop && isActive && (
              <span aria-hidden style={{
                position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                width: 62, height: 66, borderRadius: 18, background: navActiveChipBg,
                boxShadow: `0 4px 14px ${navActiveShadow}`, zIndex: 0,
              }} />
            )}
            <span style={{
              width: 44, height: 44, borderRadius: 14,
              background: isActive ? (isDesktop ? navActiveColor : navActiveColorDark) : "transparent",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: (isDesktop && isActive) ? `0 4px 14px ${navActiveShadow}` : "none",
              transform: isActive ? (isDesktop ? "scale(1.08)" : "scale(1.04)") : "scale(1)",
              transition: "all 0.22s cubic-bezier(0.34,1.56,0.64,1)",
              position: "relative", zIndex: 1,
            }}>
              <t.icon size={isDesktop ? 26 : 24} strokeWidth={isActive ? 2.4 : 1.9}
                color={isDesktop ? (isActive ? onColor(navActiveColor) : (isDarkBgTheme() ? "#ffffff" : "#241a2e")) : (isActive ? "#ffffff" : navIdleInk)} />
            </span>
            {!isDesktop && <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.4px", fontFamily: "'Quicksand', sans-serif", textTransform: "uppercase", color: isActive ? navActiveColorDark : "inherit", position: "relative", zIndex: 1 }}>{t.label}</span>}
            {t.id === "focus" && focusTimerState?.running && !focusTimerState?.paused && (
              <span style={{ position: "absolute", top: 10, right: 10, width: 7, height: 7, borderRadius: "50%", background: "var(--c-primary)", boxShadow: "0 0 0 2px #ffffff", animation: "pulse 1.2s infinite" }} />
            )}
          </button>
          )}
          </SortableTabButton>
          );
        })}
        </SortableContext>
        </DndContext>

        {/* ── Calendar/List view toggle — shown only when Planner tab is active ── */}
        {tab === "calendar" && (
          <div className="planner-view-toggle" style={{
            display: "flex", flexDirection: "column", alignItems: "center",
            gap: 4, marginTop: 8,
            padding: "6px 0",
          }}>
            <div style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              background: "var(--c-bg-card)", borderRadius: 14,
              padding: "3px", gap: 2,
            }}>
              <button
                title="Calendar view"
                onClick={() => setPlannerView("calendar")}
                style={{
                  width: 36, height: 36, borderRadius: 11,
                  border: "none", cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  background: plannerView === "calendar" ? "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))" : "transparent",
                  color: plannerView === "calendar" ? "#fff" : "#c080a0",
                  transition: "all 0.18s",
                }}>
                <LayoutGrid size={16} />
              </button>
              <button
                title="List view"
                onClick={() => setPlannerView("list")}
                style={{
                  width: 36, height: 36, borderRadius: 11,
                  border: "none", cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  background: plannerView === "list" ? "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))" : "transparent",
                  color: plannerView === "list" ? "#fff" : "#c080a0",
                  transition: "all 0.18s",
                }}>
                <ListTodo size={16} />
              </button>
            </div>
          </div>
        )}
        {/* Desktop: settings hamburger — portalled to upper-left corner on non-planner tabs. */}
        {isDesktop && tab !== "calendar" && createPortal(
          <button onClick={() => setSettingsOpen(true)} title="Open settings"
            style={{ position: "fixed", top: 12, left: 12, zIndex: 201, width: 44, height: 44, borderRadius: 14, border: "none", cursor: "pointer", background: "transparent", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4 }}>
            <span style={{ display: "block", width: 18, height: 2, background: T.primary, borderRadius: 2 }} />
            <span style={{ display: "block", width: 18, height: 2, background: T.primary, borderRadius: 2 }} />
            <span style={{ display: "block", width: 18, height: 2, background: T.primary, borderRadius: 2 }} />
          </button>,
          document.body
        )}

      </div>
      )}

      {widgetGateOpen && <PremiumGateModal onClose={() => setWidgetGateOpen(false)}
        onPurchased={() => { setWidgetGateOpen(false); setSettingsOpen(true); }} />}

      {/* Settings Drawer. paddingTop because fixed elements are positioned
          against the screen, not their parent — the app shell's --sat padding
          never reaches this drawer, so without it the header runs under the
          clock. */}
      {settingsOpen && (
        <div className="clarity-overlay-bg" style={{ position: "fixed", inset: 0, zIndex: 300, display: "flex", paddingTop: "var(--sat, 0px)" }}
          onClick={() => setSettingsOpen(false)}>
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.3)", backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)" }} />
          {/* White band behind the status bar, matching the drawer's own width, so the
              drawer reads as one continuous panel instead of floating below a dark strip. */}
          <div style={{ position: "absolute", top: 0, left: 0, width: settingsWide ? (isDesktop ? "min(94vw, 560px)" : "100vw") : 280, maxWidth: settingsWide && !isDesktop ? "100vw" : "94vw", height: "var(--sat, 0px)", background: T.bgCard, zIndex: 301 }} />
          <div className="clarity-drawer" onClick={e => e.stopPropagation()}
            style={{ position: "relative", width: settingsWide ? (isDesktop ? "min(94vw, 560px)" : "100vw") : 280, maxWidth: settingsWide && !isDesktop ? "100vw" : "94vw", height: "100%", background: T.bgCard, boxShadow: `4px 0 24px ${T.shadow}`, display: "flex", flexDirection: "column", overflowY: "auto", zIndex: 301, transition: "width 0.28s cubic-bezier(0.22,1,0.36,1)" }}>
            <SettingsPanel onClose={() => { setSettingsOpen(false); setSettingsInitialSection(null); }} initialSection={settingsInitialSection} onWideChange={setSettingsWide} canInstall={canInstall} promptInstall={promptInstall} bgTheme={savedBgTheme} onThemeSelect={selectBgTheme} darkActive={darkActive} onDarkSelect={selectDark} defaultAccent={defaultAccent} onDefaultAccentSelect={selectDefaultAccent} tabOptions={tabOptions} enabledTabs={enabledTabs} onToggleTab={toggleTab} gcal={gcal} onSyncNow={() => gcal.syncNow(calEvents, setCalEvents, calEventOccurrenceOverrides, setCalEventOccurrenceOverrides)} onSyncTasksNow={() => gcal.syncTasksNow(tasks, setTasks)} habits={habits} habitLogs={habitLogs} habitSkips={habitSkips} setHabitLogs={setHabitLogs} setHabits={setHabits} tasks={tasks} setTasks={setTasks} calEvents={calEvents} categories={categories} focusTimerState={focusTimerState} setFocusTimerState={setFocusTimerState} setFocusSessions={setFocusSessions} diary={diary} onNewNote={startNewNote} onAddNew={startAddNew} isDesktop={isDesktop} weekStart={weekStart} onWeekStartChange={saveWeekStart} calGridSurface={calGridSurface} onCalGridSurfaceChange={saveCalGridSurface} dayStartHour={dayStartHour} onDayStartHourChange={saveDayStartHour} onReplayOnboarding={replayOnboarding} />
          </div>
        </div>
      )}

      {/* Main */}
      <div className={"clarity-main" + (pastelMode ? " pastel-main" : "") + (masculineMode ? " masculine-main" : "") + (peachMode ? " peach-main" : "") + (purpleMode ? " purple-main" : "") + (mochaMode ? " mocha-main" : "") + (duskMode ? " dusk-main" : "") + (auroraMode ? " aurora-main" : "") + (lilacMode ? " lilac-main" : "") + (velvetMode ? " velvet-main" : "") + (lagoonMode ? " lagoon-main" : "") + (cloudMode ? " cloud-main" : "") + (oceanMode ? " ocean-main" : "") + (frostMode ? " frost-main" : "") + (sandMode ? " sand-main" : "") + (mistMode ? " mist-main" : "") + (opalMode ? " opal-main" : "") + (bloomMode ? " bloom-main" : "") + (terraMode ? " terra-main" : "") + (glacierMode ? " glacier-main" : "") + (shoreMode ? " shore-main" : "") + (tideMode ? " tide-main" : "")} style={{ marginLeft: isDesktop ? 72 : (navStyle === "dial" ? 0 : 96), paddingBottom: (!isDesktop && navStyle === "dial") ? 90 : undefined, flex: 1, display: "flex", flexDirection: "column", minHeight: "calc(100vh - var(--sat, 0px))", overflowX: "hidden", overflowY: (tab === "calendar" && !(plannerView === "list" && !isDesktop)) ? "hidden" : "auto", height: "calc(100vh - var(--sat, 0px))", overscrollBehavior: "contain" }}>
        {/* Mobile: no full topbar — just a minimal menu button (the Planner has its
            own topbar with a menu button, so skip it there). Desktop uses the
            floating sidebar. */}
        {/* Desktop Clock-In: Custom / Elapsed at the top left, just right of the menu
            button, and its other buttons (more options, Select, Chart / back to the timer)
            at the top right of the screen (Jade, 2026-11-02). */}
        {isDesktop && tab === "focus" && (
          <div ref={setFocusTopSlot} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10, padding: "12px 28px 0 4px", minHeight: 56, boxSizing: "border-box", flexShrink: 0 }} />
        )}
        {!isDesktop && tab !== "calendar" && (() => {
          // White on dark backgrounds and in dark mode (Jade, 2026-10-24). keep-white on the
          // lines: dark mode's catch-all repaints inline white fills in the card colour.
          const darkBar = darkActive || duskMode || velvetMode || purpleMode || oceanMode || glacierMode || tideMode;
          const barLine = darkBar ? "color-mix(in srgb, var(--c-primary) 45%, #fff)" /* same as the Week view lock (Jade, 2026-10-26) */ : pastelMode ? "#8a6f9c" : masculineMode ? "#5d6c84" : peachMode ? "#bd6a4e" : T.primary;
          return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px 0", flexShrink: 0 }}>
          <button onClick={() => setSettingsOpen(true)} aria-label="Open menu"
            style={{ background: "none", border: "none", cursor: "pointer", padding: "6px", display: "flex", flexDirection: "column", gap: 4, alignItems: "center", justifyContent: "center" }}>
            <span className="keep-white" style={{ display: "block", width: 20, height: 2.5, background: barLine, borderRadius: 2 }} />
            <span className="keep-white" style={{ display: "block", width: 20, height: 2.5, background: barLine, borderRadius: 2 }} />
            <span className="keep-white" style={{ display: "block", width: 20, height: 2.5, background: barLine, borderRadius: 2 }} />
          </button>
          {tab === "journal" && (
            <div ref={setJournalSearchSlot} style={{ flex: 1, marginLeft: 10, display: "flex", alignItems: "center" }} />
          )}
          {tab === "focus" && (
            <div ref={setFocusTopSlot} style={{ flex: 1, marginLeft: 10, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10 }} />
          )}
          {tab === "habits" && (() => {
            const d = new Date();
            return (
              <span style={{ fontSize: 13, fontWeight: 700, color: barLine /* same as the ☰ (Jade, 2026-10-26) */, fontFamily: "'Quicksand', sans-serif" }}>
                {`${DAYS_SHORT[d.getDay()]}, ${MONTHS[d.getMonth()].slice(0, 3)} ${d.getDate()}`}
              </span>
            );
          })()}
        </div>
          );
        })()}

        {/* Content */}
        {/* Mobile Planner list/reflect scrolls at the PAGE level (like the
            Habits reflections page) instead of via an inner overflow box —
            mobile browsers' dynamic address bar makes a 100vh inner scroller
            clip its last rows, so calLocked deliberately excludes that case. */}
        {/* A nav tap commits the highlight a frame before the tab swap (see
            goToTab); freezing the content for that frame keeps the highlight
            commit from re-rendering the whole outgoing tab. */}
        <Freeze frozen={navSwapPending}>
        {(() => {
          const tabStyle = (tc) => { const calLocked = (tc === "calendar" && !(plannerView === "list" && !isDesktop)); const lockedFlex = calLocked || (isDesktop && tc === "journal"); return { padding: tc === "calendar" ? (isDesktop ? "0 16px" : "var(--cal-topbar-h, 96px) 16px 0") : (isDesktop && tc === "journal") ? 0 : (tc === "journal" ? "8px 20px 20px" : "20px"), maxWidth: tc === "calendar" ? "100%" : (isDesktop && (tc === "habits" || tc === "journal")) ? "100%" : 900, width: "100%", margin: (isDesktop && (tc === "habits" || tc === "journal")) ? 0 : "0 auto", flex: lockedFlex ? 1 : "unset", minHeight: lockedFlex ? 0 : undefined, overflow: lockedFlex ? "hidden" : "visible", display: lockedFlex ? "flex" : "block", flexDirection: "column" }; };
          return (<>
            {/* Habits stays built while another tab shows (display:none), so
                coming back is a display toggle instead of a full rebuild. Showing
                a display:none subtree again restarts every CSS animation in it,
                so tabSettle and the cards' staggered rowIn replay on each visit. */}
            {habitsKeptRef.current && (
              <div ref={habitsWrapRef} className="clarity-tab-content" style={{ ...tabStyle("habits"), display: tab === "habits" ? "block" : "none" }}>
                <KeptTab active={tab === "habits"} resetKey={habitsGen} render={() => <HabitsTab key={habitsGen} habits={habits} setHabits={setHabits} setDeletedHabits={setDeletedHabits} habitLogs={habitLogs} setHabitLogs={setHabitLogs} categories={categories} setCategories={setCategories} habitSkips={habitSkips} setHabitSkips={setHabitSkips} tasks={tasks} setTasks={setTasks} calEvents={calEvents} setCalEvents={setCalEvents} cleanLog={cleanLog} setCleanLog={setCleanLog} masculineMode={masculineMode} isDesktop={isDesktop} pendingHabitEditId={pendingHabitEditId} clearPendingHabitEdit={() => setPendingHabitEditId(null)} onOpenSettings={() => setSettingsOpen(true)} savedColors={savedColors} addSavedColor={addSavedColor} settingsOpen={settingsOpen} primaryColor={primaryColor} bgTheme={bgTheme} />} />
              </div>
            )}
            {/* Other tabs remount per visit (keyed by id). Planner, the heaviest
                to tear down, lingers hidden and frozen for a moment after you
                leave it (lingerCal) so that teardown isn't part of the tap. */}
            {[...(lingerCal && tab !== "calendar" ? ["calendar"] : []), ...(tab !== "habits" ? [tab] : [])].map(id => (
              <div key={id} className="clarity-tab-content" style={id === tab ? tabStyle(id) : { ...tabStyle(id), display: "none" }}>
                {/* Planner is also frozen while the app-level edit panel is open, so
                    opening it doesn't redraw the whole Planner first (that was
                    the delay before the panel showed). */}
                <Freeze frozen={id !== tab || (id === "calendar" && !!appEditModal)}>
          {id === "categories" && <CategoriesTab categories={categories} setCategories={setCategories} habits={habits} setHabits={setHabits} tasks={tasks} setTasks={setTasks} habitLogs={habitLogs} setHabitLogs={setHabitLogs} calEvents={calEvents} setCalEvents={setCalEvents} habitSkips={habitSkips} setHabitSkips={setHabitSkips} masculineMode={masculineMode} savedColors={savedColors} addSavedColor={addSavedColor} settingsOpen={settingsOpen} primaryColor={primaryColor} />}
          {id === "calendar"   && <CalendarTab tasks={tasks} setTasks={setTasks} categories={categories} setCategories={setCategories} calEvents={calEvents} setCalEvents={setCalEvents} calReminders={calReminders} setCalReminders={setCalReminders} focusSessions={focusSessions} setFocusSessions={setFocusSessions} setWeekBlockPop={setWeekBlockPop} onEditItem={(item, type) => setAppEditModal({ item, type, form: { ...item } })} externalPanelOpen={!!appEditModal} plannerView={plannerView} setPlannerView={setPlannerView} isDesktop={isDesktop} bgTheme={bgTheme} taskOccurrenceOverrides={taskOccurrenceOverrides} setTaskOccurrenceOverrides={setTaskOccurrenceOverrides} calEventOccurrenceOverrides={calEventOccurrenceOverrides} setCalEventOccurrenceOverrides={setCalEventOccurrenceOverrides} onOpenSettings={() => setSettingsOpen(true)} weekStart={weekStart} dayStartHour={dayStartHour} />}
          {/* Clock-In uses the mobile single-column card layout on every screen size */}
          {id === "focus"      && <FocusTab setCategories={setCategories} focusSessions={focusSessions} setFocusSessions={setFocusSessions} focusTimerState={focusTimerState} setFocusTimerState={setFocusTimerState} habits={habits} setHabits={setHabits} habitLogs={habitLogs} setHabitLogs={setHabitLogs} habitSkips={habitSkips} setHabitSkips={setHabitSkips} tasks={tasks} setTasks={setTasks} taskOccurrenceOverrides={taskOccurrenceOverrides} setTaskOccurrenceOverrides={setTaskOccurrenceOverrides} categories={categories} showBackToTop={showBackToTop} isDesktop={false} onEditTask={(task) => setAppEditModal({ item: task, type: "task", form: { ...task } })} onEditHabit={(habit) => setAppHabitEdit({ id: habit.id, form: { ...withPendingGoal(habit), ...goalFormFlags(habit) } })} ProfileTab={ProfileTab} wide={isDesktop} weekStart={weekStart} onOpenAppBlockerSettings={() => { setSettingsInitialSection("appBlocker"); setSettingsOpen(true); }} topBarSlotNode={focusTopSlot} />}
          {id === "journal"    && <JournalTab entries={diary} setEntries={setDiary} categories={categories} isDesktop={isDesktop} searchSlotNode={journalSearchSlot} settingsOpen={settingsOpen} />}
                </Freeze>
              </div>
            ))}
          </>);
        })()}
        </Freeze>
      </div>

      {/* App-level Edit Modal — outside all CalendarTab stacking contexts */}
      {appEditModal && (() => {
        // NOTE: this IIFE returns JSX directly (no nested component) so the
        // modal isn't remounted on every keystroke — that was making text
        // inputs (e.g. the location box) lose focus after each character.
        const { item, type, form, occDate } = appEditModal;
        const setForm = (fn) => setAppEditModal(p => ({ ...p, form: typeof fn === "function" ? fn(p.form) : fn }));

        const handleSave = () => {
          if (!form.title?.trim()) return;
          if (form.color) addSavedColor(form.color);
          if (type === "task") setTasks(p => p.map(t => t.id === item.id ? { ...t, ...form } : t));
          else if (type === "event") setCalEvents(p => p.map(e => e.id === item.id ? { ...e, ...form, updatedAt: new Date().toISOString() } : e));
          else if (type === "reminder") setCalReminders(p => p.map(r => r.id === item.id ? { ...r, ...form } : r));
          closeAppEditModal();
        };
        // Tasks & events use the shared unified panel (same as the add panel).
        if (type === "task" || type === "event") {
          return (
            <Modal onClose={closeAppEditModal} blur={false} dim={0.5} animate={false}>
              <ItemPanel
                mode="edit" initialType={type} item={item}
                categories={categories} setCategories={setCategories} savedColors={savedColors} addSavedColor={addSavedColor}
                onClose={closeAppEditModal}
                onSubmit={(t, payload, orig) => {
                  // If the type was switched, remove the item from its old array first.
                  if (orig && orig !== t) {
                    if (orig === "task") setTasks(p => p.filter(x => x.id !== payload.id));
                    else if (orig === "event") setCalEvents(p => p.filter(x => x.id !== payload.id));
                  }
                  if (t === "task") {
                    const isRecurring = payload.frequencyType && payload.frequencyType !== "once";
                    // Edited from a specific week occurrence of a recurring task:
                    // time/endTime apply only to THAT block (stored as an override),
                    // every other field stays shared across the series. Colour is
                    // shared too: one edit recolours every block (Jade, 2026-10-16).
                    if (occDate && orig !== "event" && isRecurring && payload.id === item.id) {
                      // "" (not undefined) marks this occurrence as explicitly timeless —
                      // every reader merges overrides with `ov.time ?? base.time`, which
                      // treats undefined as "no override" and would silently fall back to
                      // the series' shared time, undoing a Remove-time edit on this block.
                      setTaskOccurrenceOverrides(prev => {
                        const next = withoutOccurrenceColors(prev, payload.id);
                        return { ...next, [`${payload.id}:${occDate}`]: { ...next[`${payload.id}:${occDate}`], time: payload.time ?? "", endTime: payload.endTime ?? "" } };
                      });
                      setTasks(p => p.map(x => x.id === payload.id ? { ...payload, time: x.time, endTime: x.endTime } : x));
                    } else {
                      if (isRecurring) setTaskOccurrenceOverrides(prev => withoutOccurrenceColors(prev, payload.id));
                      setTasks(p => p.some(x => x.id === payload.id) ? p.map(x => x.id === payload.id ? payload : x) : [...p, payload]);
                    }
                  } else {
                    const isRecurring = payload.frequencyType && payload.frequencyType !== "once";
                    // Same per-occurrence carve-out as tasks above, for recurring events.
                    if (occDate && orig !== "task" && isRecurring && payload.id === item.id) {
                      // Same "" timeless sentinel as the task branch above.
                      setCalEventOccurrenceOverrides(prev => {
                        const next = withoutOccurrenceColors(prev, payload.id);
                        return { ...next, [`${payload.id}:${occDate}`]: { ...next[`${payload.id}:${occDate}`], time: payload.time ?? "", endTime: payload.endTime ?? "" } };
                      });
                      setCalEvents(p => p.some(x => x.id === payload.id) ? p.map(x => x.id === payload.id ? { ...payload, time: x.time, endTime: x.endTime } : x) : [...p, payload]);
                    } else {
                      if (isRecurring) setCalEventOccurrenceOverrides(prev => withoutOccurrenceColors(prev, payload.id));
                      setCalEvents(p => p.some(x => x.id === payload.id) ? p.map(x => x.id === payload.id ? payload : x) : [...p, payload]);
                    }
                  }
                  closeAppEditModal();
                }}
              />
            </Modal>
          );
        }
        // Reminders keep their dedicated form.
        return (
          <div onClick={closeAppEditModal} style={{ position: "fixed", inset: 0, zIndex: 9000, background: "rgba(60,30,50,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'Quicksand','Nunito',sans-serif" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: "var(--c-bg-card)", borderRadius: 20, width: "min(480px,95vw)", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 40px rgba(212,120,154,0.28)", padding: "20px 20px 24px" }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "var(--c-text-soft)", textTransform: "uppercase", letterSpacing: 1 }}>
                  {type === "task" ? <><CheckSquare size={15} style={{marginRight:6}}/>Edit Task</> : type === "event" ? <><CalendarCheck size={15} style={{marginRight:6}}/>Edit Event</> : <><Bell size={15} style={{marginRight:6}}/>Edit Reminder</>}
                </span>
                <button onClick={closeAppEditModal} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "var(--c-text-soft)", lineHeight: 1, padding: 0 }}><X size={16} /></button>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {/* Title */}
                <div><p style={S.label}>TITLE</p>
                  <input value={form.title || ""} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} style={S.input} placeholder="Title" />
                </div>
                {/* Dates */}
                {type === "task" ? (
                  <div style={{ display: "flex", gap: 8 }}>
                    <div style={{ flex: 1 }}><p style={S.label}>START DATE</p>
                      <NativePickerInput type="date" value={form.startDate || ""} onChange={e => setForm(p => ({ ...p, startDate: e.target.value }))} style={S.input} />
                    </div>
                    <div style={{ flex: 1 }}><p style={S.label}>DUE DATE</p>
                      <NativePickerInput type="date" value={form.dueDate || ""} onChange={e => setForm(p => ({ ...p, dueDate: e.target.value }))} style={S.input} />
                    </div>
                  </div>
                ) : (
                  <div><p style={S.label}>DATE</p>
                    <NativePickerInput type="date" value={form.date || ""} onChange={e => setForm(p => ({ ...p, date: e.target.value }))} style={S.input} />
                  </div>
                )}
                {/* All-day toggle (events only) — maps to a Google all-day event */}
                {type === "event" && (
                  <div onClick={() => setForm(p => ({ ...p, allDay: !p.allDay }))} style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", padding: "2px 0" }}>
                    <span style={{ flex: 1, fontSize: 13, color: "var(--c-text)", fontWeight: 600 }}>All day</span>
                    <div style={{ width: 38, height: 22, borderRadius: 999, background: form.allDay ? "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))" : "var(--c-border)", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
                      <div style={{ position: "absolute", top: 2, left: form.allDay ? 18 : 2, width: 18, height: 18, borderRadius: "50%", background: "var(--c-bg-card)", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", transition: "left 0.2s cubic-bezier(0.34,1.56,0.64,1)" }} />
                    </div>
                  </div>
                )}
                {/* Times — hidden for all-day events */}
                {!(type === "event" && form.allDay) && (
                  <div style={{ display: "flex", gap: 8 }}>
                    <div style={{ flex: 1 }}><p style={S.label}>START TIME</p>
                      <NativePickerInput type="time" value={form.time || ""} onChange={e => setForm(p => ({ ...p, time: e.target.value }))} style={S.input} />
                    </div>
                    <div style={{ flex: 1 }}><p style={S.label}>END TIME</p>
                      <NativePickerInput type="time" value={form.endTime || ""} onChange={e => setForm(p => ({ ...p, endTime: e.target.value }))} style={S.input} />
                    </div>
                  </div>
                )}
                {/* Reminders (tasks & events) — minute offsets; events also sync these as Google popup
                    reminders. Scheduled delivery needs the native AlarmScheduler/NotificationScheduler
                    plugins, so this stays native-only (see CalendarExtras.jsx). */}
                {(type === "task" || type === "event") && Capacitor.isNativePlatform() && (
                  <div>
                    {/* Remove is the only way to turn reminders off from here.
                        The add panel has its own off switch (see ItemPanel in
                        CalendarExtras.jsx), but this edit modal had nothing —
                        so once an item had been saved with a reminder, the
                        only way to stop it ringing was to deselect every chip
                        one at a time, which nobody would guess. Emptying the
                        offsets is genuinely enough: both the on-device
                        scheduler and the server push skip an item whose
                        `reminders` array is empty, and AlarmSchedulerPlugin's
                        reconcile() cancels any registration it already made.
                        Labelled "Remove" to match the add panel's own reminder
                        off switch — "Clear" is this codebase's word for
                        emptying a single field like DUE DATE, not for turning
                        a whole feature off. */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                      <p style={{ ...S.label, margin: 0 }}>REMINDERS</p>
                      {!!(form.reminders && form.reminders.length) && (
                        <button type="button" onClick={() => setForm(p => ({ ...p, reminders: [] }))}
                          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--c-text-soft)", fontSize: 11, fontWeight: 600, display: "flex", alignItems: "center", gap: 3, padding: 0, fontFamily: "inherit" }}
                          onMouseEnter={e => e.currentTarget.style.color = "#e8647a"}
                          onMouseLeave={e => e.currentTarget.style.color = "#c0a0b8"}>
                          <X size={12} /> Remove
                        </button>
                      )}
                    </div>
                    <ReminderPicker value={form.reminders} onChange={(reminders) => setForm(p => ({ ...p, reminders }))} onlyDayWeek={!form.time}
                      alertType={form.reminderType} onAlertTypeChange={(reminderType) => setForm(p => ({ ...p, reminderType }))}
                      alarmSound={form.alarmSound} onAlarmSoundChange={(alarmSound) => setForm(p => ({ ...p, alarmSound }))}
                      alarmSoundUri={form.alarmSoundUri} alarmSoundLabel={form.alarmSoundLabel}
                      onCustomSoundChange={(picked) => setForm(p => ({ ...p, alarmSoundUri: picked?.uri || "", alarmSoundLabel: picked?.label || "" }))} />
                  </div>
                )}
                {/* Location for events/reminders — OpenStreetMap autocomplete */}
                {type !== "task" && (
                  <div><p style={S.label}>LOCATION</p>
                    <LocationAutocomplete value={form.location || ""} onChange={(v) => setForm(p => ({ ...p, location: v }))} inputStyle={S.input} />
                  </div>
                )}
                {/* ── Category ── */}
                <div><p style={S.label}>CATEGORY</p>
                  <select value={form.goalId || form.categoryId || ""} onChange={e => setForm(p => type === "task" ? { ...p, goalId: e.target.value } : { ...p, categoryId: e.target.value })} style={{ ...S.input, cursor: "pointer" }}>
                    <option value="">No category</option>
                    {categories.map(c => <option key={c.id} value={c.id}>{c.emoji} {c.title}</option>)}
                  </select>
                </div>
                {/* Frequency — tasks and events */}
                {(type === "task" || type === "event") && (
                  <div>
                    <p style={S.label}>FREQUENCY</p>
                    <div style={{ display: "flex", gap: 6 }}>
                      {[
                        { val: "once",     label: "1️⃣ Once"   },
                        { val: "daily",    label: "📅 Daily"  },
                        { val: "specific", label: "📆 Weekly" },
                        { val: "monthly",  label: "🗓 Monthly" },
                      ].map(({ val, label }) => {
                        const active = (form.frequencyType || "once") === val;
                        return (
                          <button key={val} onClick={() => setForm(p => ({
                            ...p,
                            frequencyType: val === "once" ? undefined : val,
                            frequencyDays: val !== "specific" ? undefined : (p.frequencyDays || []),
                            monthDates:    val !== "monthly"  ? undefined : (p.monthDates || []),
                            repeatEnd:     val === "once" ? undefined : p.repeatEnd,
                          }))}
                            style={{ ...S.btn, flex: 1, fontSize: 10, fontWeight: active ? 700 : 400, background: active ? "var(--c-bg-card)" : "transparent", color: active ? "#d4789a" : "#a07090", borderColor: active ? "#d4789a" : undefined }}>
                            {label}
                          </button>
                        );
                      })}
                    </div>
                    {form.frequencyType === "specific" && (
                      <div style={{ marginTop: 8, background: "var(--c-bg-soft)", borderRadius: 10, padding: "10px 12px", border: "1px solid #f0d8ea" }}>
                        <p style={{ fontSize: 11, color: "var(--c-text-soft)", margin: "0 0 8px" }}>Which days?</p>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
                          {["Mon","Tue","Wed","Thu","Fri","Sat","Sun"].map((d, i) => (
                            <button key={d} onClick={() => setForm(p => { const days = p.frequencyDays || []; return { ...p, frequencyDays: days.includes(i) ? days.filter(x => x !== i) : [...days, i] }; })}
                              style={{ ...S.btn, fontSize: 10, padding: "7px 0", textAlign: "center", background: (form.frequencyDays || []).includes(i) ? "var(--c-bg-card)" : "transparent", color: (form.frequencyDays || []).includes(i) ? "#d4789a" : "#a07090", borderColor: (form.frequencyDays || []).includes(i) ? "#d4789a" : undefined }}>
                              {d}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    {form.frequencyType === "monthly" && (
                      <div style={{ marginTop: 8, background: "var(--c-bg-soft)", borderRadius: 10, padding: "10px 12px", border: "1px solid #f0d8ea" }}>
                        <p style={{ fontSize: 11, color: "var(--c-text-soft)", margin: "0 0 8px" }}>Pick dates of the month:</p>
                        <div style={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
                          {Array.from({ length: 31 }, (_, i) => (
                            <button key={i+1} onClick={() => setForm(p => { const dates = p.monthDates || []; return { ...p, monthDates: dates.includes(i+1) ? dates.filter(x => x !== i+1) : [...dates, i+1] }; })}
                              style={{ ...S.btn, fontSize: 11, width: 32, height: 32, padding: 0, display: "flex", alignItems: "center", justifyContent: "center", background: (form.monthDates || []).includes(i+1) ? "var(--c-bg-card)" : "transparent", color: (form.monthDates || []).includes(i+1) ? "#d4789a" : "#a07090", borderColor: (form.monthDates || []).includes(i+1) ? "#d4789a" : undefined }}>
                              {i+1}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    {form.frequencyType && form.frequencyType !== "once" && (
                      <div style={{ marginTop: 8 }}>
                        <p style={{ ...S.label, marginBottom: 4 }}>REPEAT UNTIL</p>
                        <NativePickerInput type="date" value={form.repeatEnd || ""} onChange={e => setForm(p => ({ ...p, repeatEnd: e.target.value }))} style={S.input} min={form.startDate || form.date || ""} />
                        <p style={{ margin: "4px 0 0", fontSize: 10, color: "var(--c-text-soft)", fontStyle: "italic" }}>Leave blank to repeat indefinitely</p>
                      </div>
                    )}
                  </div>
                )}
                {/* Notes */}
                <div><p style={S.label}>NOTES</p>
                  <RichNotesEditor value={form.notes || ""} onChange={notes => setForm(p => ({ ...p, notes }))} placeholder="Add notes, links…" />
                </div>
                {/* Attachments (events only) */}
                {type === "event" && (
                  <div><p style={S.label}>ATTACHMENTS</p>
                    <AttachmentField value={form.attachments} onChange={(attachments) => setForm(p => ({ ...p, attachments }))} />
                  </div>
                )}
                {/* Buttons */}
                <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                  <button onClick={handleSave} className="clarity-add-btn" style={S.addBtn}><Save size={14} style={{marginRight:4}} />Save</button>
                  <button onClick={closeAppEditModal} style={S.btn}><X size={14} style={{marginRight:4}} />Cancel</button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* App-level in-place Habit editor — opened from the Clock-In queue, no tab change */}
      {appHabitEdit && (
        <Modal onClose={() => { setAppHabitEdit(null); setShowNewCatInAppHabitEdit(false); }} blur={false} dim={0.6} animate={false}>
          <div style={{ background: "var(--c-bg-active)", borderRadius: 18, padding: 24, width: "100%", maxWidth: isDesktop ? 580 : 420, maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(180,80,120,0.18)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "var(--c-text)" }}><Edit3 size={16} style={{ marginRight: 6 }} />Edit Habit</h3>
              <button onClick={() => { setAppHabitEdit(null); setShowNewCatInAppHabitEdit(false); }} style={{ background: "transparent", border: "none", fontSize: 20, cursor: "pointer", color: "var(--c-text-soft)" }}><X size={16} /></button>
            </div>
            {renderHabitForm(appHabitEdit.form, (fn) => setAppHabitEdit(p => ({ ...p, form: typeof fn === "function" ? fn(p.form) : fn })), saveAppHabitEdit, () => { setAppHabitEdit(null); setShowNewCatInAppHabitEdit(false); }, "Save changes", categories, { show: showNewCatInAppHabitEdit, setShow: setShowNewCatInAppHabitEdit, setCategories, savedColors, addSavedColor })}
          </div>
        </Modal>
      )}

      {/* WeekBlockPopoverPortal at APP ROOT — outside all CalendarTab stacking contexts */}
      {weekBlockPop && (() => {
        const eventColor = (ev) => {
          if (ev.categoryId) { const cat = categories.find(c => c.id === ev.categoryId); if (cat?.color) return cat.color; }
          return ev.color || DEFAULT_EVENT_COLOR;
        };
        const openEditModal = (item, type, occDate) => { setAppEditModal({ item, type, occDate, form: { ...item } }); setWeekBlockPop(null); };
        const openEditEvent = (ev, occDate) => { setAppEditModal({ item: ev, type: "event", occDate, form: { ...ev } }); setWeekBlockPop(null); };
        const openEditReminder = (r) => { setAppEditModal({ item: r, type: "reminder", form: { ...r } }); setWeekBlockPop(null); };
        const deleteTaskFromCal = (id) => {
          const item = tasks.find(t => t.id === id);
          if (item) softDeleteCalendarItems([{ id, type: "task", item }]);
          setTasks(p => p.filter(t => t.id !== id)); setWeekBlockPop(null);
        };
        const deleteEvent = (id) => {
          const item = calEvents.find(e => e.id === id);
          if (item) softDeleteCalendarItems([{ id, type: "event", item }]);
          setCalEvents(p => removeEventCascade(p, id)); setWeekBlockPop(null);
        };
        const deleteReminder = (id) => {
          const item = calReminders.find(r => r.id === id);
          if (item) softDeleteCalendarItems([{ id, type: "reminder", item }]);
          setCalReminders(p => p.filter(r => r.id !== id)); setWeekBlockPop(null);
        };
        const toggleTaskDoneFromCal = (id) => {
          const task = tasks.find(t => t.id === id);
          if (task) toggleTaskDoneOn(task, weekBlockPop.occDate, setTasks, setTaskOccurrenceOverrides);
        };
        return (
          <WeekBlockPopoverPortal
            key={weekBlockPop.item?.id}
            weekBlockPop={weekBlockPop} categories={categories} eventColor={eventColor}
            closeWeekBlockPop={closeWeekBlockPop} openEditModal={openEditModal}
            openEditEvent={openEditEvent} openEditReminder={openEditReminder}
            deleteTaskFromCal={deleteTaskFromCal} deleteEvent={deleteEvent}
            deleteReminder={deleteReminder} toggleTaskDoneFromCal={toggleTaskDoneFromCal}
            tasks={tasks} calEvents={calEvents} calReminders={calReminders}
            setTasks={setTasks} setCalEvents={setCalEvents} setCalReminders={setCalReminders}
            savedColors={savedColors} addSavedColor={addSavedColor}
            taskOccurrenceOverrides={taskOccurrenceOverrides} setTaskOccurrenceOverrides={setTaskOccurrenceOverrides}
            calEventOccurrenceOverrides={calEventOccurrenceOverrides} setCalEventOccurrenceOverrides={setCalEventOccurrenceOverrides}
          />
        );
      })()}
    </div>
  );
}

// ─── LIST VIEW COMPONENTS ─────────────────────────────────────────────────────
// ── List view sub-components (must be top-level so hooks work correctly) ──────

// ListEmptyState, ListDateHeader were confirmed dead code (zero usages) and were deleted.
// ListCategoryChip, ListItem live in ./features/calendar/ListView.jsx
// (imported above). The list-view detail panel is the shared
// ItemDetailPanel in ./features/calendar/ItemDetailPanel.jsx.

// ─── EVENT EDITOR HELPERS ─────────────────────────────────────────────────────
// Location type-ahead powered by OpenStreetMap (Nominatim) — free, no API key.
// LocationAutocomplete lives in ./components/pickers/LocationAutocomplete.jsx (imported above).

// Reminder offsets (minutes-before). Maps straight to Google Calendar reminders.

// ReminderPicker (and internal CustomReminderAdd) lives in ./components/pickers/ReminderPicker.jsx (imported above).

// Media attachments — photo / video / audio / camera / voice recording.
// Uploads to Cloudinary; stores normalized records on the event. Dormant (with a
// gentle hint) until Cloudinary env vars are set.
// AttachmentField lives in ./components/attachments/AttachmentField.jsx (imported above).
// Free for everyone — it used to be Premium-gated in the Planner.

// SettingsPanel (+ internal FaqItem) lives in ./features/settings/SettingsPanel.jsx (imported above).

// ─── PROFILE ──────────────────────────────────────────────────────────────────
// AboutClarityCard was dead code (zero real usages anywhere in src — only a
// comment mentioning it) — deleted rather than extracted.

// `section` controls which analytics this renders, so it can be embedded as a
// sub-page inside other tabs:
//   "habits" → habit tracker, completion target, bar graph + habits history
//   "focus"  → clock-in donut chart + logged sessions
// (The standalone Insights tab was retired; these now live behind buttons in
//  the Habits and Clock-In tabs.)
// ProfileTab lives in ./features/profile/ProfileTab.jsx (imported above).

// ─── CATEGORIES TAB ───────────────────────────────────────────────────────────

// CategoriesTab lives in ./features/categories/CategoriesTab (imported above).

// ─── SHARED TAB HEADER ────────────────────────────────────────────────────────
// TabHeader lives in ./components/TabHeader (imported above).

// ── Habit add/edit form — shared by HabitsTab and the in-place (Clock-In) editor ──
// renderHabitForm lives in ./features/habits/renderHabitForm.jsx (imported above).

// ─── HABITS ───────────────────────────────────────────────────────────────────
// HabitsTab lives in ./features/habits/HabitsTab.jsx (imported above).

// ── Link categories ──────────────────────────────────────────────────────────
// LINK_CATS lives in ./constants/misc (imported above).

// ── RichNotesEditor ───────────────────────────────────────────────────────────
// A contentEditable rich-text editor that stores HTML and provides a toolbar
// with Bold, Italic, Underline, Numbered List, Bullet List, Checkbox (subtask),
// and a link-insert button that pops a small URL panel.
// RichNotesEditor lives in ./components/RichNotesEditor.jsx (imported above).

// ── LinkEditor inline component ───────────────────────────────────────────────
// LinkEditor lives in ./components/LinkEditor (imported above).


// ─── TASKS ────────────────────────────────────────────────────────────────────
// TasksTab lives in ./features/TasksTab (imported above).


// ─── WEEK BLOCK POPOVER ────────────────────────────────────────────────────────
// WeekBlockPopoverPortal, ItemPanel live in ./features/calendar/CalendarExtras.jsx (imported above).

// ─── CALENDAR ─────────────────────────────────────────────────────────────────
// CalendarTab lives in ./features/calendar/CalendarTab.jsx (imported above).



// ─── FOCUS TAB ────────────────────────────────────────────────────────────────
// FocusTab lives in ./features/focus/FocusTab (imported above).

// ─── STATISTICS TAB ───────────────────────────────────────────────────────────
// StatisticsTab lives in ./features/stats/StatisticsTab (imported above).

// ─── ERROR BOUNDARY ───────────────────────────────────────────────────────────
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ fontFamily: "'Quicksand', sans-serif", minHeight: "100vh", background: "var(--c-bg-card)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div style={{ background: "var(--c-bg-card)", borderRadius: 20, padding: "28px 32px", border: "1.5px solid #f5d8ec", maxWidth: 420, textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🌸</div>
            <h2 style={{ color: "var(--c-text-accent)", marginBottom: 8 }}>Oops, something went wrong</h2>
            <p style={{ color: "var(--c-text-mid)", fontSize: 14, marginBottom: 20 }}>Don't worry. Your data is safe in localStorage. Try clearing the app cache or refreshing.</p>
            <button onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              style={{ background: "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))", color: "var(--c-on-primary)", border: "none", borderRadius: 12, padding: "9px 22px", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              Reload app
            </button>
            <details style={{ marginTop: 16, textAlign: "left" }}>
              <summary style={{ fontSize: 11, color: "var(--c-text-soft)", cursor: "pointer" }}>Error details</summary>
              <pre style={{ fontSize: 10, color: "#b08090", marginTop: 6, whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{String(this.state.error)}</pre>
            </details>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// ─── JOURNAL TAB ─────────────────────────────────────────────────────────────
// MOOD_OPTIONS lives in ./constants/moodOptions (imported above).

// CARD_ACCENTS lives in ./constants/palettes (imported above).
// accentFor lives in ./utils/accentFor (imported above).

// AlignIcon, StickerMaker, CropModal, frameBoxAspect, defaultCropFor, frameClip, StickerLayer, JournalTab live in ./features/journal/JournalTab.jsx (imported above).

// ─── WRAPPED EXPORT ───────────────────────────────────────────────────────────
export function WrappedClarityApp() {
  return (
    <ErrorBoundary>
      <AuthGate>
        <ClarityApp />
      </AuthGate>
    </ErrorBoundary>
  );
}
